/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Api
 * Ayrshire Hub API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptOrderStoreInviteBody,
  ActivityHistoryPoint,
  AdminCreateOrderCategoryBody,
  AdminDeleteOrderCategory200,
  AdminGetOrderCategories200,
  AdminGetOrderStores200,
  AdminPendingResponse,
  AdminRefundOrder200,
  AdminRefundOrder202,
  AdminRefundOrderBody,
  AdminStats,
  AdminUpdateOrderCategoryBody,
  AdminUpdateOrderStoreBody,
  AgencyObject,
  ApplyToBeDriverBody,
  ApproveInput,
  AuthResponse,
  Business,
  BusinessInput,
  BusinessListResponse,
  ChatMessage,
  CheckoutPendingResponse,
  CollectExternalRunJobBody,
  CommunityComment,
  CommunityPost,
  Conversation,
  ConversationListResponse,
  CreateCommentInput,
  CreateMenuItemInput,
  CreateMenuSectionInput,
  CreateOrderCheckoutSession200,
  CreateOrderCheckoutSession409,
  CreateOrderCheckoutSessionBody,
  CreateOrderPaymentIntent200,
  CreateOrderPaymentIntent409,
  CreateOrderPaymentIntentBody,
  CreateOrderStoreInput,
  CreatePostInput,
  CreateStoreDebtCardPayment200,
  Deal,
  DealInput,
  DealListResponse,
  DecideAdminDriverWithdrawal200,
  DecideAdminDriverWithdrawalBody,
  DeleteMenuItem200,
  DeleteMenuSection200,
  DriverAssignment,
  DriverMessage,
  DriverProfile,
  ErrorResponse,
  Event,
  EventInput,
  EventListResponse,
  FeatureInput,
  FinalizeUploadBody,
  FinalizeUploadResponse,
  FreeItem,
  FreeItemInput,
  FreeItemListResponse,
  GetAdminBankStatementComparison200,
  GetAdminBankStatements200,
  GetAdminBankStatementsParams,
  GetAdminDealRedemptions200,
  GetAdminDealRedemptionsParams,
  GetAdminFinanceRecovery200,
  GetAdminGrowthHistoryParams,
  GetAdminKindnessOverview200,
  GetAdminPaymentObserverParams,
  GetAdminStoreStripeReporting200,
  GetAdminStoreStripeReportingParams,
  GetAdminTransactions200,
  GetAdminTransactionsParams,
  GetAdminUsersParams,
  GetAgencyAcceptanceCopyParams,
  GetAgencyAgreementParams,
  GetAgencyReconciliationParams,
  GetAgencyStatusParams,
  GetBusinessesParams,
  GetDealsParams,
  GetDriverEarnings200,
  GetDriverRatings200,
  GetDriverSearchRadius200,
  GetEventsParams,
  GetExternalRunJobHistory200,
  GetHomeDataParams,
  GetJobsParams,
  GetMenuSections200,
  GetMyOrderStores200,
  GetMyOrders200,
  GetMyTransactions200,
  GetNewsParams,
  GetOrderCategories200,
  GetOrderDriver200,
  GetOrderStoreStaff200,
  GetOrderStores200,
  GetOrderStoresParams,
  GetReviewsParams,
  GetSavedItemsParams,
  GetStoreDebtPaymentBalance200,
  GetStoreFinanceReport200,
  GetStoreFinanceReportParams,
  GetStoreOrders200,
  GetStripeConnectUrl200,
  GetStripeConnectUrlParams,
  GetTradeProfilesParams,
  GetTransportDeparturesParams,
  GrowthHistoryResponse,
  HealthStatus,
  HomeData,
  ImportAdminBankStatement200,
  ImportAdminBankStatementBody,
  InviteOrderStoreStaffBody,
  Job,
  JobInput,
  JobListResponse,
  JobVacancy,
  JobVacancyInput,
  JobVacancyListResponse,
  LeadPurchase,
  LeadPurchaseListResponse,
  LikeResponse,
  ListCommunityPostsParams,
  ListDriverApplications200,
  ListDriverApplicationsParams,
  ListDriverJobs200,
  ListDriverJobsParams,
  ListDriverMessages200,
  ListFreeItemsParams,
  ListJobVacanciesParams,
  ListSeekerProfilesParams,
  ListTransportStations200,
  LoginInput,
  LoginLog,
  MessageImageClaim,
  MessageListResponse,
  MessageResponse,
  NewsArticle,
  NewsInput,
  NewsListResponse,
  NewsSubmissionInput,
  Notification,
  NotificationListResponse,
  Order,
  OrderCategory,
  OrderMenuItem,
  OrderMenuSection,
  OrderStore,
  OrderStoreWithMenu,
  OrderWithItems,
  PaymentObserverReport,
  PlaceOrderInput,
  PrinterCommandBatch,
  PrinterCommandRequest,
  PrinterCommandRequested,
  PrinterCommandResult,
  PrinterCredentials,
  PrinterDeviceList,
  PrinterHeartbeat,
  PrinterManagementSnapshot,
  PrinterRegistration,
  PrinterResultAccepted,
  PushNotificationInput,
  PushNotificationResult,
  PushToken,
  PushTokenInput,
  RedeemDeal200,
  RejectDriverBody,
  ReleaseDriverJob409,
  ReleaseDriverJobBody,
  ReleaseExternalRunJob200,
  ReleaseExternalRunJob409,
  ReleaseExternalRunJobBody,
  RemoveOrderStoreStaff200,
  RequestUploadUrlBody,
  RequestUploadUrlResponse,
  Review,
  ReviewInput,
  ReviewListResponse,
  SaveItemInput,
  SavedItem,
  SavedItemListResponse,
  SeekerProfile,
  SeekerProfileInput,
  SeekerProfileListResponse,
  SendDriverMessageBody,
  SendMessageInput,
  SignupInput,
  SponsorFreeItemBody,
  StoreStaff,
  SuspendUserBody,
  TradeProfile,
  TradeProfileInput,
  TradeProfileListResponse,
  TranslateMenu200,
  UnlockLeadBody,
  UpdateDriverJobStatusBody,
  UpdateDriverLocation200,
  UpdateDriverLocationBody,
  UpdateDriverProfileBody,
  UpdateDriverSearchRadius200,
  UpdateDriverSearchRadiusBody,
  UpdateOrderStatusBody,
  UpdateOrderStoreStaffBody,
  UpdateProfileInput,
  UpdateSeekerAvailabilityBody,
  UpdateStoreDriverModeBody,
  UploadOrderStoreCoverAnimation200,
  User,
  UserListResponse,
  VerifyEmailParams,
  VerifyInput,
  VerifyStoreDebtCardPayment200
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getReleaseExternalRunJobUrl = (id: number,) => {




  return `/api/external-runs/${id}/release`
}

/**
 * Requires the assigned driver. The whole job returns to dispatch. After 15 minutes the server requires explicit acceptance of the quoted 500-pence fine. Collected jobs, completed drops and handled cash cannot be released.
 * @summary Release an assigned run before pickup
 */
export const releaseExternalRunJob = async (id: number,
    releaseExternalRunJobBody?: ReleaseExternalRunJobBody, options?: RequestInit): Promise<ReleaseExternalRunJob200> => {

  return customFetch<ReleaseExternalRunJob200>(getReleaseExternalRunJobUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(releaseExternalRunJobBody)
  }
);}




export const getReleaseExternalRunJobMutationOptions = <TError = ErrorType<void | ReleaseExternalRunJob409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releaseExternalRunJob>>, TError,{id: number;data?: BodyType<ReleaseExternalRunJobBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof releaseExternalRunJob>>, TError,{id: number;data?: BodyType<ReleaseExternalRunJobBody>}, TContext> => {

const mutationKey = ['releaseExternalRunJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof releaseExternalRunJob>>, {id: number;data?: BodyType<ReleaseExternalRunJobBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  releaseExternalRunJob(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReleaseExternalRunJobMutationResult = NonNullable<Awaited<ReturnType<typeof releaseExternalRunJob>>>
    export type ReleaseExternalRunJobMutationBody = BodyType<ReleaseExternalRunJobBody> | undefined
    export type ReleaseExternalRunJobMutationError = ErrorType<void | ReleaseExternalRunJob409>

    /**
 * @summary Release an assigned run before pickup
 */
export const useReleaseExternalRunJob = <TError = ErrorType<void | ReleaseExternalRunJob409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releaseExternalRunJob>>, TError,{id: number;data?: BodyType<ReleaseExternalRunJobBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof releaseExternalRunJob>>,
        TError,
        {id: number;data?: BodyType<ReleaseExternalRunJobBody>},
        TContext
      > => {
      return useMutation(getReleaseExternalRunJobMutationOptions(options));
    }

export const getCollectExternalRunJobUrl = (id: number,) => {




  return `/api/external-runs/${id}/pickup`
}

/**
 * @summary Mark the whole job picked up from the shop
 */
export const collectExternalRunJob = async (id: number,
    collectExternalRunJobBody?: CollectExternalRunJobBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCollectExternalRunJobUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(collectExternalRunJobBody)
  }
);}




export const getCollectExternalRunJobMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof collectExternalRunJob>>, TError,{id: number;data?: BodyType<CollectExternalRunJobBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof collectExternalRunJob>>, TError,{id: number;data?: BodyType<CollectExternalRunJobBody>}, TContext> => {

const mutationKey = ['collectExternalRunJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof collectExternalRunJob>>, {id: number;data?: BodyType<CollectExternalRunJobBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  collectExternalRunJob(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CollectExternalRunJobMutationResult = NonNullable<Awaited<ReturnType<typeof collectExternalRunJob>>>
    export type CollectExternalRunJobMutationBody = BodyType<CollectExternalRunJobBody> | undefined
    export type CollectExternalRunJobMutationError = ErrorType<void>

    /**
 * @summary Mark the whole job picked up from the shop
 */
export const useCollectExternalRunJob = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof collectExternalRunJob>>, TError,{id: number;data?: BodyType<CollectExternalRunJobBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof collectExternalRunJob>>,
        TError,
        {id: number;data?: BodyType<CollectExternalRunJobBody>},
        TContext
      > => {
      return useMutation(getCollectExternalRunJobMutationOptions(options));
    }

export const getRedispatchExternalRunJobUrl = (id: number,) => {




  return `/api/external-runs/${id}/redispatch`
}

/**
 * @summary Shop owner, accepted on-shift staff or admin can find another driver before pickup
 */
export const redispatchExternalRunJob = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRedispatchExternalRunJobUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRedispatchExternalRunJobMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redispatchExternalRunJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof redispatchExternalRunJob>>, TError,{id: number}, TContext> => {

const mutationKey = ['redispatchExternalRunJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redispatchExternalRunJob>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  redispatchExternalRunJob(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedispatchExternalRunJobMutationResult = NonNullable<Awaited<ReturnType<typeof redispatchExternalRunJob>>>

    export type RedispatchExternalRunJobMutationError = ErrorType<void>

    /**
 * @summary Shop owner, accepted on-shift staff or admin can find another driver before pickup
 */
export const useRedispatchExternalRunJob = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redispatchExternalRunJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof redispatchExternalRunJob>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRedispatchExternalRunJobMutationOptions(options));
    }

export const getGetExternalRunJobHistoryUrl = (id: number,) => {




  return `/api/external-runs/${id}/history`
}

/**
 * @summary Read the job audit history as its shop, admin or assigned driver
 */
export const getExternalRunJobHistory = async (id: number, options?: RequestInit): Promise<GetExternalRunJobHistory200> => {

  return customFetch<GetExternalRunJobHistory200>(getGetExternalRunJobHistoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExternalRunJobHistoryQueryKey = (id: number,) => {
    return [
    `/api/external-runs/${id}/history`
    ] as const;
    }


export const getGetExternalRunJobHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getExternalRunJobHistory>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExternalRunJobHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalRunJobHistoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalRunJobHistory>>> = ({ signal }) => getExternalRunJobHistory(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalRunJobHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExternalRunJobHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalRunJobHistory>>>
export type GetExternalRunJobHistoryQueryError = ErrorType<void>


/**
 * @summary Read the job audit history as its shop, admin or assigned driver
 */

export function useGetExternalRunJobHistory<TData = Awaited<ReturnType<typeof getExternalRunJobHistory>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExternalRunJobHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExternalRunJobHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicAgencyShopDisclosureUrl = (storeId: number,) => {




  return `/api/agency/public/shops/${storeId}/disclosure`
}

export const getPublicAgencyShopDisclosure = async (storeId: number, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetPublicAgencyShopDisclosureUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicAgencyShopDisclosureQueryKey = (storeId: number,) => {
    return [
    `/api/agency/public/shops/${storeId}/disclosure`
    ] as const;
    }


export const getGetPublicAgencyShopDisclosureQueryOptions = <TData = Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError = ErrorType<unknown>>(storeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicAgencyShopDisclosureQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>> = ({ signal }) => getPublicAgencyShopDisclosure(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicAgencyShopDisclosureQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>>
export type GetPublicAgencyShopDisclosureQueryError = ErrorType<unknown>



export function useGetPublicAgencyShopDisclosure<TData = Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError = ErrorType<unknown>>(
 storeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicAgencyShopDisclosureQueryOptions(storeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAgencyAcceptanceCopyUrl = (acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agency/acceptances/${acceptanceId}/copy?${stringifiedParams}` : `/api/agency/acceptances/${acceptanceId}/copy`
}

export const getAgencyAcceptanceCopy = async (acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams, options?: RequestInit): Promise<Blob | AgencyObject> => {

  return customFetch<Blob | AgencyObject>(getGetAgencyAcceptanceCopyUrl(acceptanceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyAcceptanceCopyQueryKey = (acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams,) => {
    return [
    `/api/agency/acceptances/${acceptanceId}/copy`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyAcceptanceCopyQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError = ErrorType<unknown>>(acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyAcceptanceCopyQueryKey(acceptanceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>> = ({ signal }) => getAgencyAcceptanceCopy(acceptanceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: acceptanceId !== null && acceptanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyAcceptanceCopyQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>>
export type GetAgencyAcceptanceCopyQueryError = ErrorType<unknown>



export function useGetAgencyAcceptanceCopy<TData = Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError = ErrorType<unknown>>(
 acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyAcceptanceCopyQueryOptions(acceptanceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicAgencyCustomerTermsUrl = () => {




  return `/api/agency/public/customer-terms`
}

export const getPublicAgencyCustomerTerms = async ( options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetPublicAgencyCustomerTermsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicAgencyCustomerTermsQueryKey = () => {
    return [
    `/api/agency/public/customer-terms`
    ] as const;
    }


export const getGetPublicAgencyCustomerTermsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicAgencyCustomerTermsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>> = ({ signal }) => getPublicAgencyCustomerTerms({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicAgencyCustomerTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>>
export type GetPublicAgencyCustomerTermsQueryError = ErrorType<unknown>



export function useGetPublicAgencyCustomerTerms<TData = Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicAgencyCustomerTermsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAgencyComplianceUrl = () => {




  return `/api/admin/agency/compliance`
}

export const getAgencyCompliance = async ( options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetAgencyComplianceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyComplianceQueryKey = () => {
    return [
    `/api/admin/agency/compliance`
    ] as const;
    }


export const getGetAgencyComplianceQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyCompliance>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyCompliance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyComplianceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyCompliance>>> = ({ signal }) => getAgencyCompliance({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyCompliance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyComplianceQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyCompliance>>>
export type GetAgencyComplianceQueryError = ErrorType<unknown>



export function useGetAgencyCompliance<TData = Awaited<ReturnType<typeof getAgencyCompliance>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyCompliance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyComplianceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAgencyVersionUrl = () => {




  return `/api/admin/agency/versions`
}

export const createAgencyVersion = async (agencyObject: AgencyObject, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getCreateAgencyVersionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(agencyObject)
  }
);}




export const getCreateAgencyVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgencyVersion>>, TError,{data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgencyVersion>>, TError,{data: BodyType<AgencyObject>}, TContext> => {

const mutationKey = ['createAgencyVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgencyVersion>>, {data: BodyType<AgencyObject>}> = (props) => {
          const {data} = props ?? {};

          return  createAgencyVersion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAgencyVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createAgencyVersion>>>
    export type CreateAgencyVersionMutationBody = BodyType<AgencyObject>
    export type CreateAgencyVersionMutationError = ErrorType<unknown>

    export const useCreateAgencyVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgencyVersion>>, TError,{data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAgencyVersion>>,
        TError,
        {data: BodyType<AgencyObject>},
        TContext
      > => {
      return useMutation(getCreateAgencyVersionMutationOptions(options));
    }

export const getRecordAgencyReviewUrl = (id: number,) => {




  return `/api/admin/agency/versions/${id}/reviews`
}

export const recordAgencyReview = async (id: number,
    agencyObject: AgencyObject, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getRecordAgencyReviewUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(agencyObject)
  }
);}




export const getRecordAgencyReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAgencyReview>>, TError,{id: number;data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordAgencyReview>>, TError,{id: number;data: BodyType<AgencyObject>}, TContext> => {

const mutationKey = ['recordAgencyReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordAgencyReview>>, {id: number;data: BodyType<AgencyObject>}> = (props) => {
          const {id,data} = props ?? {};

          return  recordAgencyReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordAgencyReviewMutationResult = NonNullable<Awaited<ReturnType<typeof recordAgencyReview>>>
    export type RecordAgencyReviewMutationBody = BodyType<AgencyObject>
    export type RecordAgencyReviewMutationError = ErrorType<unknown>

    export const useRecordAgencyReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAgencyReview>>, TError,{id: number;data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordAgencyReview>>,
        TError,
        {id: number;data: BodyType<AgencyObject>},
        TContext
      > => {
      return useMutation(getRecordAgencyReviewMutationOptions(options));
    }

export const getGetAgencyStatusUrl = (params?: GetAgencyStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agency/status?${stringifiedParams}` : `/api/agency/status`
}

export const getAgencyStatus = async (params?: GetAgencyStatusParams, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetAgencyStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyStatusQueryKey = (params?: GetAgencyStatusParams,) => {
    return [
    `/api/agency/status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyStatus>>, TError = ErrorType<unknown>>(params?: GetAgencyStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyStatus>>> = ({ signal }) => getAgencyStatus(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyStatus>>>
export type GetAgencyStatusQueryError = ErrorType<unknown>



export function useGetAgencyStatus<TData = Awaited<ReturnType<typeof getAgencyStatus>>, TError = ErrorType<unknown>>(
 params?: GetAgencyStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAgencyAgreementUrl = (releaseId: number,
    params?: GetAgencyAgreementParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agency/agreements/${releaseId}?${stringifiedParams}` : `/api/agency/agreements/${releaseId}`
}

export const getAgencyAgreement = async (releaseId: number,
    params?: GetAgencyAgreementParams, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetAgencyAgreementUrl(releaseId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyAgreementQueryKey = (releaseId: number,
    params?: GetAgencyAgreementParams,) => {
    return [
    `/api/agency/agreements/${releaseId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyAgreementQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyAgreement>>, TError = ErrorType<unknown>>(releaseId: number,
    params?: GetAgencyAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyAgreement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyAgreementQueryKey(releaseId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyAgreement>>> = ({ signal }) => getAgencyAgreement(releaseId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: releaseId !== null && releaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyAgreement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyAgreementQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyAgreement>>>
export type GetAgencyAgreementQueryError = ErrorType<unknown>



export function useGetAgencyAgreement<TData = Awaited<ReturnType<typeof getAgencyAgreement>>, TError = ErrorType<unknown>>(
 releaseId: number,
    params?: GetAgencyAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyAgreement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyAgreementQueryOptions(releaseId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAcceptAgencyAgreementUrl = (releaseId: number,) => {




  return `/api/agency/agreements/${releaseId}/accept`
}

export const acceptAgencyAgreement = async (releaseId: number,
    agencyObject: AgencyObject, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getAcceptAgencyAgreementUrl(releaseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(agencyObject)
  }
);}




export const getAcceptAgencyAgreementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptAgencyAgreement>>, TError,{releaseId: number;data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptAgencyAgreement>>, TError,{releaseId: number;data: BodyType<AgencyObject>}, TContext> => {

const mutationKey = ['acceptAgencyAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptAgencyAgreement>>, {releaseId: number;data: BodyType<AgencyObject>}> = (props) => {
          const {releaseId,data} = props ?? {};

          return  acceptAgencyAgreement(releaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptAgencyAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof acceptAgencyAgreement>>>
    export type AcceptAgencyAgreementMutationBody = BodyType<AgencyObject>
    export type AcceptAgencyAgreementMutationError = ErrorType<unknown>

    export const useAcceptAgencyAgreement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptAgencyAgreement>>, TError,{releaseId: number;data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptAgencyAgreement>>,
        TError,
        {releaseId: number;data: BodyType<AgencyObject>},
        TContext
      > => {
      return useMutation(getAcceptAgencyAgreementMutationOptions(options));
    }

export const getGetAgencyReconciliationUrl = (orderId: number,
    params?: GetAgencyReconciliationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/agency/reconciliation/${orderId}?${stringifiedParams}` : `/api/admin/agency/reconciliation/${orderId}`
}

export const getAgencyReconciliation = async (orderId: number,
    params?: GetAgencyReconciliationParams, options?: RequestInit): Promise<AgencyObject | string> => {

  return customFetch<AgencyObject | string>(getGetAgencyReconciliationUrl(orderId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyReconciliationQueryKey = (orderId: number,
    params?: GetAgencyReconciliationParams,) => {
    return [
    `/api/admin/agency/reconciliation/${orderId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyReconciliation>>, TError = ErrorType<unknown>>(orderId: number,
    params?: GetAgencyReconciliationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyReconciliationQueryKey(orderId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyReconciliation>>> = ({ signal }) => getAgencyReconciliation(orderId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyReconciliation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyReconciliation>>>
export type GetAgencyReconciliationQueryError = ErrorType<unknown>



export function useGetAgencyReconciliation<TData = Awaited<ReturnType<typeof getAgencyReconciliation>>, TError = ErrorType<unknown>>(
 orderId: number,
    params?: GetAgencyReconciliationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyReconciliationQueryOptions(orderId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetShopAgencyReconciliationUrl = (storeId: number,
    orderId: number,) => {




  return `/api/agency/shops/${storeId}/reconciliation/${orderId}`
}

export const getShopAgencyReconciliation = async (storeId: number,
    orderId: number, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetShopAgencyReconciliationUrl(storeId,orderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopAgencyReconciliationQueryKey = (storeId: number,
    orderId: number,) => {
    return [
    `/api/agency/shops/${storeId}/reconciliation/${orderId}`
    ] as const;
    }


export const getGetShopAgencyReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError = ErrorType<unknown>>(storeId: number,
    orderId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopAgencyReconciliationQueryKey(storeId,orderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopAgencyReconciliation>>> = ({ signal }) => getShopAgencyReconciliation(storeId,orderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: storeId !== null && storeId !== undefined && orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopAgencyReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof getShopAgencyReconciliation>>>
export type GetShopAgencyReconciliationQueryError = ErrorType<unknown>



export function useGetShopAgencyReconciliation<TData = Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError = ErrorType<unknown>>(
 storeId: number,
    orderId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopAgencyReconciliationQueryOptions(storeId,orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRegisterPrinterPadUrl = () => {




  return `/api/printer-pads/register`
}

/**
 * @summary registerPrinterPad
 */
export const registerPrinterPad = async (printerRegistration: PrinterRegistration, options?: RequestInit): Promise<PrinterCredentials> => {

  return customFetch<PrinterCredentials>(getRegisterPrinterPadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(printerRegistration)
  }
);}




export const getRegisterPrinterPadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPrinterPad>>, TError,{data: BodyType<PrinterRegistration>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerPrinterPad>>, TError,{data: BodyType<PrinterRegistration>}, TContext> => {

const mutationKey = ['registerPrinterPad'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerPrinterPad>>, {data: BodyType<PrinterRegistration>}> = (props) => {
          const {data} = props ?? {};

          return  registerPrinterPad(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterPrinterPadMutationResult = NonNullable<Awaited<ReturnType<typeof registerPrinterPad>>>
    export type RegisterPrinterPadMutationBody = BodyType<PrinterRegistration>
    export type RegisterPrinterPadMutationError = ErrorType<void>

    /**
 * @summary registerPrinterPad
 */
export const useRegisterPrinterPad = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPrinterPad>>, TError,{data: BodyType<PrinterRegistration>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerPrinterPad>>,
        TError,
        {data: BodyType<PrinterRegistration>},
        TContext
      > => {
      return useMutation(getRegisterPrinterPadMutationOptions(options));
    }

export const getReportPrinterPadHealthUrl = (deviceId: string,) => {




  return `/api/printer-pads/${deviceId}/heartbeat`
}

/**
 * @summary reportPrinterPadHealth
 */
export const reportPrinterPadHealth = async (deviceId: string,
    printerHeartbeat: PrinterHeartbeat, options?: RequestInit): Promise<PrinterCommandBatch> => {

  return customFetch<PrinterCommandBatch>(getReportPrinterPadHealthUrl(deviceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(printerHeartbeat)
  }
);}




export const getReportPrinterPadHealthMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportPrinterPadHealth>>, TError,{deviceId: string;data: BodyType<PrinterHeartbeat>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reportPrinterPadHealth>>, TError,{deviceId: string;data: BodyType<PrinterHeartbeat>}, TContext> => {

const mutationKey = ['reportPrinterPadHealth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportPrinterPadHealth>>, {deviceId: string;data: BodyType<PrinterHeartbeat>}> = (props) => {
          const {deviceId,data} = props ?? {};

          return  reportPrinterPadHealth(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportPrinterPadHealthMutationResult = NonNullable<Awaited<ReturnType<typeof reportPrinterPadHealth>>>
    export type ReportPrinterPadHealthMutationBody = BodyType<PrinterHeartbeat>
    export type ReportPrinterPadHealthMutationError = ErrorType<void>

    /**
 * @summary reportPrinterPadHealth
 */
export const useReportPrinterPadHealth = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportPrinterPadHealth>>, TError,{deviceId: string;data: BodyType<PrinterHeartbeat>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reportPrinterPadHealth>>,
        TError,
        {deviceId: string;data: BodyType<PrinterHeartbeat>},
        TContext
      > => {
      return useMutation(getReportPrinterPadHealthMutationOptions(options));
    }

export const getReportPrinterCommandResultUrl = (deviceId: string,) => {




  return `/api/printer-pads/${deviceId}/result`
}

/**
 * @summary reportPrinterCommandResult
 */
export const reportPrinterCommandResult = async (deviceId: string,
    printerCommandResult: PrinterCommandResult, options?: RequestInit): Promise<PrinterResultAccepted> => {

  return customFetch<PrinterResultAccepted>(getReportPrinterCommandResultUrl(deviceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(printerCommandResult)
  }
);}




export const getReportPrinterCommandResultMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportPrinterCommandResult>>, TError,{deviceId: string;data: BodyType<PrinterCommandResult>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reportPrinterCommandResult>>, TError,{deviceId: string;data: BodyType<PrinterCommandResult>}, TContext> => {

const mutationKey = ['reportPrinterCommandResult'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportPrinterCommandResult>>, {deviceId: string;data: BodyType<PrinterCommandResult>}> = (props) => {
          const {deviceId,data} = props ?? {};

          return  reportPrinterCommandResult(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportPrinterCommandResultMutationResult = NonNullable<Awaited<ReturnType<typeof reportPrinterCommandResult>>>
    export type ReportPrinterCommandResultMutationBody = BodyType<PrinterCommandResult>
    export type ReportPrinterCommandResultMutationError = ErrorType<void>

    /**
 * @summary reportPrinterCommandResult
 */
export const useReportPrinterCommandResult = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportPrinterCommandResult>>, TError,{deviceId: string;data: BodyType<PrinterCommandResult>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reportPrinterCommandResult>>,
        TError,
        {deviceId: string;data: BodyType<PrinterCommandResult>},
        TContext
      > => {
      return useMutation(getReportPrinterCommandResultMutationOptions(options));
    }

export const getGetAdminPrinterHealthUrl = () => {




  return `/api/admin/printer-management`
}

/**
 * @summary getAdminPrinterHealth
 */
export const getAdminPrinterHealth = async ( options?: RequestInit): Promise<PrinterDeviceList> => {

  return customFetch<PrinterDeviceList>(getGetAdminPrinterHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminPrinterHealthQueryKey = () => {
    return [
    `/api/admin/printer-management`
    ] as const;
    }


export const getGetAdminPrinterHealthQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPrinterHealth>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPrinterHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPrinterHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPrinterHealth>>> = ({ signal }) => getAdminPrinterHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPrinterHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminPrinterHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPrinterHealth>>>
export type GetAdminPrinterHealthQueryError = ErrorType<void>


/**
 * @summary getAdminPrinterHealth
 */

export function useGetAdminPrinterHealth<TData = Awaited<ReturnType<typeof getAdminPrinterHealth>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPrinterHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminPrinterHealthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminStorePrintersUrl = (storeId: number,) => {




  return `/api/admin/order-stores/${storeId}/printers`
}

/**
 * @summary getAdminStorePrinters
 */
export const getAdminStorePrinters = async (storeId: number, options?: RequestInit): Promise<PrinterManagementSnapshot> => {

  return customFetch<PrinterManagementSnapshot>(getGetAdminStorePrintersUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStorePrintersQueryKey = (storeId: number,) => {
    return [
    `/api/admin/order-stores/${storeId}/printers`
    ] as const;
    }


export const getGetAdminStorePrintersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStorePrinters>>, TError = ErrorType<void>>(storeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStorePrinters>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStorePrintersQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStorePrinters>>> = ({ signal }) => getAdminStorePrinters(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStorePrinters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminStorePrintersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStorePrinters>>>
export type GetAdminStorePrintersQueryError = ErrorType<void>


/**
 * @summary getAdminStorePrinters
 */

export function useGetAdminStorePrinters<TData = Awaited<ReturnType<typeof getAdminStorePrinters>>, TError = ErrorType<void>>(
 storeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStorePrinters>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminStorePrintersQueryOptions(storeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestPrinterCommandUrl = (storeId: number,
    deviceId: string,) => {




  return `/api/admin/order-stores/${storeId}/printers/${deviceId}/commands`
}

/**
 * @summary requestPrinterCommand
 */
export const requestPrinterCommand = async (storeId: number,
    deviceId: string,
    printerCommandRequest: PrinterCommandRequest, options?: RequestInit): Promise<PrinterCommandRequested> => {

  return customFetch<PrinterCommandRequested>(getRequestPrinterCommandUrl(storeId,deviceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(printerCommandRequest)
  }
);}




export const getRequestPrinterCommandMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPrinterCommand>>, TError,{storeId: number;deviceId: string;data: BodyType<PrinterCommandRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPrinterCommand>>, TError,{storeId: number;deviceId: string;data: BodyType<PrinterCommandRequest>}, TContext> => {

const mutationKey = ['requestPrinterCommand'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPrinterCommand>>, {storeId: number;deviceId: string;data: BodyType<PrinterCommandRequest>}> = (props) => {
          const {storeId,deviceId,data} = props ?? {};

          return  requestPrinterCommand(storeId,deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPrinterCommandMutationResult = NonNullable<Awaited<ReturnType<typeof requestPrinterCommand>>>
    export type RequestPrinterCommandMutationBody = BodyType<PrinterCommandRequest>
    export type RequestPrinterCommandMutationError = ErrorType<void>

    /**
 * @summary requestPrinterCommand
 */
export const useRequestPrinterCommand = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPrinterCommand>>, TError,{storeId: number;deviceId: string;data: BodyType<PrinterCommandRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestPrinterCommand>>,
        TError,
        {storeId: number;deviceId: string;data: BodyType<PrinterCommandRequest>},
        TContext
      > => {
      return useMutation(getRequestPrinterCommandMutationOptions(options));
    }

export const getGetAdminPaymentObserverUrl = (params?: GetAdminPaymentObserverParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/payment-observer?${stringifiedParams}` : `/api/admin/payment-observer`
}

/**
 * @summary Read the independent payment observer log
 */
export const getAdminPaymentObserver = async (params?: GetAdminPaymentObserverParams, options?: RequestInit): Promise<PaymentObserverReport> => {

  return customFetch<PaymentObserverReport>(getGetAdminPaymentObserverUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminPaymentObserverQueryKey = (params?: GetAdminPaymentObserverParams,) => {
    return [
    `/api/admin/payment-observer`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminPaymentObserverQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPaymentObserver>>, TError = ErrorType<void>>(params?: GetAdminPaymentObserverParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPaymentObserver>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPaymentObserverQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPaymentObserver>>> = ({ signal }) => getAdminPaymentObserver(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPaymentObserver>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminPaymentObserverQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPaymentObserver>>>
export type GetAdminPaymentObserverQueryError = ErrorType<void>


/**
 * @summary Read the independent payment observer log
 */

export function useGetAdminPaymentObserver<TData = Awaited<ReturnType<typeof getAdminPaymentObserver>>, TError = ErrorType<void>>(
 params?: GetAdminPaymentObserverParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPaymentObserver>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminPaymentObserverQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSignupUrl = () => {




  return `/api/auth/signup`
}

/**
 * @summary Create a new account
 */
export const signup = async (signupInput: SignupInput, options?: RequestInit): Promise<AuthResponse> => {

  return customFetch<AuthResponse>(getSignupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signupInput)
  }
);}




export const getSignupMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: BodyType<SignupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: BodyType<SignupInput>}, TContext> => {

const mutationKey = ['signup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signup>>, {data: BodyType<SignupInput>}> = (props) => {
          const {data} = props ?? {};

          return  signup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupMutationResult = NonNullable<Awaited<ReturnType<typeof signup>>>
    export type SignupMutationBody = BodyType<SignupInput>
    export type SignupMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a new account
 */
export const useSignup = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: BodyType<SignupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof signup>>,
        TError,
        {data: BodyType<SignupInput>},
        TContext
      > => {
      return useMutation(getSignupMutationOptions(options));
    }

export const getLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Log in
 */
export const login = async (loginInput: LoginInput, options?: RequestInit): Promise<AuthResponse> => {

  return customFetch<AuthResponse>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginInput)
  }
);}




export const getLoginMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: BodyType<LoginInput>}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = BodyType<LoginInput>
    export type LoginMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Log in
 */
export const useLogin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: BodyType<LoginInput>},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options));
    }

export const getUpdateProfileUrl = () => {




  return `/api/auth/profile`
}

/**
 * @summary Update current user's profile
 */
export const updateProfile = async (updateProfileInput: UpdateProfileInput, options?: RequestInit): Promise<User> => {

  return customFetch<User>(getUpdateProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProfileInput)
  }
);}




export const getUpdateProfileMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: BodyType<UpdateProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: BodyType<UpdateProfileInput>}, TContext> => {

const mutationKey = ['updateProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {data: BodyType<UpdateProfileInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = BodyType<UpdateProfileInput>
    export type UpdateProfileMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update current user's profile
 */
export const useUpdateProfile = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: BodyType<UpdateProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {data: BodyType<UpdateProfileInput>},
        TContext
      > => {
      return useMutation(getUpdateProfileMutationOptions(options));
    }

export const getLogoutUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary Log out
 */
export const logout = async ( options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = ErrorType<unknown>

    /**
 * @summary Log out
 */
export const useLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options));
    }

export const getGetMeUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Get current user
 */
export const getMe = async ( options?: RequestInit): Promise<User> => {

  return customFetch<User>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get current user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteMyAccountUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Delete the authenticated user's account and all their data
 */
export const deleteMyAccount = async ( options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteMyAccountUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMyAccountMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMyAccount>>, TError,void, TContext> => {

const mutationKey = ['deleteMyAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMyAccount>>, void> = () => {


          return  deleteMyAccount(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMyAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMyAccount>>>

    export type DeleteMyAccountMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete the authenticated user's account and all their data
 */
export const useDeleteMyAccount = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMyAccount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteMyAccountMutationOptions(options));
    }

export const getVerifyEmailUrl = (params: VerifyEmailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auth/verify-email?${stringifiedParams}` : `/api/auth/verify-email`
}

/**
 * @summary Verify email address via token
 */
export const verifyEmail = async (params: VerifyEmailParams, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getVerifyEmailUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVerifyEmailQueryKey = (params?: VerifyEmailParams,) => {
    return [
    `/api/auth/verify-email`, ...(params ? [params] : [])
    ] as const;
    }


export const getVerifyEmailQueryOptions = <TData = Awaited<ReturnType<typeof verifyEmail>>, TError = ErrorType<ErrorResponse>>(params: VerifyEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof verifyEmail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyEmailQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyEmail>>> = ({ signal }) => verifyEmail(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verifyEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type VerifyEmailQueryResult = NonNullable<Awaited<ReturnType<typeof verifyEmail>>>
export type VerifyEmailQueryError = ErrorType<ErrorResponse>


/**
 * @summary Verify email address via token
 */

export function useVerifyEmail<TData = Awaited<ReturnType<typeof verifyEmail>>, TError = ErrorType<ErrorResponse>>(
 params: VerifyEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof verifyEmail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getVerifyEmailQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResendVerificationUrl = () => {




  return `/api/auth/resend-verification`
}

/**
 * @summary Resend email verification link
 */
export const resendVerification = async ( options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getResendVerificationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendVerificationMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,void, TContext> => {

const mutationKey = ['resendVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendVerification>>, void> = () => {


          return  resendVerification(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof resendVerification>>>

    export type ResendVerificationMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Resend email verification link
 */
export const useResendVerification = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendVerification>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResendVerificationMutationOptions(options));
    }

export const getListCommunityPostsUrl = (params?: ListCommunityPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/community/posts?${stringifiedParams}` : `/api/community/posts`
}

/**
 * @summary List community posts
 */
export const listCommunityPosts = async (params?: ListCommunityPostsParams, options?: RequestInit): Promise<CommunityPost[]> => {

  return customFetch<CommunityPost[]>(getListCommunityPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCommunityPostsQueryKey = (params?: ListCommunityPostsParams,) => {
    return [
    `/api/community/posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCommunityPostsQueryOptions = <TData = Awaited<ReturnType<typeof listCommunityPosts>>, TError = ErrorType<unknown>>(params?: ListCommunityPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCommunityPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCommunityPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCommunityPosts>>> = ({ signal }) => listCommunityPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCommunityPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCommunityPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listCommunityPosts>>>
export type ListCommunityPostsQueryError = ErrorType<unknown>


/**
 * @summary List community posts
 */

export function useListCommunityPosts<TData = Awaited<ReturnType<typeof listCommunityPosts>>, TError = ErrorType<unknown>>(
 params?: ListCommunityPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCommunityPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCommunityPostsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCommunityPostUrl = () => {




  return `/api/community/posts`
}

/**
 * @summary Create a community post
 */
export const createCommunityPost = async (createPostInput: CreatePostInput, options?: RequestInit): Promise<CommunityPost> => {

  return customFetch<CommunityPost>(getCreateCommunityPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPostInput)
  }
);}




export const getCreateCommunityPostMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCommunityPost>>, TError,{data: BodyType<CreatePostInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCommunityPost>>, TError,{data: BodyType<CreatePostInput>}, TContext> => {

const mutationKey = ['createCommunityPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCommunityPost>>, {data: BodyType<CreatePostInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCommunityPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCommunityPostMutationResult = NonNullable<Awaited<ReturnType<typeof createCommunityPost>>>
    export type CreateCommunityPostMutationBody = BodyType<CreatePostInput>
    export type CreateCommunityPostMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a community post
 */
export const useCreateCommunityPost = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCommunityPost>>, TError,{data: BodyType<CreatePostInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCommunityPost>>,
        TError,
        {data: BodyType<CreatePostInput>},
        TContext
      > => {
      return useMutation(getCreateCommunityPostMutationOptions(options));
    }

export const getDeleteCommunityPostUrl = (id: number,) => {




  return `/api/community/posts/${id}`
}

/**
 * @summary Delete a community post
 */
export const deleteCommunityPost = async (id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteCommunityPostUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCommunityPostMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommunityPost>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCommunityPost>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCommunityPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCommunityPost>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCommunityPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommunityPostMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCommunityPost>>>

    export type DeleteCommunityPostMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a community post
 */
export const useDeleteCommunityPost = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommunityPost>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCommunityPost>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCommunityPostMutationOptions(options));
    }

export const getToggleCommunityPostLikeUrl = (id: number,) => {




  return `/api/community/posts/${id}/like`
}

/**
 * @summary Toggle like on a community post
 */
export const toggleCommunityPostLike = async (id: number, options?: RequestInit): Promise<LikeResponse> => {

  return customFetch<LikeResponse>(getToggleCommunityPostLikeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getToggleCommunityPostLikeMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleCommunityPostLike>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleCommunityPostLike>>, TError,{id: number}, TContext> => {

const mutationKey = ['toggleCommunityPostLike'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleCommunityPostLike>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  toggleCommunityPostLike(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleCommunityPostLikeMutationResult = NonNullable<Awaited<ReturnType<typeof toggleCommunityPostLike>>>

    export type ToggleCommunityPostLikeMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Toggle like on a community post
 */
export const useToggleCommunityPostLike = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleCommunityPostLike>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof toggleCommunityPostLike>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getToggleCommunityPostLikeMutationOptions(options));
    }

export const getListCommunityCommentsUrl = (id: number,) => {




  return `/api/community/posts/${id}/comments`
}

/**
 * @summary List comments on a post
 */
export const listCommunityComments = async (id: number, options?: RequestInit): Promise<CommunityComment[]> => {

  return customFetch<CommunityComment[]>(getListCommunityCommentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCommunityCommentsQueryKey = (id: number,) => {
    return [
    `/api/community/posts/${id}/comments`
    ] as const;
    }


export const getListCommunityCommentsQueryOptions = <TData = Awaited<ReturnType<typeof listCommunityComments>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCommunityComments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCommunityCommentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCommunityComments>>> = ({ signal }) => listCommunityComments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCommunityComments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCommunityCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof listCommunityComments>>>
export type ListCommunityCommentsQueryError = ErrorType<unknown>


/**
 * @summary List comments on a post
 */

export function useListCommunityComments<TData = Awaited<ReturnType<typeof listCommunityComments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCommunityComments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCommunityCommentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCommunityCommentUrl = (id: number,) => {




  return `/api/community/posts/${id}/comments`
}

/**
 * @summary Add a comment to a post
 */
export const createCommunityComment = async (id: number,
    createCommentInput: CreateCommentInput, options?: RequestInit): Promise<CommunityComment> => {

  return customFetch<CommunityComment>(getCreateCommunityCommentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCommentInput)
  }
);}




export const getCreateCommunityCommentMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCommunityComment>>, TError,{id: number;data: BodyType<CreateCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCommunityComment>>, TError,{id: number;data: BodyType<CreateCommentInput>}, TContext> => {

const mutationKey = ['createCommunityComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCommunityComment>>, {id: number;data: BodyType<CreateCommentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createCommunityComment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCommunityCommentMutationResult = NonNullable<Awaited<ReturnType<typeof createCommunityComment>>>
    export type CreateCommunityCommentMutationBody = BodyType<CreateCommentInput>
    export type CreateCommunityCommentMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Add a comment to a post
 */
export const useCreateCommunityComment = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCommunityComment>>, TError,{id: number;data: BodyType<CreateCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCommunityComment>>,
        TError,
        {id: number;data: BodyType<CreateCommentInput>},
        TContext
      > => {
      return useMutation(getCreateCommunityCommentMutationOptions(options));
    }

export const getGetHomeDataUrl = (params?: GetHomeDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/home?${stringifiedParams}` : `/api/home`
}

/**
 * @summary Get combined home page data
 */
export const getHomeData = async (params?: GetHomeDataParams, options?: RequestInit): Promise<HomeData> => {

  return customFetch<HomeData>(getGetHomeDataUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHomeDataQueryKey = (params?: GetHomeDataParams,) => {
    return [
    `/api/home`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHomeDataQueryOptions = <TData = Awaited<ReturnType<typeof getHomeData>>, TError = ErrorType<unknown>>(params?: GetHomeDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHomeData>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHomeDataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomeData>>> = ({ signal }) => getHomeData(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHomeData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHomeDataQueryResult = NonNullable<Awaited<ReturnType<typeof getHomeData>>>
export type GetHomeDataQueryError = ErrorType<unknown>


/**
 * @summary Get combined home page data
 */

export function useGetHomeData<TData = Awaited<ReturnType<typeof getHomeData>>, TError = ErrorType<unknown>>(
 params?: GetHomeDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHomeData>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHomeDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetNewsUrl = (params?: GetNewsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/news?${stringifiedParams}` : `/api/news`
}

/**
 * @summary List news articles
 */
export const getNews = async (params?: GetNewsParams, options?: RequestInit): Promise<NewsListResponse> => {

  return customFetch<NewsListResponse>(getGetNewsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNewsQueryKey = (params?: GetNewsParams,) => {
    return [
    `/api/news`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNewsQueryOptions = <TData = Awaited<ReturnType<typeof getNews>>, TError = ErrorType<unknown>>(params?: GetNewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNews>>> = ({ signal }) => getNews(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNewsQueryResult = NonNullable<Awaited<ReturnType<typeof getNews>>>
export type GetNewsQueryError = ErrorType<unknown>


/**
 * @summary List news articles
 */

export function useGetNews<TData = Awaited<ReturnType<typeof getNews>>, TError = ErrorType<unknown>>(
 params?: GetNewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNewsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateNewsUrl = () => {




  return `/api/news`
}

/**
 * @summary Admin create news article
 */
export const createNews = async (newsInput: NewsInput, options?: RequestInit): Promise<NewsArticle> => {

  return customFetch<NewsArticle>(getCreateNewsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(newsInput)
  }
);}




export const getCreateNewsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNews>>, TError,{data: BodyType<NewsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNews>>, TError,{data: BodyType<NewsInput>}, TContext> => {

const mutationKey = ['createNews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNews>>, {data: BodyType<NewsInput>}> = (props) => {
          const {data} = props ?? {};

          return  createNews(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNewsMutationResult = NonNullable<Awaited<ReturnType<typeof createNews>>>
    export type CreateNewsMutationBody = BodyType<NewsInput>
    export type CreateNewsMutationError = ErrorType<unknown>

    /**
 * @summary Admin create news article
 */
export const useCreateNews = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNews>>, TError,{data: BodyType<NewsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNews>>,
        TError,
        {data: BodyType<NewsInput>},
        TContext
      > => {
      return useMutation(getCreateNewsMutationOptions(options));
    }

export const getGetNewsByIdUrl = (id: number,) => {




  return `/api/news/${id}`
}

/**
 * @summary Get a news article
 */
export const getNewsById = async (id: number, options?: RequestInit): Promise<NewsArticle> => {

  return customFetch<NewsArticle>(getGetNewsByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNewsByIdQueryKey = (id: number,) => {
    return [
    `/api/news/${id}`
    ] as const;
    }


export const getGetNewsByIdQueryOptions = <TData = Awaited<ReturnType<typeof getNewsById>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNewsById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewsByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewsById>>> = ({ signal }) => getNewsById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewsById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNewsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getNewsById>>>
export type GetNewsByIdQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a news article
 */

export function useGetNewsById<TData = Awaited<ReturnType<typeof getNewsById>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNewsById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNewsByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateNewsUrl = (id: number,) => {




  return `/api/news/${id}`
}

/**
 * @summary Admin update news article
 */
export const updateNews = async (id: number,
    newsInput: NewsInput, options?: RequestInit): Promise<NewsArticle> => {

  return customFetch<NewsArticle>(getUpdateNewsUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(newsInput)
  }
);}




export const getUpdateNewsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNews>>, TError,{id: number;data: BodyType<NewsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNews>>, TError,{id: number;data: BodyType<NewsInput>}, TContext> => {

const mutationKey = ['updateNews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNews>>, {id: number;data: BodyType<NewsInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateNews(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNewsMutationResult = NonNullable<Awaited<ReturnType<typeof updateNews>>>
    export type UpdateNewsMutationBody = BodyType<NewsInput>
    export type UpdateNewsMutationError = ErrorType<unknown>

    /**
 * @summary Admin update news article
 */
export const useUpdateNews = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNews>>, TError,{id: number;data: BodyType<NewsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNews>>,
        TError,
        {id: number;data: BodyType<NewsInput>},
        TContext
      > => {
      return useMutation(getUpdateNewsMutationOptions(options));
    }

export const getDeleteNewsUrl = (id: number,) => {




  return `/api/news/${id}`
}

/**
 * @summary Admin delete news article
 */
export const deleteNews = async (id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteNewsUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteNewsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNews>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNews>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteNews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNews>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteNews(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNewsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNews>>>

    export type DeleteNewsMutationError = ErrorType<unknown>

    /**
 * @summary Admin delete news article
 */
export const useDeleteNews = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNews>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteNews>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteNewsMutationOptions(options));
    }

export const getSubmitNewsUrl = () => {




  return `/api/news/submit`
}

/**
 * @summary User submits a news tip
 */
export const submitNews = async (newsSubmissionInput: NewsSubmissionInput, options?: RequestInit): Promise<NewsArticle> => {

  return customFetch<NewsArticle>(getSubmitNewsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(newsSubmissionInput)
  }
);}




export const getSubmitNewsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitNews>>, TError,{data: BodyType<NewsSubmissionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitNews>>, TError,{data: BodyType<NewsSubmissionInput>}, TContext> => {

const mutationKey = ['submitNews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitNews>>, {data: BodyType<NewsSubmissionInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitNews(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitNewsMutationResult = NonNullable<Awaited<ReturnType<typeof submitNews>>>
    export type SubmitNewsMutationBody = BodyType<NewsSubmissionInput>
    export type SubmitNewsMutationError = ErrorType<unknown>

    /**
 * @summary User submits a news tip
 */
export const useSubmitNews = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitNews>>, TError,{data: BodyType<NewsSubmissionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitNews>>,
        TError,
        {data: BodyType<NewsSubmissionInput>},
        TContext
      > => {
      return useMutation(getSubmitNewsMutationOptions(options));
    }

export const getApproveNewsUrl = (id: number,) => {




  return `/api/news/${id}/approve`
}

/**
 * @summary Admin approve/reject news
 */
export const approveNews = async (id: number,
    approveInput: ApproveInput, options?: RequestInit): Promise<NewsArticle> => {

  return customFetch<NewsArticle>(getApproveNewsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveInput)
  }
);}




export const getApproveNewsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveNews>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveNews>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext> => {

const mutationKey = ['approveNews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveNews>>, {id: number;data: BodyType<ApproveInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveNews(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveNewsMutationResult = NonNullable<Awaited<ReturnType<typeof approveNews>>>
    export type ApproveNewsMutationBody = BodyType<ApproveInput>
    export type ApproveNewsMutationError = ErrorType<unknown>

    /**
 * @summary Admin approve/reject news
 */
export const useApproveNews = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveNews>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveNews>>,
        TError,
        {id: number;data: BodyType<ApproveInput>},
        TContext
      > => {
      return useMutation(getApproveNewsMutationOptions(options));
    }

export const getFeatureNewsUrl = (id: number,) => {




  return `/api/news/${id}/feature`
}

/**
 * @summary Admin toggle featured
 */
export const featureNews = async (id: number,
    featureInput: FeatureInput, options?: RequestInit): Promise<NewsArticle> => {

  return customFetch<NewsArticle>(getFeatureNewsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(featureInput)
  }
);}




export const getFeatureNewsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureNews>>, TError,{id: number;data: BodyType<FeatureInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof featureNews>>, TError,{id: number;data: BodyType<FeatureInput>}, TContext> => {

const mutationKey = ['featureNews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof featureNews>>, {id: number;data: BodyType<FeatureInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  featureNews(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FeatureNewsMutationResult = NonNullable<Awaited<ReturnType<typeof featureNews>>>
    export type FeatureNewsMutationBody = BodyType<FeatureInput>
    export type FeatureNewsMutationError = ErrorType<unknown>

    /**
 * @summary Admin toggle featured
 */
export const useFeatureNews = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureNews>>, TError,{id: number;data: BodyType<FeatureInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof featureNews>>,
        TError,
        {id: number;data: BodyType<FeatureInput>},
        TContext
      > => {
      return useMutation(getFeatureNewsMutationOptions(options));
    }

export const getGetJobsUrl = (params?: GetJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/jobs?${stringifiedParams}` : `/api/jobs`
}

/**
 * @summary List job posts
 */
export const getJobs = async (params?: GetJobsParams, options?: RequestInit): Promise<JobListResponse> => {

  return customFetch<JobListResponse>(getGetJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobsQueryKey = (params?: GetJobsParams,) => {
    return [
    `/api/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetJobsQueryOptions = <TData = Awaited<ReturnType<typeof getJobs>>, TError = ErrorType<unknown>>(params?: GetJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobs>>> = ({ signal }) => getJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobs>>>
export type GetJobsQueryError = ErrorType<unknown>


/**
 * @summary List job posts
 */

export function useGetJobs<TData = Awaited<ReturnType<typeof getJobs>>, TError = ErrorType<unknown>>(
 params?: GetJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateJobUrl = () => {




  return `/api/jobs`
}

/**
 * @summary Post a job
 */
export const createJob = async (jobInput: JobInput, options?: RequestInit): Promise<Job> => {

  return customFetch<Job>(getCreateJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobInput)
  }
);}




export const getCreateJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: BodyType<JobInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: BodyType<JobInput>}, TContext> => {

const mutationKey = ['createJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJob>>, {data: BodyType<JobInput>}> = (props) => {
          const {data} = props ?? {};

          return  createJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobMutationResult = NonNullable<Awaited<ReturnType<typeof createJob>>>
    export type CreateJobMutationBody = BodyType<JobInput>
    export type CreateJobMutationError = ErrorType<unknown>

    /**
 * @summary Post a job
 */
export const useCreateJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: BodyType<JobInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createJob>>,
        TError,
        {data: BodyType<JobInput>},
        TContext
      > => {
      return useMutation(getCreateJobMutationOptions(options));
    }

export const getGetJobByIdUrl = (id: number,) => {




  return `/api/jobs/${id}`
}

/**
 * @summary Get a job
 */
export const getJobById = async (id: number, options?: RequestInit): Promise<Job> => {

  return customFetch<Job>(getGetJobByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobByIdQueryKey = (id: number,) => {
    return [
    `/api/jobs/${id}`
    ] as const;
    }


export const getGetJobByIdQueryOptions = <TData = Awaited<ReturnType<typeof getJobById>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobById>>> = ({ signal }) => getJobById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getJobById>>>
export type GetJobByIdQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a job
 */

export function useGetJobById<TData = Awaited<ReturnType<typeof getJobById>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateJobUrl = (id: number,) => {




  return `/api/jobs/${id}`
}

/**
 * @summary Update a job
 */
export const updateJob = async (id: number,
    jobInput: JobInput, options?: RequestInit): Promise<Job> => {

  return customFetch<Job>(getUpdateJobUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobInput)
  }
);}




export const getUpdateJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{id: number;data: BodyType<JobInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{id: number;data: BodyType<JobInput>}, TContext> => {

const mutationKey = ['updateJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJob>>, {id: number;data: BodyType<JobInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateJob(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobMutationResult = NonNullable<Awaited<ReturnType<typeof updateJob>>>
    export type UpdateJobMutationBody = BodyType<JobInput>
    export type UpdateJobMutationError = ErrorType<unknown>

    /**
 * @summary Update a job
 */
export const useUpdateJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{id: number;data: BodyType<JobInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateJob>>,
        TError,
        {id: number;data: BodyType<JobInput>},
        TContext
      > => {
      return useMutation(getUpdateJobMutationOptions(options));
    }

export const getDeleteJobUrl = (id: number,) => {




  return `/api/jobs/${id}`
}

/**
 * @summary Delete a job
 */
export const deleteJob = async (id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteJobUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJob>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteJob(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJob>>>

    export type DeleteJobMutationError = ErrorType<unknown>

    /**
 * @summary Delete a job
 */
export const useDeleteJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteJob>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteJobMutationOptions(options));
    }

export const getUnlockLeadUrl = (id: number,) => {




  return `/api/jobs/${id}/unlock`
}

/**
 * @summary Tradesperson unlocks a job lead (requires verified Stripe payment)
 */
export const unlockLead = async (id: number,
    unlockLeadBody: UnlockLeadBody, options?: RequestInit): Promise<LeadPurchase> => {

  return customFetch<LeadPurchase>(getUnlockLeadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(unlockLeadBody)
  }
);}




export const getUnlockLeadMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockLead>>, TError,{id: number;data: BodyType<UnlockLeadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlockLead>>, TError,{id: number;data: BodyType<UnlockLeadBody>}, TContext> => {

const mutationKey = ['unlockLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockLead>>, {id: number;data: BodyType<UnlockLeadBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  unlockLead(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockLeadMutationResult = NonNullable<Awaited<ReturnType<typeof unlockLead>>>
    export type UnlockLeadMutationBody = BodyType<UnlockLeadBody>
    export type UnlockLeadMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Tradesperson unlocks a job lead (requires verified Stripe payment)
 */
export const useUnlockLead = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockLead>>, TError,{id: number;data: BodyType<UnlockLeadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlockLead>>,
        TError,
        {id: number;data: BodyType<UnlockLeadBody>},
        TContext
      > => {
      return useMutation(getUnlockLeadMutationOptions(options));
    }

export const getGetTradeProfilesUrl = (params?: GetTradeProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/trades?${stringifiedParams}` : `/api/trades`
}

/**
 * @summary List trade profiles
 */
export const getTradeProfiles = async (params?: GetTradeProfilesParams, options?: RequestInit): Promise<TradeProfileListResponse> => {

  return customFetch<TradeProfileListResponse>(getGetTradeProfilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTradeProfilesQueryKey = (params?: GetTradeProfilesParams,) => {
    return [
    `/api/trades`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradeProfilesQueryOptions = <TData = Awaited<ReturnType<typeof getTradeProfiles>>, TError = ErrorType<unknown>>(params?: GetTradeProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTradeProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradeProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradeProfiles>>> = ({ signal }) => getTradeProfiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradeProfiles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTradeProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof getTradeProfiles>>>
export type GetTradeProfilesQueryError = ErrorType<unknown>


/**
 * @summary List trade profiles
 */

export function useGetTradeProfiles<TData = Awaited<ReturnType<typeof getTradeProfiles>>, TError = ErrorType<unknown>>(
 params?: GetTradeProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTradeProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTradeProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTradeProfileUrl = () => {




  return `/api/trades`
}

/**
 * @summary Create trade profile
 */
export const createTradeProfile = async (tradeProfileInput: TradeProfileInput, options?: RequestInit): Promise<TradeProfile> => {

  return customFetch<TradeProfile>(getCreateTradeProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tradeProfileInput)
  }
);}




export const getCreateTradeProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTradeProfile>>, TError,{data: BodyType<TradeProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTradeProfile>>, TError,{data: BodyType<TradeProfileInput>}, TContext> => {

const mutationKey = ['createTradeProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTradeProfile>>, {data: BodyType<TradeProfileInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTradeProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTradeProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createTradeProfile>>>
    export type CreateTradeProfileMutationBody = BodyType<TradeProfileInput>
    export type CreateTradeProfileMutationError = ErrorType<unknown>

    /**
 * @summary Create trade profile
 */
export const useCreateTradeProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTradeProfile>>, TError,{data: BodyType<TradeProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTradeProfile>>,
        TError,
        {data: BodyType<TradeProfileInput>},
        TContext
      > => {
      return useMutation(getCreateTradeProfileMutationOptions(options));
    }

export const getGetTradeProfileByIdUrl = (id: number,) => {




  return `/api/trades/${id}`
}

/**
 * @summary Get trade profile
 */
export const getTradeProfileById = async (id: number, options?: RequestInit): Promise<TradeProfile> => {

  return customFetch<TradeProfile>(getGetTradeProfileByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTradeProfileByIdQueryKey = (id: number,) => {
    return [
    `/api/trades/${id}`
    ] as const;
    }


export const getGetTradeProfileByIdQueryOptions = <TData = Awaited<ReturnType<typeof getTradeProfileById>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTradeProfileById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradeProfileByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradeProfileById>>> = ({ signal }) => getTradeProfileById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradeProfileById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTradeProfileByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTradeProfileById>>>
export type GetTradeProfileByIdQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get trade profile
 */

export function useGetTradeProfileById<TData = Awaited<ReturnType<typeof getTradeProfileById>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTradeProfileById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTradeProfileByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTradeProfileUrl = (id: number,) => {




  return `/api/trades/${id}`
}

/**
 * @summary Update trade profile
 */
export const updateTradeProfile = async (id: number,
    tradeProfileInput: TradeProfileInput, options?: RequestInit): Promise<TradeProfile> => {

  return customFetch<TradeProfile>(getUpdateTradeProfileUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tradeProfileInput)
  }
);}




export const getUpdateTradeProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTradeProfile>>, TError,{id: number;data: BodyType<TradeProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTradeProfile>>, TError,{id: number;data: BodyType<TradeProfileInput>}, TContext> => {

const mutationKey = ['updateTradeProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTradeProfile>>, {id: number;data: BodyType<TradeProfileInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTradeProfile(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTradeProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateTradeProfile>>>
    export type UpdateTradeProfileMutationBody = BodyType<TradeProfileInput>
    export type UpdateTradeProfileMutationError = ErrorType<unknown>

    /**
 * @summary Update trade profile
 */
export const useUpdateTradeProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTradeProfile>>, TError,{id: number;data: BodyType<TradeProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTradeProfile>>,
        TError,
        {id: number;data: BodyType<TradeProfileInput>},
        TContext
      > => {
      return useMutation(getUpdateTradeProfileMutationOptions(options));
    }

export const getGetMyTradeProfileUrl = () => {




  return `/api/trades/me`
}

/**
 * @summary Get current user trade profile
 */
export const getMyTradeProfile = async ( options?: RequestInit): Promise<TradeProfile> => {

  return customFetch<TradeProfile>(getGetMyTradeProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyTradeProfileQueryKey = () => {
    return [
    `/api/trades/me`
    ] as const;
    }


export const getGetMyTradeProfileQueryOptions = <TData = Awaited<ReturnType<typeof getMyTradeProfile>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyTradeProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyTradeProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTradeProfile>>> = ({ signal }) => getMyTradeProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyTradeProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyTradeProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyTradeProfile>>>
export type GetMyTradeProfileQueryError = ErrorType<unknown>


/**
 * @summary Get current user trade profile
 */

export function useGetMyTradeProfile<TData = Awaited<ReturnType<typeof getMyTradeProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyTradeProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyTradeProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getVerifyTradeUrl = (id: number,) => {




  return `/api/trades/${id}/verify`
}

/**
 * @summary Admin verify tradesperson
 */
export const verifyTrade = async (id: number,
    verifyInput: VerifyInput, options?: RequestInit): Promise<TradeProfile> => {

  return customFetch<TradeProfile>(getVerifyTradeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyInput)
  }
);}




export const getVerifyTradeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTrade>>, TError,{id: number;data: BodyType<VerifyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyTrade>>, TError,{id: number;data: BodyType<VerifyInput>}, TContext> => {

const mutationKey = ['verifyTrade'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyTrade>>, {id: number;data: BodyType<VerifyInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  verifyTrade(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyTradeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyTrade>>>
    export type VerifyTradeMutationBody = BodyType<VerifyInput>
    export type VerifyTradeMutationError = ErrorType<unknown>

    /**
 * @summary Admin verify tradesperson
 */
export const useVerifyTrade = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTrade>>, TError,{id: number;data: BodyType<VerifyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyTrade>>,
        TError,
        {id: number;data: BodyType<VerifyInput>},
        TContext
      > => {
      return useMutation(getVerifyTradeMutationOptions(options));
    }

export const getGetEventsUrl = (params?: GetEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/events?${stringifiedParams}` : `/api/events`
}

/**
 * @summary List events
 */
export const getEvents = async (params?: GetEventsParams, options?: RequestInit): Promise<EventListResponse> => {

  return customFetch<EventListResponse>(getGetEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEventsQueryKey = (params?: GetEventsParams,) => {
    return [
    `/api/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(params?: GetEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = ErrorType<unknown>


/**
 * @summary List events
 */

export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(
 params?: GetEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitEventUrl = () => {




  return `/api/events`
}

/**
 * @summary Submit an event
 */
export const submitEvent = async (eventInput: EventInput, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getSubmitEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(eventInput)
  }
);}




export const getSubmitEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEvent>>, TError,{data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitEvent>>, TError,{data: BodyType<EventInput>}, TContext> => {

const mutationKey = ['submitEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEvent>>, {data: BodyType<EventInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitEventMutationResult = NonNullable<Awaited<ReturnType<typeof submitEvent>>>
    export type SubmitEventMutationBody = BodyType<EventInput>
    export type SubmitEventMutationError = ErrorType<unknown>

    /**
 * @summary Submit an event
 */
export const useSubmitEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEvent>>, TError,{data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEvent>>,
        TError,
        {data: BodyType<EventInput>},
        TContext
      > => {
      return useMutation(getSubmitEventMutationOptions(options));
    }

export const getGetEventByIdUrl = (id: string,) => {




  return `/api/events/${id}`
}

/**
 * @summary Get event
 */
export const getEventById = async (id: string, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getGetEventByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEventByIdQueryKey = (id: string,) => {
    return [
    `/api/events/${id}`
    ] as const;
    }


export const getGetEventByIdQueryOptions = <TData = Awaited<ReturnType<typeof getEventById>>, TError = ErrorType<ErrorResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventById>>> = ({ signal }) => getEventById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEventById>>>
export type GetEventByIdQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get event
 */

export function useGetEventById<TData = Awaited<ReturnType<typeof getEventById>>, TError = ErrorType<ErrorResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateEventUrl = (id: number,) => {




  return `/api/events/${id}`
}

/**
 * @summary Update event
 */
export const updateEvent = async (id: number,
    eventInput: EventInput, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getUpdateEventUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(eventInput)
  }
);}




export const getUpdateEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{id: number;data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{id: number;data: BodyType<EventInput>}, TContext> => {

const mutationKey = ['updateEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEvent>>, {id: number;data: BodyType<EventInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEvent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvent>>>
    export type UpdateEventMutationBody = BodyType<EventInput>
    export type UpdateEventMutationError = ErrorType<unknown>

    /**
 * @summary Update event
 */
export const useUpdateEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvent>>, TError,{id: number;data: BodyType<EventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEvent>>,
        TError,
        {id: number;data: BodyType<EventInput>},
        TContext
      > => {
      return useMutation(getUpdateEventMutationOptions(options));
    }

export const getDeleteEventUrl = (id: number,) => {




  return `/api/events/${id}`
}

/**
 * @summary Delete event
 */
export const deleteEvent = async (id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteEventUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEvent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>

    export type DeleteEventMutationError = ErrorType<unknown>

    /**
 * @summary Delete event
 */
export const useDeleteEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEvent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteEventMutationOptions(options));
    }

export const getApproveEventUrl = (id: number,) => {




  return `/api/events/${id}/approve`
}

/**
 * @summary Admin approve/reject event
 */
export const approveEvent = async (id: number,
    approveInput: ApproveInput, options?: RequestInit): Promise<Event> => {

  return customFetch<Event>(getApproveEventUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveInput)
  }
);}




export const getApproveEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveEvent>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveEvent>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext> => {

const mutationKey = ['approveEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveEvent>>, {id: number;data: BodyType<ApproveInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveEvent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveEventMutationResult = NonNullable<Awaited<ReturnType<typeof approveEvent>>>
    export type ApproveEventMutationBody = BodyType<ApproveInput>
    export type ApproveEventMutationError = ErrorType<unknown>

    /**
 * @summary Admin approve/reject event
 */
export const useApproveEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveEvent>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveEvent>>,
        TError,
        {id: number;data: BodyType<ApproveInput>},
        TContext
      > => {
      return useMutation(getApproveEventMutationOptions(options));
    }

export const getGetDealsUrl = (params?: GetDealsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/deals?${stringifiedParams}` : `/api/deals`
}

/**
 * @summary List deals
 */
export const getDeals = async (params?: GetDealsParams, options?: RequestInit): Promise<DealListResponse> => {

  return customFetch<DealListResponse>(getGetDealsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDealsQueryKey = (params?: GetDealsParams,) => {
    return [
    `/api/deals`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDealsQueryOptions = <TData = Awaited<ReturnType<typeof getDeals>>, TError = ErrorType<unknown>>(params?: GetDealsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDealsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeals>>> = ({ signal }) => getDeals(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDealsQueryResult = NonNullable<Awaited<ReturnType<typeof getDeals>>>
export type GetDealsQueryError = ErrorType<unknown>


/**
 * @summary List deals
 */

export function useGetDeals<TData = Awaited<ReturnType<typeof getDeals>>, TError = ErrorType<unknown>>(
 params?: GetDealsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDealsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitDealUrl = () => {




  return `/api/deals`
}

/**
 * @summary Submit a deal
 */
export const submitDeal = async (dealInput: DealInput, options?: RequestInit): Promise<Deal> => {

  return customFetch<Deal>(getSubmitDealUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dealInput)
  }
);}




export const getSubmitDealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitDeal>>, TError,{data: BodyType<DealInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitDeal>>, TError,{data: BodyType<DealInput>}, TContext> => {

const mutationKey = ['submitDeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitDeal>>, {data: BodyType<DealInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitDeal(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitDealMutationResult = NonNullable<Awaited<ReturnType<typeof submitDeal>>>
    export type SubmitDealMutationBody = BodyType<DealInput>
    export type SubmitDealMutationError = ErrorType<unknown>

    /**
 * @summary Submit a deal
 */
export const useSubmitDeal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitDeal>>, TError,{data: BodyType<DealInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitDeal>>,
        TError,
        {data: BodyType<DealInput>},
        TContext
      > => {
      return useMutation(getSubmitDealMutationOptions(options));
    }

export const getGetDealByIdUrl = (id: string,) => {




  return `/api/deals/${id}`
}

/**
 * @summary Get deal
 */
export const getDealById = async (id: string, options?: RequestInit): Promise<Deal> => {

  return customFetch<Deal>(getGetDealByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDealByIdQueryKey = (id: string,) => {
    return [
    `/api/deals/${id}`
    ] as const;
    }


export const getGetDealByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDealById>>, TError = ErrorType<ErrorResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDealById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDealByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDealById>>> = ({ signal }) => getDealById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDealById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDealByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDealById>>>
export type GetDealByIdQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get deal
 */

export function useGetDealById<TData = Awaited<ReturnType<typeof getDealById>>, TError = ErrorType<ErrorResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDealById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDealByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDealUrl = (id: number,) => {




  return `/api/deals/${id}`
}

/**
 * @summary Update deal
 */
export const updateDeal = async (id: number,
    dealInput: DealInput, options?: RequestInit): Promise<Deal> => {

  return customFetch<Deal>(getUpdateDealUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dealInput)
  }
);}




export const getUpdateDealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeal>>, TError,{id: number;data: BodyType<DealInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeal>>, TError,{id: number;data: BodyType<DealInput>}, TContext> => {

const mutationKey = ['updateDeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeal>>, {id: number;data: BodyType<DealInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDeal(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDealMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeal>>>
    export type UpdateDealMutationBody = BodyType<DealInput>
    export type UpdateDealMutationError = ErrorType<unknown>

    /**
 * @summary Update deal
 */
export const useUpdateDeal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeal>>, TError,{id: number;data: BodyType<DealInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDeal>>,
        TError,
        {id: number;data: BodyType<DealInput>},
        TContext
      > => {
      return useMutation(getUpdateDealMutationOptions(options));
    }

export const getDeleteDealUrl = (id: number,) => {




  return `/api/deals/${id}`
}

/**
 * @summary Delete deal
 */
export const deleteDeal = async (id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteDealUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDeal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDeal>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDeal>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDeal(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDealMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDeal>>>

    export type DeleteDealMutationError = ErrorType<unknown>

    /**
 * @summary Delete deal
 */
export const useDeleteDeal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDeal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDeal>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteDealMutationOptions(options));
    }

export const getRedeemDealUrl = (id: number,) => {




  return `/api/deals/${id}/redeem`
}

/**
 * @summary Redeem a deal (auth required, one per user)
 */
export const redeemDeal = async (id: number, options?: RequestInit): Promise<RedeemDeal200> => {

  return customFetch<RedeemDeal200>(getRedeemDealUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRedeemDealMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemDeal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemDeal>>, TError,{id: number}, TContext> => {

const mutationKey = ['redeemDeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemDeal>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  redeemDeal(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemDealMutationResult = NonNullable<Awaited<ReturnType<typeof redeemDeal>>>

    export type RedeemDealMutationError = ErrorType<void>

    /**
 * @summary Redeem a deal (auth required, one per user)
 */
export const useRedeemDeal = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemDeal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof redeemDeal>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRedeemDealMutationOptions(options));
    }

export const getApproveDealUrl = (id: number,) => {




  return `/api/deals/${id}/approve`
}

/**
 * @summary Admin approve/reject deal
 */
export const approveDeal = async (id: number,
    approveInput: ApproveInput, options?: RequestInit): Promise<Deal> => {

  return customFetch<Deal>(getApproveDealUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveInput)
  }
);}




export const getApproveDealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDeal>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveDeal>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext> => {

const mutationKey = ['approveDeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveDeal>>, {id: number;data: BodyType<ApproveInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveDeal(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveDealMutationResult = NonNullable<Awaited<ReturnType<typeof approveDeal>>>
    export type ApproveDealMutationBody = BodyType<ApproveInput>
    export type ApproveDealMutationError = ErrorType<unknown>

    /**
 * @summary Admin approve/reject deal
 */
export const useApproveDeal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDeal>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveDeal>>,
        TError,
        {id: number;data: BodyType<ApproveInput>},
        TContext
      > => {
      return useMutation(getApproveDealMutationOptions(options));
    }

export const getGetBusinessesUrl = (params?: GetBusinessesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/businesses?${stringifiedParams}` : `/api/businesses`
}

/**
 * @summary List businesses
 */
export const getBusinesses = async (params?: GetBusinessesParams, options?: RequestInit): Promise<BusinessListResponse> => {

  return customFetch<BusinessListResponse>(getGetBusinessesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBusinessesQueryKey = (params?: GetBusinessesParams,) => {
    return [
    `/api/businesses`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBusinessesQueryOptions = <TData = Awaited<ReturnType<typeof getBusinesses>>, TError = ErrorType<unknown>>(params?: GetBusinessesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBusinesses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinesses>>> = ({ signal }) => getBusinesses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinesses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBusinessesQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinesses>>>
export type GetBusinessesQueryError = ErrorType<unknown>


/**
 * @summary List businesses
 */

export function useGetBusinesses<TData = Awaited<ReturnType<typeof getBusinesses>>, TError = ErrorType<unknown>>(
 params?: GetBusinessesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBusinesses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBusinessesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitBusinessUrl = () => {




  return `/api/businesses`
}

/**
 * @summary Submit business listing
 */
export const submitBusiness = async (businessInput: BusinessInput, options?: RequestInit): Promise<Business> => {

  return customFetch<Business>(getSubmitBusinessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(businessInput)
  }
);}




export const getSubmitBusinessMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitBusiness>>, TError,{data: BodyType<BusinessInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitBusiness>>, TError,{data: BodyType<BusinessInput>}, TContext> => {

const mutationKey = ['submitBusiness'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitBusiness>>, {data: BodyType<BusinessInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitBusiness(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitBusinessMutationResult = NonNullable<Awaited<ReturnType<typeof submitBusiness>>>
    export type SubmitBusinessMutationBody = BodyType<BusinessInput>
    export type SubmitBusinessMutationError = ErrorType<unknown>

    /**
 * @summary Submit business listing
 */
export const useSubmitBusiness = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitBusiness>>, TError,{data: BodyType<BusinessInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitBusiness>>,
        TError,
        {data: BodyType<BusinessInput>},
        TContext
      > => {
      return useMutation(getSubmitBusinessMutationOptions(options));
    }

export const getGetBusinessByIdUrl = (id: string,) => {




  return `/api/businesses/${id}`
}

/**
 * @summary Get business by numeric ID or slug
 */
export const getBusinessById = async (id: string, options?: RequestInit): Promise<Business> => {

  return customFetch<Business>(getGetBusinessByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBusinessByIdQueryKey = (id: string,) => {
    return [
    `/api/businesses/${id}`
    ] as const;
    }


export const getGetBusinessByIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessById>>, TError = ErrorType<ErrorResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBusinessById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessById>>> = ({ signal }) => getBusinessById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBusinessByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessById>>>
export type GetBusinessByIdQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get business by numeric ID or slug
 */

export function useGetBusinessById<TData = Awaited<ReturnType<typeof getBusinessById>>, TError = ErrorType<ErrorResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBusinessById>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBusinessByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateBusinessUrl = (id: number,) => {




  return `/api/businesses/${id}`
}

/**
 * @summary Update business
 */
export const updateBusiness = async (id: number,
    businessInput: BusinessInput, options?: RequestInit): Promise<Business> => {

  return customFetch<Business>(getUpdateBusinessUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(businessInput)
  }
);}




export const getUpdateBusinessMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBusiness>>, TError,{id: number;data: BodyType<BusinessInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBusiness>>, TError,{id: number;data: BodyType<BusinessInput>}, TContext> => {

const mutationKey = ['updateBusiness'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBusiness>>, {id: number;data: BodyType<BusinessInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBusiness(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBusinessMutationResult = NonNullable<Awaited<ReturnType<typeof updateBusiness>>>
    export type UpdateBusinessMutationBody = BodyType<BusinessInput>
    export type UpdateBusinessMutationError = ErrorType<unknown>

    /**
 * @summary Update business
 */
export const useUpdateBusiness = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBusiness>>, TError,{id: number;data: BodyType<BusinessInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBusiness>>,
        TError,
        {id: number;data: BodyType<BusinessInput>},
        TContext
      > => {
      return useMutation(getUpdateBusinessMutationOptions(options));
    }

export const getDeleteBusinessUrl = (id: number,) => {




  return `/api/businesses/${id}`
}

/**
 * @summary Delete business
 */
export const deleteBusiness = async (id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteBusinessUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteBusinessMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusiness>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusiness>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteBusiness'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusiness>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusiness(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusiness>>>

    export type DeleteBusinessMutationError = ErrorType<unknown>

    /**
 * @summary Delete business
 */
export const useDeleteBusiness = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusiness>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusiness>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteBusinessMutationOptions(options));
    }

export const getApproveBusinessUrl = (id: number,) => {




  return `/api/businesses/${id}/approve`
}

/**
 * @summary Admin approve/reject business
 */
export const approveBusiness = async (id: number,
    approveInput: ApproveInput, options?: RequestInit): Promise<Business> => {

  return customFetch<Business>(getApproveBusinessUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveInput)
  }
);}




export const getApproveBusinessMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveBusiness>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveBusiness>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext> => {

const mutationKey = ['approveBusiness'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveBusiness>>, {id: number;data: BodyType<ApproveInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveBusiness(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveBusinessMutationResult = NonNullable<Awaited<ReturnType<typeof approveBusiness>>>
    export type ApproveBusinessMutationBody = BodyType<ApproveInput>
    export type ApproveBusinessMutationError = ErrorType<unknown>

    /**
 * @summary Admin approve/reject business
 */
export const useApproveBusiness = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveBusiness>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveBusiness>>,
        TError,
        {id: number;data: BodyType<ApproveInput>},
        TContext
      > => {
      return useMutation(getApproveBusinessMutationOptions(options));
    }

export const getVerifyBusinessUrl = (id: number,) => {




  return `/api/businesses/${id}/verify`
}

/**
 * @summary Admin verify business
 */
export const verifyBusiness = async (id: number,
    verifyInput: VerifyInput, options?: RequestInit): Promise<Business> => {

  return customFetch<Business>(getVerifyBusinessUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyInput)
  }
);}




export const getVerifyBusinessMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyBusiness>>, TError,{id: number;data: BodyType<VerifyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyBusiness>>, TError,{id: number;data: BodyType<VerifyInput>}, TContext> => {

const mutationKey = ['verifyBusiness'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyBusiness>>, {id: number;data: BodyType<VerifyInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  verifyBusiness(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyBusinessMutationResult = NonNullable<Awaited<ReturnType<typeof verifyBusiness>>>
    export type VerifyBusinessMutationBody = BodyType<VerifyInput>
    export type VerifyBusinessMutationError = ErrorType<unknown>

    /**
 * @summary Admin verify business
 */
export const useVerifyBusiness = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyBusiness>>, TError,{id: number;data: BodyType<VerifyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyBusiness>>,
        TError,
        {id: number;data: BodyType<VerifyInput>},
        TContext
      > => {
      return useMutation(getVerifyBusinessMutationOptions(options));
    }

export const getGetReviewsUrl = (params?: GetReviewsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reviews?${stringifiedParams}` : `/api/reviews`
}

/**
 * @summary List reviews
 */
export const getReviews = async (params?: GetReviewsParams, options?: RequestInit): Promise<ReviewListResponse> => {

  return customFetch<ReviewListResponse>(getGetReviewsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReviewsQueryKey = (params?: GetReviewsParams,) => {
    return [
    `/api/reviews`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getReviews>>, TError = ErrorType<unknown>>(params?: GetReviewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReviewsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviews>>> = ({ signal }) => getReviews(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getReviews>>>
export type GetReviewsQueryError = ErrorType<unknown>


/**
 * @summary List reviews
 */

export function useGetReviews<TData = Awaited<ReturnType<typeof getReviews>>, TError = ErrorType<unknown>>(
 params?: GetReviewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReviewsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitReviewUrl = () => {




  return `/api/reviews`
}

/**
 * @summary Submit a review
 */
export const submitReview = async (reviewInput: ReviewInput, options?: RequestInit): Promise<Review> => {

  return customFetch<Review>(getSubmitReviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reviewInput)
  }
);}




export const getSubmitReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReview>>, TError,{data: BodyType<ReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitReview>>, TError,{data: BodyType<ReviewInput>}, TContext> => {

const mutationKey = ['submitReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitReview>>, {data: BodyType<ReviewInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitReview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitReviewMutationResult = NonNullable<Awaited<ReturnType<typeof submitReview>>>
    export type SubmitReviewMutationBody = BodyType<ReviewInput>
    export type SubmitReviewMutationError = ErrorType<unknown>

    /**
 * @summary Submit a review
 */
export const useSubmitReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReview>>, TError,{data: BodyType<ReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitReview>>,
        TError,
        {data: BodyType<ReviewInput>},
        TContext
      > => {
      return useMutation(getSubmitReviewMutationOptions(options));
    }

export const getApproveReviewUrl = (id: number,) => {




  return `/api/reviews/${id}/approve`
}

/**
 * @summary Admin approve/reject review
 */
export const approveReview = async (id: number,
    approveInput: ApproveInput, options?: RequestInit): Promise<Review> => {

  return customFetch<Review>(getApproveReviewUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveInput)
  }
);}




export const getApproveReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveReview>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveReview>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext> => {

const mutationKey = ['approveReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveReview>>, {id: number;data: BodyType<ApproveInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveReviewMutationResult = NonNullable<Awaited<ReturnType<typeof approveReview>>>
    export type ApproveReviewMutationBody = BodyType<ApproveInput>
    export type ApproveReviewMutationError = ErrorType<unknown>

    /**
 * @summary Admin approve/reject review
 */
export const useApproveReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveReview>>, TError,{id: number;data: BodyType<ApproveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveReview>>,
        TError,
        {id: number;data: BodyType<ApproveInput>},
        TContext
      > => {
      return useMutation(getApproveReviewMutationOptions(options));
    }

export const getGetMyTransactionsUrl = () => {




  return `/api/transactions/my`
}

/**
 * @summary Get current user's transaction history
 */
export const getMyTransactions = async ( options?: RequestInit): Promise<GetMyTransactions200> => {

  return customFetch<GetMyTransactions200>(getGetMyTransactionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyTransactionsQueryKey = () => {
    return [
    `/api/transactions/my`
    ] as const;
    }


export const getGetMyTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getMyTransactions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyTransactionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTransactions>>> = ({ signal }) => getMyTransactions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyTransactions>>>
export type GetMyTransactionsQueryError = ErrorType<unknown>


/**
 * @summary Get current user's transaction history
 */

export function useGetMyTransactions<TData = Awaited<ReturnType<typeof getMyTransactions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyTransactionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLeadPurchasesUrl = () => {




  return `/api/leads`
}

/**
 * @summary Get lead purchase history
 */
export const getLeadPurchases = async ( options?: RequestInit): Promise<LeadPurchaseListResponse> => {

  return customFetch<LeadPurchaseListResponse>(getGetLeadPurchasesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeadPurchasesQueryKey = () => {
    return [
    `/api/leads`
    ] as const;
    }


export const getGetLeadPurchasesQueryOptions = <TData = Awaited<ReturnType<typeof getLeadPurchases>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLeadPurchases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadPurchasesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadPurchases>>> = ({ signal }) => getLeadPurchases({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeadPurchases>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLeadPurchasesQueryResult = NonNullable<Awaited<ReturnType<typeof getLeadPurchases>>>
export type GetLeadPurchasesQueryError = ErrorType<unknown>


/**
 * @summary Get lead purchase history
 */

export function useGetLeadPurchases<TData = Awaited<ReturnType<typeof getLeadPurchases>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLeadPurchases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLeadPurchasesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSavedItemsUrl = (params?: GetSavedItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/saved?${stringifiedParams}` : `/api/saved`
}

/**
 * @summary Get saved items
 */
export const getSavedItems = async (params?: GetSavedItemsParams, options?: RequestInit): Promise<SavedItemListResponse> => {

  return customFetch<SavedItemListResponse>(getGetSavedItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSavedItemsQueryKey = (params?: GetSavedItemsParams,) => {
    return [
    `/api/saved`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSavedItemsQueryOptions = <TData = Awaited<ReturnType<typeof getSavedItems>>, TError = ErrorType<unknown>>(params?: GetSavedItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSavedItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSavedItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedItems>>> = ({ signal }) => getSavedItems(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSavedItems>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSavedItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedItems>>>
export type GetSavedItemsQueryError = ErrorType<unknown>


/**
 * @summary Get saved items
 */

export function useGetSavedItems<TData = Awaited<ReturnType<typeof getSavedItems>>, TError = ErrorType<unknown>>(
 params?: GetSavedItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSavedItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSavedItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveItemUrl = () => {




  return `/api/saved`
}

/**
 * @summary Save an item
 */
export const saveItem = async (saveItemInput: SaveItemInput, options?: RequestInit): Promise<SavedItem> => {

  return customFetch<SavedItem>(getSaveItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveItemInput)
  }
);}




export const getSaveItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveItem>>, TError,{data: BodyType<SaveItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveItem>>, TError,{data: BodyType<SaveItemInput>}, TContext> => {

const mutationKey = ['saveItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveItem>>, {data: BodyType<SaveItemInput>}> = (props) => {
          const {data} = props ?? {};

          return  saveItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveItemMutationResult = NonNullable<Awaited<ReturnType<typeof saveItem>>>
    export type SaveItemMutationBody = BodyType<SaveItemInput>
    export type SaveItemMutationError = ErrorType<unknown>

    /**
 * @summary Save an item
 */
export const useSaveItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveItem>>, TError,{data: BodyType<SaveItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveItem>>,
        TError,
        {data: BodyType<SaveItemInput>},
        TContext
      > => {
      return useMutation(getSaveItemMutationOptions(options));
    }

export const getDeleteSavedItemUrl = (id: number,) => {




  return `/api/saved/${id}`
}

/**
 * @summary Remove saved item
 */
export const deleteSavedItem = async (id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteSavedItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSavedItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSavedItem>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSavedItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSavedItem>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSavedItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSavedItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSavedItem>>>

    export type DeleteSavedItemMutationError = ErrorType<unknown>

    /**
 * @summary Remove saved item
 */
export const useDeleteSavedItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSavedItem>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSavedItemMutationOptions(options));
    }

export const getGetNotificationsUrl = () => {




  return `/api/notifications`
}

/**
 * @summary Get user notifications
 */
export const getNotifications = async ( options?: RequestInit): Promise<NotificationListResponse> => {

  return customFetch<NotificationListResponse>(getGetNotificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNotificationsQueryKey = () => {
    return [
    `/api/notifications`
    ] as const;
    }


export const getGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getNotifications>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = ErrorType<unknown>


/**
 * @summary Get user notifications
 */

export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNotificationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMarkNotificationReadUrl = (id: number,) => {




  return `/api/notifications/${id}/read`
}

/**
 * @summary Mark notification as read
 */
export const markNotificationRead = async (id: number, options?: RequestInit): Promise<Notification> => {

  return customFetch<Notification>(getMarkNotificationReadUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getMarkNotificationReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext> => {

const mutationKey = ['markNotificationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markNotificationRead(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>

    export type MarkNotificationReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark notification as read
 */
export const useMarkNotificationRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationRead>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkNotificationReadMutationOptions(options));
    }

export const getMarkAllNotificationsReadUrl = () => {




  return `/api/notifications/read-all`
}

/**
 * @summary Mark all notifications read
 */
export const markAllNotificationsRead = async ( options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getMarkAllNotificationsReadUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getMarkAllNotificationsReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext> => {

const mutationKey = ['markAllNotificationsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllNotificationsRead>>, void> = () => {


          return  markAllNotificationsRead(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllNotificationsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationsRead>>>

    export type MarkAllNotificationsReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark all notifications read
 */
export const useMarkAllNotificationsRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markAllNotificationsRead>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkAllNotificationsReadMutationOptions(options));
    }

export const getGetAdminStatsUrl = () => {




  return `/api/admin/stats`
}

/**
 * @summary Admin overview stats
 */
export const getAdminStats = async ( options?: RequestInit): Promise<AdminStats> => {

  return customFetch<AdminStats>(getGetAdminStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStatsQueryKey = () => {
    return [
    `/api/admin/stats`
    ] as const;
    }


export const getGetAdminStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStats>>> = ({ signal }) => getAdminStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStats>>>
export type GetAdminStatsQueryError = ErrorType<unknown>


/**
 * @summary Admin overview stats
 */

export function useGetAdminStats<TData = Awaited<ReturnType<typeof getAdminStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminActivityHistoryUrl = () => {




  return `/api/admin/activity-history`
}

/**
 * @summary Hourly web/mobile active user counts for the last 24h
 */
export const getAdminActivityHistory = async ( options?: RequestInit): Promise<ActivityHistoryPoint[]> => {

  return customFetch<ActivityHistoryPoint[]>(getGetAdminActivityHistoryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminActivityHistoryQueryKey = () => {
    return [
    `/api/admin/activity-history`
    ] as const;
    }


export const getGetAdminActivityHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminActivityHistory>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminActivityHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminActivityHistoryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminActivityHistory>>> = ({ signal }) => getAdminActivityHistory({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminActivityHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminActivityHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminActivityHistory>>>
export type GetAdminActivityHistoryQueryError = ErrorType<unknown>


/**
 * @summary Hourly web/mobile active user counts for the last 24h
 */

export function useGetAdminActivityHistory<TData = Awaited<ReturnType<typeof getAdminActivityHistory>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminActivityHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminActivityHistoryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminGrowthHistoryUrl = (params?: GetAdminGrowthHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/growth-history?${stringifiedParams}` : `/api/admin/growth-history`
}

/**
 * @summary Daily user and non-cancelled order growth
 */
export const getAdminGrowthHistory = async (params?: GetAdminGrowthHistoryParams, options?: RequestInit): Promise<GrowthHistoryResponse> => {

  return customFetch<GrowthHistoryResponse>(getGetAdminGrowthHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminGrowthHistoryQueryKey = (params?: GetAdminGrowthHistoryParams,) => {
    return [
    `/api/admin/growth-history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminGrowthHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminGrowthHistory>>, TError = ErrorType<unknown>>(params?: GetAdminGrowthHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowthHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminGrowthHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminGrowthHistory>>> = ({ signal }) => getAdminGrowthHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowthHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminGrowthHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminGrowthHistory>>>
export type GetAdminGrowthHistoryQueryError = ErrorType<unknown>


/**
 * @summary Daily user and non-cancelled order growth
 */

export function useGetAdminGrowthHistory<TData = Awaited<ReturnType<typeof getAdminGrowthHistory>>, TError = ErrorType<unknown>>(
 params?: GetAdminGrowthHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowthHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminGrowthHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminUsersUrl = (params?: GetAdminUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/users?${stringifiedParams}` : `/api/admin/users`
}

/**
 * @summary Admin list users
 */
export const getAdminUsers = async (params?: GetAdminUsersParams, options?: RequestInit): Promise<UserListResponse> => {

  return customFetch<UserListResponse>(getGetAdminUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminUsersQueryKey = (params?: GetAdminUsersParams,) => {
    return [
    `/api/admin/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ErrorType<unknown>>(params?: GetAdminUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsers>>> = ({ signal }) => getAdminUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsers>>>
export type GetAdminUsersQueryError = ErrorType<unknown>


/**
 * @summary Admin list users
 */

export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ErrorType<unknown>>(
 params?: GetAdminUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (requestUploadUrlBody: RequestUploadUrlBody, options?: RequestInit): Promise<RequestUploadUrlResponse> => {

  return customFetch<RequestUploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestUploadUrlBody)
  }
);}




export const getRequestUploadUrlMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<RequestUploadUrlBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<RequestUploadUrlBody>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<RequestUploadUrlBody>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<RequestUploadUrlBody>
    export type RequestUploadUrlMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<RequestUploadUrlBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<RequestUploadUrlBody>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getFinalizeUploadUrl = () => {




  return `/api/storage/uploads/finalize`
}

/**
 * Must be called after a successful PUT to the presigned URL obtained from
 * /storage/uploads/request-url. Supplies the signed finalizeToken returned
 * by that endpoint. The server verifies the token, ensures the object has
 * not already been finalized, and sets an ACL binding the object to the
 * uploading user. Until finalized the object cannot be served.
 * @summary Finalize an upload and bind ownership ACL
 */
export const finalizeUpload = async (finalizeUploadBody: FinalizeUploadBody, options?: RequestInit): Promise<FinalizeUploadResponse> => {

  return customFetch<FinalizeUploadResponse>(getFinalizeUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(finalizeUploadBody)
  }
);}




export const getFinalizeUploadMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizeUpload>>, TError,{data: BodyType<FinalizeUploadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finalizeUpload>>, TError,{data: BodyType<FinalizeUploadBody>}, TContext> => {

const mutationKey = ['finalizeUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finalizeUpload>>, {data: BodyType<FinalizeUploadBody>}> = (props) => {
          const {data} = props ?? {};

          return  finalizeUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinalizeUploadMutationResult = NonNullable<Awaited<ReturnType<typeof finalizeUpload>>>
    export type FinalizeUploadMutationBody = BodyType<FinalizeUploadBody>
    export type FinalizeUploadMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Finalize an upload and bind ownership ACL
 */
export const useFinalizeUpload = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizeUpload>>, TError,{data: BodyType<FinalizeUploadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof finalizeUpload>>,
        TError,
        {data: BodyType<FinalizeUploadBody>},
        TContext
      > => {
      return useMutation(getFinalizeUploadMutationOptions(options));
    }

export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve an uploaded object
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorResponse>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorResponse>


/**
 * @summary Serve an uploaded object
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorResponse>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListFreeItemsUrl = (params?: ListFreeItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/free-items?${stringifiedParams}` : `/api/free-items`
}

/**
 * @summary List available free items
 */
export const listFreeItems = async (params?: ListFreeItemsParams, options?: RequestInit): Promise<FreeItemListResponse> => {

  return customFetch<FreeItemListResponse>(getListFreeItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFreeItemsQueryKey = (params?: ListFreeItemsParams,) => {
    return [
    `/api/free-items`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFreeItemsQueryOptions = <TData = Awaited<ReturnType<typeof listFreeItems>>, TError = ErrorType<unknown>>(params?: ListFreeItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFreeItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFreeItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFreeItems>>> = ({ signal }) => listFreeItems(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFreeItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFreeItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listFreeItems>>>
export type ListFreeItemsQueryError = ErrorType<unknown>


/**
 * @summary List available free items
 */

export function useListFreeItems<TData = Awaited<ReturnType<typeof listFreeItems>>, TError = ErrorType<unknown>>(
 params?: ListFreeItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFreeItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFreeItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateFreeItemUrl = () => {




  return `/api/free-items`
}

/**
 * @summary Post a free item
 */
export const createFreeItem = async (freeItemInput: FreeItemInput, options?: RequestInit): Promise<FreeItem> => {

  return customFetch<FreeItem>(getCreateFreeItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(freeItemInput)
  }
);}




export const getCreateFreeItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFreeItem>>, TError,{data: BodyType<FreeItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFreeItem>>, TError,{data: BodyType<FreeItemInput>}, TContext> => {

const mutationKey = ['createFreeItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFreeItem>>, {data: BodyType<FreeItemInput>}> = (props) => {
          const {data} = props ?? {};

          return  createFreeItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFreeItemMutationResult = NonNullable<Awaited<ReturnType<typeof createFreeItem>>>
    export type CreateFreeItemMutationBody = BodyType<FreeItemInput>
    export type CreateFreeItemMutationError = ErrorType<unknown>

    /**
 * @summary Post a free item
 */
export const useCreateFreeItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFreeItem>>, TError,{data: BodyType<FreeItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFreeItem>>,
        TError,
        {data: BodyType<FreeItemInput>},
        TContext
      > => {
      return useMutation(getCreateFreeItemMutationOptions(options));
    }

export const getGetMyFreeItemsUrl = () => {




  return `/api/free-items/mine`
}

/**
 * @summary Get the current user's free item listings
 */
export const getMyFreeItems = async ( options?: RequestInit): Promise<FreeItemListResponse> => {

  return customFetch<FreeItemListResponse>(getGetMyFreeItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyFreeItemsQueryKey = () => {
    return [
    `/api/free-items/mine`
    ] as const;
    }


export const getGetMyFreeItemsQueryOptions = <TData = Awaited<ReturnType<typeof getMyFreeItems>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyFreeItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyFreeItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyFreeItems>>> = ({ signal }) => getMyFreeItems({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyFreeItems>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyFreeItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyFreeItems>>>
export type GetMyFreeItemsQueryError = ErrorType<unknown>


/**
 * @summary Get the current user's free item listings
 */

export function useGetMyFreeItems<TData = Awaited<ReturnType<typeof getMyFreeItems>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyFreeItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyFreeItemsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteFreeItemUrl = (id: number,) => {




  return `/api/free-items/${id}`
}

/**
 * @summary Delete a free item (owner or admin only)
 */
export const deleteFreeItem = async (id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteFreeItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteFreeItemMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFreeItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFreeItem>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteFreeItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFreeItem>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteFreeItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFreeItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFreeItem>>>

    export type DeleteFreeItemMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a free item (owner or admin only)
 */
export const useDeleteFreeItem = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFreeItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteFreeItem>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteFreeItemMutationOptions(options));
    }

export const getSponsorFreeItemUrl = (id: number,) => {




  return `/api/free-items/${id}/sponsor`
}

/**
 * @summary Boost a marketplace (free / for-sale) item
 */
export const sponsorFreeItem = async (id: number,
    sponsorFreeItemBody: SponsorFreeItemBody, options?: RequestInit): Promise<FreeItem> => {

  return customFetch<FreeItem>(getSponsorFreeItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sponsorFreeItemBody)
  }
);}




export const getSponsorFreeItemMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sponsorFreeItem>>, TError,{id: number;data: BodyType<SponsorFreeItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sponsorFreeItem>>, TError,{id: number;data: BodyType<SponsorFreeItemBody>}, TContext> => {

const mutationKey = ['sponsorFreeItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sponsorFreeItem>>, {id: number;data: BodyType<SponsorFreeItemBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  sponsorFreeItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SponsorFreeItemMutationResult = NonNullable<Awaited<ReturnType<typeof sponsorFreeItem>>>
    export type SponsorFreeItemMutationBody = BodyType<SponsorFreeItemBody>
    export type SponsorFreeItemMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Boost a marketplace (free / for-sale) item
 */
export const useSponsorFreeItem = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sponsorFreeItem>>, TError,{id: number;data: BodyType<SponsorFreeItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sponsorFreeItem>>,
        TError,
        {id: number;data: BodyType<SponsorFreeItemBody>},
        TContext
      > => {
      return useMutation(getSponsorFreeItemMutationOptions(options));
    }

export const getMarkFreeItemCollectedUrl = (id: number,) => {




  return `/api/free-items/${id}/collected`
}

/**
 * @summary Mark a free item as collected
 */
export const markFreeItemCollected = async (id: number, options?: RequestInit): Promise<FreeItem> => {

  return customFetch<FreeItem>(getMarkFreeItemCollectedUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getMarkFreeItemCollectedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markFreeItemCollected>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markFreeItemCollected>>, TError,{id: number}, TContext> => {

const mutationKey = ['markFreeItemCollected'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markFreeItemCollected>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markFreeItemCollected(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkFreeItemCollectedMutationResult = NonNullable<Awaited<ReturnType<typeof markFreeItemCollected>>>

    export type MarkFreeItemCollectedMutationError = ErrorType<unknown>

    /**
 * @summary Mark a free item as collected
 */
export const useMarkFreeItemCollected = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markFreeItemCollected>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markFreeItemCollected>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkFreeItemCollectedMutationOptions(options));
    }

export const getGetFreeItemConversationsUrl = (id: number,) => {




  return `/api/free-items/${id}/conversations`
}

/**
 * @summary Get conversations for a free item (poster only)
 */
export const getFreeItemConversations = async (id: number, options?: RequestInit): Promise<ConversationListResponse> => {

  return customFetch<ConversationListResponse>(getGetFreeItemConversationsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFreeItemConversationsQueryKey = (id: number,) => {
    return [
    `/api/free-items/${id}/conversations`
    ] as const;
    }


export const getGetFreeItemConversationsQueryOptions = <TData = Awaited<ReturnType<typeof getFreeItemConversations>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFreeItemConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFreeItemConversationsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreeItemConversations>>> = ({ signal }) => getFreeItemConversations(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFreeItemConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFreeItemConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof getFreeItemConversations>>>
export type GetFreeItemConversationsQueryError = ErrorType<unknown>


/**
 * @summary Get conversations for a free item (poster only)
 */

export function useGetFreeItemConversations<TData = Awaited<ReturnType<typeof getFreeItemConversations>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFreeItemConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFreeItemConversationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartConversationUrl = (id: number,) => {




  return `/api/free-items/${id}/conversations`
}

/**
 * @summary Start or get a conversation about a free item
 */
export const startConversation = async (id: number, options?: RequestInit): Promise<Conversation> => {

  return customFetch<Conversation>(getStartConversationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStartConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startConversation>>, TError,{id: number}, TContext> => {

const mutationKey = ['startConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startConversation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  startConversation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartConversationMutationResult = NonNullable<Awaited<ReturnType<typeof startConversation>>>

    export type StartConversationMutationError = ErrorType<unknown>

    /**
 * @summary Start or get a conversation about a free item
 */
export const useStartConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startConversation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getStartConversationMutationOptions(options));
    }

export const getUploadMessageImageUrl = () => {




  return `/api/message-images`
}

/**
 * @summary Upload a private screenshot or photo for a message or support request
 */
export const uploadMessageImage = async (uploadMessageImageBody: string, options?: RequestInit): Promise<MessageImageClaim> => {

  return customFetch<MessageImageClaim>(getUploadMessageImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/plain', ...options?.headers },
    body: uploadMessageImageBody
  }
);}




export const getUploadMessageImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMessageImage>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadMessageImage>>, TError,{data: BodyType<string>}, TContext> => {

const mutationKey = ['uploadMessageImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadMessageImage>>, {data: BodyType<string>}> = (props) => {
          const {data} = props ?? {};

          return  uploadMessageImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadMessageImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadMessageImage>>>
    export type UploadMessageImageMutationBody = BodyType<string>
    export type UploadMessageImageMutationError = ErrorType<unknown>

    /**
 * @summary Upload a private screenshot or photo for a message or support request
 */
export const useUploadMessageImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMessageImage>>, TError,{data: BodyType<string>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadMessageImage>>,
        TError,
        {data: BodyType<string>},
        TContext
      > => {
      return useMutation(getUploadMessageImageMutationOptions(options));
    }

export const getGetMessageImageUrl = (id: string,) => {




  return `/api/message-images/${id}`
}

/**
 * @summary Read a private image as a participant or authorised support staff
 */
export const getMessageImage = async (id: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetMessageImageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessageImageQueryKey = (id: string,) => {
    return [
    `/api/message-images/${id}`
    ] as const;
    }


export const getGetMessageImageQueryOptions = <TData = Awaited<ReturnType<typeof getMessageImage>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessageImage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessageImageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessageImage>>> = ({ signal }) => getMessageImage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessageImage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMessageImageQueryResult = NonNullable<Awaited<ReturnType<typeof getMessageImage>>>
export type GetMessageImageQueryError = ErrorType<void>


/**
 * @summary Read a private image as a participant or authorised support staff
 */

export function useGetMessageImage<TData = Awaited<ReturnType<typeof getMessageImage>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessageImage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMessageImageQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMessagesUrl = (conversationId: number,) => {




  return `/api/conversations/${conversationId}/messages`
}

/**
 * @summary Get messages in a conversation
 */
export const getMessages = async (conversationId: number, options?: RequestInit): Promise<MessageListResponse> => {

  return customFetch<MessageListResponse>(getGetMessagesUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagesQueryKey = (conversationId: number,) => {
    return [
    `/api/conversations/${conversationId}/messages`
    ] as const;
    }


export const getGetMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(conversationId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessages>>> = ({ signal }) => getMessages(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getMessages>>>
export type GetMessagesQueryError = ErrorType<unknown>


/**
 * @summary Get messages in a conversation
 */

export function useGetMessages<TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(
 conversationId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMessagesQueryOptions(conversationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendMessageUrl = (conversationId: number,) => {




  return `/api/conversations/${conversationId}/messages`
}

/**
 * @summary Send a message in a conversation
 */
export const sendMessage = async (conversationId: number,
    sendMessageInput: SendMessageInput, options?: RequestInit): Promise<ChatMessage> => {

  return customFetch<ChatMessage>(getSendMessageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendMessageInput)
  }
);}




export const getSendMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: number;data: BodyType<SendMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: number;data: BodyType<SendMessageInput>}, TContext> => {

const mutationKey = ['sendMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMessage>>, {conversationId: number;data: BodyType<SendMessageInput>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  sendMessage(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendMessage>>>
    export type SendMessageMutationBody = BodyType<SendMessageInput>
    export type SendMessageMutationError = ErrorType<unknown>

    /**
 * @summary Send a message in a conversation
 */
export const useSendMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: number;data: BodyType<SendMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendMessage>>,
        TError,
        {conversationId: number;data: BodyType<SendMessageInput>},
        TContext
      > => {
      return useMutation(getSendMessageMutationOptions(options));
    }

export const getGetMyConversationsUrl = () => {




  return `/api/my-conversations`
}

/**
 * @summary Get all conversations for the current user
 */
export const getMyConversations = async ( options?: RequestInit): Promise<ConversationListResponse> => {

  return customFetch<ConversationListResponse>(getGetMyConversationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyConversationsQueryKey = () => {
    return [
    `/api/my-conversations`
    ] as const;
    }


export const getGetMyConversationsQueryOptions = <TData = Awaited<ReturnType<typeof getMyConversations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyConversationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyConversations>>> = ({ signal }) => getMyConversations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyConversations>>>
export type GetMyConversationsQueryError = ErrorType<unknown>


/**
 * @summary Get all conversations for the current user
 */

export function useGetMyConversations<TData = Awaited<ReturnType<typeof getMyConversations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyConversationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRegisterPushTokenUrl = () => {




  return `/api/push-tokens`
}

/**
 * @summary Register an Expo push token
 */
export const registerPushToken = async (pushTokenInput: PushTokenInput, options?: RequestInit): Promise<PushToken> => {

  return customFetch<PushToken>(getRegisterPushTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushTokenInput)
  }
);}




export const getRegisterPushTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPushToken>>, TError,{data: BodyType<PushTokenInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerPushToken>>, TError,{data: BodyType<PushTokenInput>}, TContext> => {

const mutationKey = ['registerPushToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerPushToken>>, {data: BodyType<PushTokenInput>}> = (props) => {
          const {data} = props ?? {};

          return  registerPushToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterPushTokenMutationResult = NonNullable<Awaited<ReturnType<typeof registerPushToken>>>
    export type RegisterPushTokenMutationBody = BodyType<PushTokenInput>
    export type RegisterPushTokenMutationError = ErrorType<unknown>

    /**
 * @summary Register an Expo push token
 */
export const useRegisterPushToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPushToken>>, TError,{data: BodyType<PushTokenInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerPushToken>>,
        TError,
        {data: BodyType<PushTokenInput>},
        TContext
      > => {
      return useMutation(getRegisterPushTokenMutationOptions(options));
    }

export const getGetAdminTransactionsUrl = (params?: GetAdminTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/transactions?${stringifiedParams}` : `/api/admin/transactions`
}

/**
 * @summary Get all platform transactions (lead unlocks, deal listings, event listings)
 */
export const getAdminTransactions = async (params?: GetAdminTransactionsParams, options?: RequestInit): Promise<GetAdminTransactions200> => {

  return customFetch<GetAdminTransactions200>(getGetAdminTransactionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminTransactionsQueryKey = (params?: GetAdminTransactionsParams,) => {
    return [
    `/api/admin/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTransactions>>, TError = ErrorType<unknown>>(params?: GetAdminTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTransactions>>> = ({ signal }) => getAdminTransactions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTransactions>>>
export type GetAdminTransactionsQueryError = ErrorType<unknown>


/**
 * @summary Get all platform transactions (lead unlocks, deal listings, event listings)
 */

export function useGetAdminTransactions<TData = Awaited<ReturnType<typeof getAdminTransactions>>, TError = ErrorType<unknown>>(
 params?: GetAdminTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminDealRedemptionsUrl = (params?: GetAdminDealRedemptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/deal-redemptions?${stringifiedParams}` : `/api/admin/deal-redemptions`
}

/**
 * @summary Get all deal redemptions with user and deal info
 */
export const getAdminDealRedemptions = async (params?: GetAdminDealRedemptionsParams, options?: RequestInit): Promise<GetAdminDealRedemptions200> => {

  return customFetch<GetAdminDealRedemptions200>(getGetAdminDealRedemptionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminDealRedemptionsQueryKey = (params?: GetAdminDealRedemptionsParams,) => {
    return [
    `/api/admin/deal-redemptions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminDealRedemptionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDealRedemptions>>, TError = ErrorType<unknown>>(params?: GetAdminDealRedemptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDealRedemptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDealRedemptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDealRedemptions>>> = ({ signal }) => getAdminDealRedemptions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDealRedemptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminDealRedemptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDealRedemptions>>>
export type GetAdminDealRedemptionsQueryError = ErrorType<unknown>


/**
 * @summary Get all deal redemptions with user and deal info
 */

export function useGetAdminDealRedemptions<TData = Awaited<ReturnType<typeof getAdminDealRedemptions>>, TError = ErrorType<unknown>>(
 params?: GetAdminDealRedemptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDealRedemptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminDealRedemptionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminPendingUrl = () => {




  return `/api/admin/pending`
}

/**
 * @summary Get all pending approval items
 */
export const getAdminPending = async ( options?: RequestInit): Promise<AdminPendingResponse> => {

  return customFetch<AdminPendingResponse>(getGetAdminPendingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminPendingQueryKey = () => {
    return [
    `/api/admin/pending`
    ] as const;
    }


export const getGetAdminPendingQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPending>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPending>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPendingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPending>>> = ({ signal }) => getAdminPending({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPending>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminPendingQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPending>>>
export type GetAdminPendingQueryError = ErrorType<unknown>


/**
 * @summary Get all pending approval items
 */

export function useGetAdminPending<TData = Awaited<ReturnType<typeof getAdminPending>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPending>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminPendingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApproveContentUrl = (type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs',
    id: number,) => {




  return `/api/admin/content/${type}/${id}/approve`
}

/**
 * @summary Approve a content item
 */
export const approveContent = async (type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs',
    id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getApproveContentUrl(type,id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getApproveContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveContent>>, TError,{type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveContent>>, TError,{type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number}, TContext> => {

const mutationKey = ['approveContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveContent>>, {type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number}> = (props) => {
          const {type,id} = props ?? {};

          return  approveContent(type,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveContentMutationResult = NonNullable<Awaited<ReturnType<typeof approveContent>>>

    export type ApproveContentMutationError = ErrorType<unknown>

    /**
 * @summary Approve a content item
 */
export const useApproveContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveContent>>, TError,{type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveContent>>,
        TError,
        {type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number},
        TContext
      > => {
      return useMutation(getApproveContentMutationOptions(options));
    }

export const getRejectContentUrl = (type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs',
    id: number,) => {




  return `/api/admin/content/${type}/${id}/reject`
}

/**
 * @summary Reject and remove a content item
 */
export const rejectContent = async (type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs',
    id: number, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getRejectContentUrl(type,id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getRejectContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectContent>>, TError,{type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectContent>>, TError,{type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number}, TContext> => {

const mutationKey = ['rejectContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectContent>>, {type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number}> = (props) => {
          const {type,id} = props ?? {};

          return  rejectContent(type,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectContentMutationResult = NonNullable<Awaited<ReturnType<typeof rejectContent>>>

    export type RejectContentMutationError = ErrorType<unknown>

    /**
 * @summary Reject and remove a content item
 */
export const useRejectContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectContent>>, TError,{type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectContent>>,
        TError,
        {type: 'news' | 'events' | 'deals' | 'businesses' | 'reviews' | 'jobs';id: number},
        TContext
      > => {
      return useMutation(getRejectContentMutationOptions(options));
    }

export const getGetAdminUserLoginLogsUrl = (id: number,) => {




  return `/api/admin/users/${id}/login-logs`
}

/**
 * @summary Get login history for a user
 */
export const getAdminUserLoginLogs = async (id: number, options?: RequestInit): Promise<LoginLog[]> => {

  return customFetch<LoginLog[]>(getGetAdminUserLoginLogsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminUserLoginLogsQueryKey = (id: number,) => {
    return [
    `/api/admin/users/${id}/login-logs`
    ] as const;
    }


export const getGetAdminUserLoginLogsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserLoginLogs>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLoginLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserLoginLogsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserLoginLogs>>> = ({ signal }) => getAdminUserLoginLogs(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLoginLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserLoginLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserLoginLogs>>>
export type GetAdminUserLoginLogsQueryError = ErrorType<unknown>


/**
 * @summary Get login history for a user
 */

export function useGetAdminUserLoginLogs<TData = Awaited<ReturnType<typeof getAdminUserLoginLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLoginLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUserLoginLogsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSuspendUserUrl = (id: number,) => {




  return `/api/admin/users/${id}/suspend`
}

/**
 * @summary Suspend or unsuspend a user
 */
export const suspendUser = async (id: number,
    suspendUserBody: SuspendUserBody, options?: RequestInit): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getSuspendUserUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(suspendUserBody)
  }
);}




export const getSuspendUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspendUser>>, TError,{id: number;data: BodyType<SuspendUserBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof suspendUser>>, TError,{id: number;data: BodyType<SuspendUserBody>}, TContext> => {

const mutationKey = ['suspendUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suspendUser>>, {id: number;data: BodyType<SuspendUserBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  suspendUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuspendUserMutationResult = NonNullable<Awaited<ReturnType<typeof suspendUser>>>
    export type SuspendUserMutationBody = BodyType<SuspendUserBody>
    export type SuspendUserMutationError = ErrorType<unknown>

    /**
 * @summary Suspend or unsuspend a user
 */
export const useSuspendUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspendUser>>, TError,{id: number;data: BodyType<SuspendUserBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof suspendUser>>,
        TError,
        {id: number;data: BodyType<SuspendUserBody>},
        TContext
      > => {
      return useMutation(getSuspendUserMutationOptions(options));
    }

export const getSendPushNotificationUrl = () => {




  return `/api/admin/push-notifications/send`
}

/**
 * @summary Send a push notification to users
 */
export const sendPushNotification = async (pushNotificationInput: PushNotificationInput, options?: RequestInit): Promise<PushNotificationResult> => {

  return customFetch<PushNotificationResult>(getSendPushNotificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushNotificationInput)
  }
);}




export const getSendPushNotificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPushNotification>>, TError,{data: BodyType<PushNotificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPushNotification>>, TError,{data: BodyType<PushNotificationInput>}, TContext> => {

const mutationKey = ['sendPushNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPushNotification>>, {data: BodyType<PushNotificationInput>}> = (props) => {
          const {data} = props ?? {};

          return  sendPushNotification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendPushNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendPushNotification>>>
    export type SendPushNotificationMutationBody = BodyType<PushNotificationInput>
    export type SendPushNotificationMutationError = ErrorType<unknown>

    /**
 * @summary Send a push notification to users
 */
export const useSendPushNotification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPushNotification>>, TError,{data: BodyType<PushNotificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendPushNotification>>,
        TError,
        {data: BodyType<PushNotificationInput>},
        TContext
      > => {
      return useMutation(getSendPushNotificationMutationOptions(options));
    }

export const getListJobVacanciesUrl = (params?: ListJobVacanciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-vacancies?${stringifiedParams}` : `/api/job-vacancies`
}

/**
 * @summary List approved job vacancies
 */
export const listJobVacancies = async (params?: ListJobVacanciesParams, options?: RequestInit): Promise<JobVacancyListResponse> => {

  return customFetch<JobVacancyListResponse>(getListJobVacanciesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobVacanciesQueryKey = (params?: ListJobVacanciesParams,) => {
    return [
    `/api/job-vacancies`, ...(params ? [params] : [])
    ] as const;
    }


export const getListJobVacanciesQueryOptions = <TData = Awaited<ReturnType<typeof listJobVacancies>>, TError = ErrorType<unknown>>(params?: ListJobVacanciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listJobVacancies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobVacanciesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobVacancies>>> = ({ signal }) => listJobVacancies(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobVacancies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListJobVacanciesQueryResult = NonNullable<Awaited<ReturnType<typeof listJobVacancies>>>
export type ListJobVacanciesQueryError = ErrorType<unknown>


/**
 * @summary List approved job vacancies
 */

export function useListJobVacancies<TData = Awaited<ReturnType<typeof listJobVacancies>>, TError = ErrorType<unknown>>(
 params?: ListJobVacanciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listJobVacancies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListJobVacanciesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateJobVacancyUrl = () => {




  return `/api/job-vacancies`
}

/**
 * @summary Post a job vacancy
 */
export const createJobVacancy = async (jobVacancyInput: JobVacancyInput, options?: RequestInit): Promise<JobVacancy> => {

  return customFetch<JobVacancy>(getCreateJobVacancyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jobVacancyInput)
  }
);}




export const getCreateJobVacancyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobVacancy>>, TError,{data: BodyType<JobVacancyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createJobVacancy>>, TError,{data: BodyType<JobVacancyInput>}, TContext> => {

const mutationKey = ['createJobVacancy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobVacancy>>, {data: BodyType<JobVacancyInput>}> = (props) => {
          const {data} = props ?? {};

          return  createJobVacancy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobVacancyMutationResult = NonNullable<Awaited<ReturnType<typeof createJobVacancy>>>
    export type CreateJobVacancyMutationBody = BodyType<JobVacancyInput>
    export type CreateJobVacancyMutationError = ErrorType<unknown>

    /**
 * @summary Post a job vacancy
 */
export const useCreateJobVacancy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobVacancy>>, TError,{data: BodyType<JobVacancyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createJobVacancy>>,
        TError,
        {data: BodyType<JobVacancyInput>},
        TContext
      > => {
      return useMutation(getCreateJobVacancyMutationOptions(options));
    }

export const getDeleteJobVacancyUrl = (id: number,) => {




  return `/api/job-vacancies/${id}`
}

/**
 * @summary Delete a job vacancy
 */
export const deleteJobVacancy = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteJobVacancyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteJobVacancyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobVacancy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteJobVacancy>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteJobVacancy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJobVacancy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteJobVacancy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobVacancyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJobVacancy>>>

    export type DeleteJobVacancyMutationError = ErrorType<unknown>

    /**
 * @summary Delete a job vacancy
 */
export const useDeleteJobVacancy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobVacancy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteJobVacancy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteJobVacancyMutationOptions(options));
    }

export const getListSeekerProfilesUrl = (params?: ListSeekerProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/seeker-profiles?${stringifiedParams}` : `/api/seeker-profiles`
}

/**
 * @summary List available seeker profiles
 */
export const listSeekerProfiles = async (params?: ListSeekerProfilesParams, options?: RequestInit): Promise<SeekerProfileListResponse> => {

  return customFetch<SeekerProfileListResponse>(getListSeekerProfilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSeekerProfilesQueryKey = (params?: ListSeekerProfilesParams,) => {
    return [
    `/api/seeker-profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSeekerProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listSeekerProfiles>>, TError = ErrorType<unknown>>(params?: ListSeekerProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSeekerProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSeekerProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSeekerProfiles>>> = ({ signal }) => listSeekerProfiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSeekerProfiles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSeekerProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listSeekerProfiles>>>
export type ListSeekerProfilesQueryError = ErrorType<unknown>


/**
 * @summary List available seeker profiles
 */

export function useListSeekerProfiles<TData = Awaited<ReturnType<typeof listSeekerProfiles>>, TError = ErrorType<unknown>>(
 params?: ListSeekerProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSeekerProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSeekerProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOrUpdateSeekerProfileUrl = () => {




  return `/api/seeker-profiles`
}

/**
 * @summary Create or update own seeker profile
 */
export const createOrUpdateSeekerProfile = async (seekerProfileInput: SeekerProfileInput, options?: RequestInit): Promise<SeekerProfile> => {

  return customFetch<SeekerProfile>(getCreateOrUpdateSeekerProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(seekerProfileInput)
  }
);}




export const getCreateOrUpdateSeekerProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateSeekerProfile>>, TError,{data: BodyType<SeekerProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateSeekerProfile>>, TError,{data: BodyType<SeekerProfileInput>}, TContext> => {

const mutationKey = ['createOrUpdateSeekerProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrUpdateSeekerProfile>>, {data: BodyType<SeekerProfileInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOrUpdateSeekerProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrUpdateSeekerProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createOrUpdateSeekerProfile>>>
    export type CreateOrUpdateSeekerProfileMutationBody = BodyType<SeekerProfileInput>
    export type CreateOrUpdateSeekerProfileMutationError = ErrorType<unknown>

    /**
 * @summary Create or update own seeker profile
 */
export const useCreateOrUpdateSeekerProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrUpdateSeekerProfile>>, TError,{data: BodyType<SeekerProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrUpdateSeekerProfile>>,
        TError,
        {data: BodyType<SeekerProfileInput>},
        TContext
      > => {
      return useMutation(getCreateOrUpdateSeekerProfileMutationOptions(options));
    }

export const getGetMySeekerProfileUrl = () => {




  return `/api/seeker-profiles/mine`
}

/**
 * @summary Get current user's seeker profile
 */
export const getMySeekerProfile = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetMySeekerProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMySeekerProfileQueryKey = () => {
    return [
    `/api/seeker-profiles/mine`
    ] as const;
    }


export const getGetMySeekerProfileQueryOptions = <TData = Awaited<ReturnType<typeof getMySeekerProfile>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMySeekerProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMySeekerProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMySeekerProfile>>> = ({ signal }) => getMySeekerProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMySeekerProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMySeekerProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMySeekerProfile>>>
export type GetMySeekerProfileQueryError = ErrorType<unknown>


/**
 * @summary Get current user's seeker profile
 */

export function useGetMySeekerProfile<TData = Awaited<ReturnType<typeof getMySeekerProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMySeekerProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMySeekerProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSeekerAvailabilityUrl = () => {




  return `/api/seeker-profiles/mine/availability`
}

/**
 * @summary Toggle availability
 */
export const updateSeekerAvailability = async (updateSeekerAvailabilityBody: UpdateSeekerAvailabilityBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateSeekerAvailabilityUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSeekerAvailabilityBody)
  }
);}




export const getUpdateSeekerAvailabilityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSeekerAvailability>>, TError,{data: BodyType<UpdateSeekerAvailabilityBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSeekerAvailability>>, TError,{data: BodyType<UpdateSeekerAvailabilityBody>}, TContext> => {

const mutationKey = ['updateSeekerAvailability'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSeekerAvailability>>, {data: BodyType<UpdateSeekerAvailabilityBody>}> = (props) => {
          const {data} = props ?? {};

          return  updateSeekerAvailability(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSeekerAvailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof updateSeekerAvailability>>>
    export type UpdateSeekerAvailabilityMutationBody = BodyType<UpdateSeekerAvailabilityBody>
    export type UpdateSeekerAvailabilityMutationError = ErrorType<unknown>

    /**
 * @summary Toggle availability
 */
export const useUpdateSeekerAvailability = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSeekerAvailability>>, TError,{data: BodyType<UpdateSeekerAvailabilityBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSeekerAvailability>>,
        TError,
        {data: BodyType<UpdateSeekerAvailabilityBody>},
        TContext
      > => {
      return useMutation(getUpdateSeekerAvailabilityMutationOptions(options));
    }

export const getListTransportStationsUrl = () => {




  return `/api/transport/stations`
}

/**
 * @summary List Ayrshire train stations
 */
export const listTransportStations = async ( options?: RequestInit): Promise<ListTransportStations200> => {

  return customFetch<ListTransportStations200>(getListTransportStationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTransportStationsQueryKey = () => {
    return [
    `/api/transport/stations`
    ] as const;
    }


export const getListTransportStationsQueryOptions = <TData = Awaited<ReturnType<typeof listTransportStations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTransportStations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTransportStationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTransportStations>>> = ({ signal }) => listTransportStations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTransportStations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTransportStationsQueryResult = NonNullable<Awaited<ReturnType<typeof listTransportStations>>>
export type ListTransportStationsQueryError = ErrorType<unknown>


/**
 * @summary List Ayrshire train stations
 */

export function useListTransportStations<TData = Awaited<ReturnType<typeof listTransportStations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTransportStations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTransportStationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTransportDeparturesUrl = (params: GetTransportDeparturesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/transport/departures?${stringifiedParams}` : `/api/transport/departures`
}

/**
 * @summary Live train departures for a station
 */
export const getTransportDepartures = async (params: GetTransportDeparturesParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetTransportDeparturesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTransportDeparturesQueryKey = (params?: GetTransportDeparturesParams,) => {
    return [
    `/api/transport/departures`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTransportDeparturesQueryOptions = <TData = Awaited<ReturnType<typeof getTransportDepartures>>, TError = ErrorType<unknown>>(params: GetTransportDeparturesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTransportDepartures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransportDeparturesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransportDepartures>>> = ({ signal }) => getTransportDepartures(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransportDepartures>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTransportDeparturesQueryResult = NonNullable<Awaited<ReturnType<typeof getTransportDepartures>>>
export type GetTransportDeparturesQueryError = ErrorType<unknown>


/**
 * @summary Live train departures for a station
 */

export function useGetTransportDepartures<TData = Awaited<ReturnType<typeof getTransportDepartures>>, TError = ErrorType<unknown>>(
 params: GetTransportDeparturesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTransportDepartures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTransportDeparturesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOrderCategoriesUrl = () => {




  return `/api/order/categories`
}

/**
 * @summary Get active order categories
 */
export const getOrderCategories = async ( options?: RequestInit): Promise<GetOrderCategories200> => {

  return customFetch<GetOrderCategories200>(getGetOrderCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderCategoriesQueryKey = () => {
    return [
    `/api/order/categories`
    ] as const;
    }


export const getGetOrderCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getOrderCategories>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderCategories>>> = ({ signal }) => getOrderCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderCategories>>>
export type GetOrderCategoriesQueryError = ErrorType<unknown>


/**
 * @summary Get active order categories
 */

export function useGetOrderCategories<TData = Awaited<ReturnType<typeof getOrderCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderCategoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOrderStoresUrl = (params?: GetOrderStoresParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/order/stores?${stringifiedParams}` : `/api/order/stores`
}

/**
 * @summary Browse order stores
 */
export const getOrderStores = async (params?: GetOrderStoresParams, options?: RequestInit): Promise<GetOrderStores200> => {

  return customFetch<GetOrderStores200>(getGetOrderStoresUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderStoresQueryKey = (params?: GetOrderStoresParams,) => {
    return [
    `/api/order/stores`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrderStoresQueryOptions = <TData = Awaited<ReturnType<typeof getOrderStores>>, TError = ErrorType<unknown>>(params?: GetOrderStoresParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderStores>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderStoresQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderStores>>> = ({ signal }) => getOrderStores(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderStores>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderStoresQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderStores>>>
export type GetOrderStoresQueryError = ErrorType<unknown>


/**
 * @summary Browse order stores
 */

export function useGetOrderStores<TData = Awaited<ReturnType<typeof getOrderStores>>, TError = ErrorType<unknown>>(
 params?: GetOrderStoresParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderStores>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderStoresQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOrderStoreUrl = () => {




  return `/api/order/stores`
}

/**
 * @summary Create a new order store
 */
export const createOrderStore = async (createOrderStoreInput: CreateOrderStoreInput, options?: RequestInit): Promise<OrderStore> => {

  return customFetch<OrderStore>(getCreateOrderStoreUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrderStoreInput)
  }
);}




export const getCreateOrderStoreMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderStore>>, TError,{data: BodyType<CreateOrderStoreInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderStore>>, TError,{data: BodyType<CreateOrderStoreInput>}, TContext> => {

const mutationKey = ['createOrderStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderStore>>, {data: BodyType<CreateOrderStoreInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOrderStore(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderStoreMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderStore>>>
    export type CreateOrderStoreMutationBody = BodyType<CreateOrderStoreInput>
    export type CreateOrderStoreMutationError = ErrorType<unknown>

    /**
 * @summary Create a new order store
 */
export const useCreateOrderStore = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderStore>>, TError,{data: BodyType<CreateOrderStoreInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrderStore>>,
        TError,
        {data: BodyType<CreateOrderStoreInput>},
        TContext
      > => {
      return useMutation(getCreateOrderStoreMutationOptions(options));
    }

export const getGetMyOrderStoresUrl = () => {




  return `/api/order/my-stores`
}

/**
 * @summary Get current user's stores (owned + staff)
 */
export const getMyOrderStores = async ( options?: RequestInit): Promise<GetMyOrderStores200> => {

  return customFetch<GetMyOrderStores200>(getGetMyOrderStoresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyOrderStoresQueryKey = () => {
    return [
    `/api/order/my-stores`
    ] as const;
    }


export const getGetMyOrderStoresQueryOptions = <TData = Awaited<ReturnType<typeof getMyOrderStores>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyOrderStores>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyOrderStoresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyOrderStores>>> = ({ signal }) => getMyOrderStores({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyOrderStores>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyOrderStoresQueryResult = NonNullable<Awaited<ReturnType<typeof getMyOrderStores>>>
export type GetMyOrderStoresQueryError = ErrorType<unknown>


/**
 * @summary Get current user's stores (owned + staff)
 */

export function useGetMyOrderStores<TData = Awaited<ReturnType<typeof getMyOrderStores>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyOrderStores>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyOrderStoresQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOrderStoreStaffUrl = (id: number,) => {




  return `/api/order/stores/${id}/staff`
}

/**
 * @summary List staff for a store
 */
export const getOrderStoreStaff = async (id: number, options?: RequestInit): Promise<GetOrderStoreStaff200> => {

  return customFetch<GetOrderStoreStaff200>(getGetOrderStoreStaffUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderStoreStaffQueryKey = (id: number,) => {
    return [
    `/api/order/stores/${id}/staff`
    ] as const;
    }


export const getGetOrderStoreStaffQueryOptions = <TData = Awaited<ReturnType<typeof getOrderStoreStaff>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderStoreStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderStoreStaffQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderStoreStaff>>> = ({ signal }) => getOrderStoreStaff(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderStoreStaff>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderStoreStaffQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderStoreStaff>>>
export type GetOrderStoreStaffQueryError = ErrorType<unknown>


/**
 * @summary List staff for a store
 */

export function useGetOrderStoreStaff<TData = Awaited<ReturnType<typeof getOrderStoreStaff>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderStoreStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderStoreStaffQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getInviteOrderStoreStaffUrl = (id: number,) => {




  return `/api/order/stores/${id}/staff/invite`
}

/**
 * @summary Invite a staff member by email
 */
export const inviteOrderStoreStaff = async (id: number,
    inviteOrderStoreStaffBody: InviteOrderStoreStaffBody, options?: RequestInit): Promise<StoreStaff> => {

  return customFetch<StoreStaff>(getInviteOrderStoreStaffUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inviteOrderStoreStaffBody)
  }
);}




export const getInviteOrderStoreStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOrderStoreStaff>>, TError,{id: number;data: BodyType<InviteOrderStoreStaffBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteOrderStoreStaff>>, TError,{id: number;data: BodyType<InviteOrderStoreStaffBody>}, TContext> => {

const mutationKey = ['inviteOrderStoreStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteOrderStoreStaff>>, {id: number;data: BodyType<InviteOrderStoreStaffBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  inviteOrderStoreStaff(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteOrderStoreStaffMutationResult = NonNullable<Awaited<ReturnType<typeof inviteOrderStoreStaff>>>
    export type InviteOrderStoreStaffMutationBody = BodyType<InviteOrderStoreStaffBody>
    export type InviteOrderStoreStaffMutationError = ErrorType<unknown>

    /**
 * @summary Invite a staff member by email
 */
export const useInviteOrderStoreStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOrderStoreStaff>>, TError,{id: number;data: BodyType<InviteOrderStoreStaffBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof inviteOrderStoreStaff>>,
        TError,
        {id: number;data: BodyType<InviteOrderStoreStaffBody>},
        TContext
      > => {
      return useMutation(getInviteOrderStoreStaffMutationOptions(options));
    }

export const getUpdateOrderStoreStaffUrl = (id: number,
    staffId: number,) => {




  return `/api/order/stores/${id}/staff/${staffId}`
}

/**
 * @summary Change a staff member's role
 */
export const updateOrderStoreStaff = async (id: number,
    staffId: number,
    updateOrderStoreStaffBody: UpdateOrderStoreStaffBody, options?: RequestInit): Promise<StoreStaff> => {

  return customFetch<StoreStaff>(getUpdateOrderStoreStaffUrl(id,staffId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOrderStoreStaffBody)
  }
);}




export const getUpdateOrderStoreStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderStoreStaff>>, TError,{id: number;staffId: number;data: BodyType<UpdateOrderStoreStaffBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrderStoreStaff>>, TError,{id: number;staffId: number;data: BodyType<UpdateOrderStoreStaffBody>}, TContext> => {

const mutationKey = ['updateOrderStoreStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrderStoreStaff>>, {id: number;staffId: number;data: BodyType<UpdateOrderStoreStaffBody>}> = (props) => {
          const {id,staffId,data} = props ?? {};

          return  updateOrderStoreStaff(id,staffId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderStoreStaffMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrderStoreStaff>>>
    export type UpdateOrderStoreStaffMutationBody = BodyType<UpdateOrderStoreStaffBody>
    export type UpdateOrderStoreStaffMutationError = ErrorType<unknown>

    /**
 * @summary Change a staff member's role
 */
export const useUpdateOrderStoreStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderStoreStaff>>, TError,{id: number;staffId: number;data: BodyType<UpdateOrderStoreStaffBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrderStoreStaff>>,
        TError,
        {id: number;staffId: number;data: BodyType<UpdateOrderStoreStaffBody>},
        TContext
      > => {
      return useMutation(getUpdateOrderStoreStaffMutationOptions(options));
    }

export const getRemoveOrderStoreStaffUrl = (id: number,
    staffId: number,) => {




  return `/api/order/stores/${id}/staff/${staffId}`
}

/**
 * @summary Remove a staff member
 */
export const removeOrderStoreStaff = async (id: number,
    staffId: number, options?: RequestInit): Promise<RemoveOrderStoreStaff200> => {

  return customFetch<RemoveOrderStoreStaff200>(getRemoveOrderStoreStaffUrl(id,staffId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveOrderStoreStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrderStoreStaff>>, TError,{id: number;staffId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOrderStoreStaff>>, TError,{id: number;staffId: number}, TContext> => {

const mutationKey = ['removeOrderStoreStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrderStoreStaff>>, {id: number;staffId: number}> = (props) => {
          const {id,staffId} = props ?? {};

          return  removeOrderStoreStaff(id,staffId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrderStoreStaffMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrderStoreStaff>>>

    export type RemoveOrderStoreStaffMutationError = ErrorType<unknown>

    /**
 * @summary Remove a staff member
 */
export const useRemoveOrderStoreStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrderStoreStaff>>, TError,{id: number;staffId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeOrderStoreStaff>>,
        TError,
        {id: number;staffId: number},
        TContext
      > => {
      return useMutation(getRemoveOrderStoreStaffMutationOptions(options));
    }

export const getAcceptOrderStoreInviteUrl = () => {




  return `/api/order/staff/accept-invite`
}

/**
 * @summary Accept a staff invite by token
 */
export const acceptOrderStoreInvite = async (acceptOrderStoreInviteBody: AcceptOrderStoreInviteBody, options?: RequestInit): Promise<StoreStaff> => {

  return customFetch<StoreStaff>(getAcceptOrderStoreInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acceptOrderStoreInviteBody)
  }
);}




export const getAcceptOrderStoreInviteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptOrderStoreInvite>>, TError,{data: BodyType<AcceptOrderStoreInviteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptOrderStoreInvite>>, TError,{data: BodyType<AcceptOrderStoreInviteBody>}, TContext> => {

const mutationKey = ['acceptOrderStoreInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptOrderStoreInvite>>, {data: BodyType<AcceptOrderStoreInviteBody>}> = (props) => {
          const {data} = props ?? {};

          return  acceptOrderStoreInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptOrderStoreInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptOrderStoreInvite>>>
    export type AcceptOrderStoreInviteMutationBody = BodyType<AcceptOrderStoreInviteBody>
    export type AcceptOrderStoreInviteMutationError = ErrorType<unknown>

    /**
 * @summary Accept a staff invite by token
 */
export const useAcceptOrderStoreInvite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptOrderStoreInvite>>, TError,{data: BodyType<AcceptOrderStoreInviteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptOrderStoreInvite>>,
        TError,
        {data: BodyType<AcceptOrderStoreInviteBody>},
        TContext
      > => {
      return useMutation(getAcceptOrderStoreInviteMutationOptions(options));
    }

export const getGetOrderStoreUrl = (idOrSlug: string,) => {




  return `/api/order/stores/${idOrSlug}`
}

/**
 * @summary Get store with menu
 */
export const getOrderStore = async (idOrSlug: string, options?: RequestInit): Promise<OrderStoreWithMenu> => {

  return customFetch<OrderStoreWithMenu>(getGetOrderStoreUrl(idOrSlug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderStoreQueryKey = (idOrSlug: string,) => {
    return [
    `/api/order/stores/${idOrSlug}`
    ] as const;
    }


export const getGetOrderStoreQueryOptions = <TData = Awaited<ReturnType<typeof getOrderStore>>, TError = ErrorType<unknown>>(idOrSlug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderStore>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderStoreQueryKey(idOrSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderStore>>> = ({ signal }) => getOrderStore(idOrSlug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: idOrSlug !== null && idOrSlug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderStore>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderStoreQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderStore>>>
export type GetOrderStoreQueryError = ErrorType<unknown>


/**
 * @summary Get store with menu
 */

export function useGetOrderStore<TData = Awaited<ReturnType<typeof getOrderStore>>, TError = ErrorType<unknown>>(
 idOrSlug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderStore>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderStoreQueryOptions(idOrSlug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOrderStoreUrl = (idOrSlug: string,) => {




  return `/api/order/stores/${idOrSlug}`
}

/**
 * @summary Update a store
 */
export const updateOrderStore = async (idOrSlug: string,
    createOrderStoreInput: CreateOrderStoreInput, options?: RequestInit): Promise<OrderStore> => {

  return customFetch<OrderStore>(getUpdateOrderStoreUrl(idOrSlug),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrderStoreInput)
  }
);}




export const getUpdateOrderStoreMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderStore>>, TError,{idOrSlug: string;data: BodyType<CreateOrderStoreInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrderStore>>, TError,{idOrSlug: string;data: BodyType<CreateOrderStoreInput>}, TContext> => {

const mutationKey = ['updateOrderStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrderStore>>, {idOrSlug: string;data: BodyType<CreateOrderStoreInput>}> = (props) => {
          const {idOrSlug,data} = props ?? {};

          return  updateOrderStore(idOrSlug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderStoreMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrderStore>>>
    export type UpdateOrderStoreMutationBody = BodyType<CreateOrderStoreInput>
    export type UpdateOrderStoreMutationError = ErrorType<unknown>

    /**
 * @summary Update a store
 */
export const useUpdateOrderStore = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderStore>>, TError,{idOrSlug: string;data: BodyType<CreateOrderStoreInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrderStore>>,
        TError,
        {idOrSlug: string;data: BodyType<CreateOrderStoreInput>},
        TContext
      > => {
      return useMutation(getUpdateOrderStoreMutationOptions(options));
    }

export const getUploadOrderStoreCoverAnimationUrl = (id: number,) => {




  return `/api/order/stores/${id}/cover-animation`
}

/**
 * @summary Prepare a silent shop-card animation (owner or admin only)
 */
export const uploadOrderStoreCoverAnimation = async (id: number,
    uploadOrderStoreCoverAnimationBody: Blob, options?: RequestInit): Promise<UploadOrderStoreCoverAnimation200> => {

  return customFetch<UploadOrderStoreCoverAnimation200>(getUploadOrderStoreCoverAnimationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'video/mp4', ...options?.headers },
    body: uploadOrderStoreCoverAnimationBody
  }
);}




export const getUploadOrderStoreCoverAnimationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrderStoreCoverAnimation>>, TError,{id: number;data: BodyType<Blob>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadOrderStoreCoverAnimation>>, TError,{id: number;data: BodyType<Blob>}, TContext> => {

const mutationKey = ['uploadOrderStoreCoverAnimation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadOrderStoreCoverAnimation>>, {id: number;data: BodyType<Blob>}> = (props) => {
          const {id,data} = props ?? {};

          return  uploadOrderStoreCoverAnimation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadOrderStoreCoverAnimationMutationResult = NonNullable<Awaited<ReturnType<typeof uploadOrderStoreCoverAnimation>>>
    export type UploadOrderStoreCoverAnimationMutationBody = BodyType<Blob>
    export type UploadOrderStoreCoverAnimationMutationError = ErrorType<void>

    /**
 * @summary Prepare a silent shop-card animation (owner or admin only)
 */
export const useUploadOrderStoreCoverAnimation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrderStoreCoverAnimation>>, TError,{id: number;data: BodyType<Blob>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadOrderStoreCoverAnimation>>,
        TError,
        {id: number;data: BodyType<Blob>},
        TContext
      > => {
      return useMutation(getUploadOrderStoreCoverAnimationMutationOptions(options));
    }

export const getGetStripeConnectUrlUrl = (params: GetStripeConnectUrlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/order/stripe-connect/url?${stringifiedParams}` : `/api/order/stripe-connect/url`
}

/**
 * @summary Get Stripe Connect OAuth URL for a store
 */
export const getStripeConnectUrl = async (params: GetStripeConnectUrlParams, options?: RequestInit): Promise<GetStripeConnectUrl200> => {

  return customFetch<GetStripeConnectUrl200>(getGetStripeConnectUrlUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStripeConnectUrlQueryKey = (params?: GetStripeConnectUrlParams,) => {
    return [
    `/api/order/stripe-connect/url`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStripeConnectUrlQueryOptions = <TData = Awaited<ReturnType<typeof getStripeConnectUrl>>, TError = ErrorType<unknown>>(params: GetStripeConnectUrlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStripeConnectUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStripeConnectUrlQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStripeConnectUrl>>> = ({ signal }) => getStripeConnectUrl(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStripeConnectUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStripeConnectUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getStripeConnectUrl>>>
export type GetStripeConnectUrlQueryError = ErrorType<unknown>


/**
 * @summary Get Stripe Connect OAuth URL for a store
 */

export function useGetStripeConnectUrl<TData = Awaited<ReturnType<typeof getStripeConnectUrl>>, TError = ErrorType<unknown>>(
 params: GetStripeConnectUrlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStripeConnectUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStripeConnectUrlQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMenuSectionsUrl = (id: number,) => {




  return `/api/order/stores/${id}/menu-sections`
}

/**
 * @summary Get menu sections for a store
 */
export const getMenuSections = async (id: number, options?: RequestInit): Promise<GetMenuSections200> => {

  return customFetch<GetMenuSections200>(getGetMenuSectionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMenuSectionsQueryKey = (id: number,) => {
    return [
    `/api/order/stores/${id}/menu-sections`
    ] as const;
    }


export const getGetMenuSectionsQueryOptions = <TData = Awaited<ReturnType<typeof getMenuSections>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMenuSections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMenuSectionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMenuSections>>> = ({ signal }) => getMenuSections(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMenuSections>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMenuSectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMenuSections>>>
export type GetMenuSectionsQueryError = ErrorType<unknown>


/**
 * @summary Get menu sections for a store
 */

export function useGetMenuSections<TData = Awaited<ReturnType<typeof getMenuSections>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMenuSections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMenuSectionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateMenuSectionUrl = (id: number,) => {




  return `/api/order/stores/${id}/menu-sections`
}

/**
 * @summary Create a menu section
 */
export const createMenuSection = async (id: number,
    createMenuSectionInput: CreateMenuSectionInput, options?: RequestInit): Promise<OrderMenuSection> => {

  return customFetch<OrderMenuSection>(getCreateMenuSectionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMenuSectionInput)
  }
);}




export const getCreateMenuSectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMenuSection>>, TError,{id: number;data: BodyType<CreateMenuSectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMenuSection>>, TError,{id: number;data: BodyType<CreateMenuSectionInput>}, TContext> => {

const mutationKey = ['createMenuSection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMenuSection>>, {id: number;data: BodyType<CreateMenuSectionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createMenuSection(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMenuSectionMutationResult = NonNullable<Awaited<ReturnType<typeof createMenuSection>>>
    export type CreateMenuSectionMutationBody = BodyType<CreateMenuSectionInput>
    export type CreateMenuSectionMutationError = ErrorType<unknown>

    /**
 * @summary Create a menu section
 */
export const useCreateMenuSection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMenuSection>>, TError,{id: number;data: BodyType<CreateMenuSectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMenuSection>>,
        TError,
        {id: number;data: BodyType<CreateMenuSectionInput>},
        TContext
      > => {
      return useMutation(getCreateMenuSectionMutationOptions(options));
    }

export const getUpdateMenuSectionUrl = (id: number,
    sectionId: number,) => {




  return `/api/order/stores/${id}/menu-sections/${sectionId}`
}

/**
 * @summary Update a menu section
 */
export const updateMenuSection = async (id: number,
    sectionId: number,
    createMenuSectionInput: CreateMenuSectionInput, options?: RequestInit): Promise<OrderMenuSection> => {

  return customFetch<OrderMenuSection>(getUpdateMenuSectionUrl(id,sectionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMenuSectionInput)
  }
);}




export const getUpdateMenuSectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMenuSection>>, TError,{id: number;sectionId: number;data: BodyType<CreateMenuSectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMenuSection>>, TError,{id: number;sectionId: number;data: BodyType<CreateMenuSectionInput>}, TContext> => {

const mutationKey = ['updateMenuSection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMenuSection>>, {id: number;sectionId: number;data: BodyType<CreateMenuSectionInput>}> = (props) => {
          const {id,sectionId,data} = props ?? {};

          return  updateMenuSection(id,sectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMenuSectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateMenuSection>>>
    export type UpdateMenuSectionMutationBody = BodyType<CreateMenuSectionInput>
    export type UpdateMenuSectionMutationError = ErrorType<unknown>

    /**
 * @summary Update a menu section
 */
export const useUpdateMenuSection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMenuSection>>, TError,{id: number;sectionId: number;data: BodyType<CreateMenuSectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMenuSection>>,
        TError,
        {id: number;sectionId: number;data: BodyType<CreateMenuSectionInput>},
        TContext
      > => {
      return useMutation(getUpdateMenuSectionMutationOptions(options));
    }

export const getDeleteMenuSectionUrl = (id: number,
    sectionId: number,) => {




  return `/api/order/stores/${id}/menu-sections/${sectionId}`
}

/**
 * @summary Delete a menu section
 */
export const deleteMenuSection = async (id: number,
    sectionId: number, options?: RequestInit): Promise<DeleteMenuSection200> => {

  return customFetch<DeleteMenuSection200>(getDeleteMenuSectionUrl(id,sectionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMenuSectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMenuSection>>, TError,{id: number;sectionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMenuSection>>, TError,{id: number;sectionId: number}, TContext> => {

const mutationKey = ['deleteMenuSection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMenuSection>>, {id: number;sectionId: number}> = (props) => {
          const {id,sectionId} = props ?? {};

          return  deleteMenuSection(id,sectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMenuSectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMenuSection>>>

    export type DeleteMenuSectionMutationError = ErrorType<unknown>

    /**
 * @summary Delete a menu section
 */
export const useDeleteMenuSection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMenuSection>>, TError,{id: number;sectionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMenuSection>>,
        TError,
        {id: number;sectionId: number},
        TContext
      > => {
      return useMutation(getDeleteMenuSectionMutationOptions(options));
    }

export const getCreateMenuItemUrl = (id: number,) => {




  return `/api/order/stores/${id}/menu-items`
}

/**
 * @summary Create a menu item
 */
export const createMenuItem = async (id: number,
    createMenuItemInput: CreateMenuItemInput, options?: RequestInit): Promise<OrderMenuItem> => {

  return customFetch<OrderMenuItem>(getCreateMenuItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMenuItemInput)
  }
);}




export const getCreateMenuItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMenuItem>>, TError,{id: number;data: BodyType<CreateMenuItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMenuItem>>, TError,{id: number;data: BodyType<CreateMenuItemInput>}, TContext> => {

const mutationKey = ['createMenuItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMenuItem>>, {id: number;data: BodyType<CreateMenuItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createMenuItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMenuItemMutationResult = NonNullable<Awaited<ReturnType<typeof createMenuItem>>>
    export type CreateMenuItemMutationBody = BodyType<CreateMenuItemInput>
    export type CreateMenuItemMutationError = ErrorType<unknown>

    /**
 * @summary Create a menu item
 */
export const useCreateMenuItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMenuItem>>, TError,{id: number;data: BodyType<CreateMenuItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMenuItem>>,
        TError,
        {id: number;data: BodyType<CreateMenuItemInput>},
        TContext
      > => {
      return useMutation(getCreateMenuItemMutationOptions(options));
    }

export const getTranslateMenuUrl = (id: number,) => {




  return `/api/order/stores/${id}/translate-menu`
}

/**
 * @summary Translate all menu item names to Chinese (stores results in DB)
 */
export const translateMenu = async (id: number, options?: RequestInit): Promise<TranslateMenu200> => {

  return customFetch<TranslateMenu200>(getTranslateMenuUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTranslateMenuMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translateMenu>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof translateMenu>>, TError,{id: number}, TContext> => {

const mutationKey = ['translateMenu'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translateMenu>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  translateMenu(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TranslateMenuMutationResult = NonNullable<Awaited<ReturnType<typeof translateMenu>>>

    export type TranslateMenuMutationError = ErrorType<unknown>

    /**
 * @summary Translate all menu item names to Chinese (stores results in DB)
 */
export const useTranslateMenu = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translateMenu>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof translateMenu>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getTranslateMenuMutationOptions(options));
    }

export const getUpdateMenuItemUrl = (id: number,
    itemId: number,) => {




  return `/api/order/stores/${id}/menu-items/${itemId}`
}

/**
 * @summary Update a menu item
 */
export const updateMenuItem = async (id: number,
    itemId: number,
    createMenuItemInput: CreateMenuItemInput, options?: RequestInit): Promise<OrderMenuItem> => {

  return customFetch<OrderMenuItem>(getUpdateMenuItemUrl(id,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMenuItemInput)
  }
);}




export const getUpdateMenuItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMenuItem>>, TError,{id: number;itemId: number;data: BodyType<CreateMenuItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMenuItem>>, TError,{id: number;itemId: number;data: BodyType<CreateMenuItemInput>}, TContext> => {

const mutationKey = ['updateMenuItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMenuItem>>, {id: number;itemId: number;data: BodyType<CreateMenuItemInput>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  updateMenuItem(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMenuItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateMenuItem>>>
    export type UpdateMenuItemMutationBody = BodyType<CreateMenuItemInput>
    export type UpdateMenuItemMutationError = ErrorType<unknown>

    /**
 * @summary Update a menu item
 */
export const useUpdateMenuItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMenuItem>>, TError,{id: number;itemId: number;data: BodyType<CreateMenuItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMenuItem>>,
        TError,
        {id: number;itemId: number;data: BodyType<CreateMenuItemInput>},
        TContext
      > => {
      return useMutation(getUpdateMenuItemMutationOptions(options));
    }

export const getDeleteMenuItemUrl = (id: number,
    itemId: number,) => {




  return `/api/order/stores/${id}/menu-items/${itemId}`
}

/**
 * @summary Delete a menu item
 */
export const deleteMenuItem = async (id: number,
    itemId: number, options?: RequestInit): Promise<DeleteMenuItem200> => {

  return customFetch<DeleteMenuItem200>(getDeleteMenuItemUrl(id,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMenuItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMenuItem>>, TError,{id: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMenuItem>>, TError,{id: number;itemId: number}, TContext> => {

const mutationKey = ['deleteMenuItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMenuItem>>, {id: number;itemId: number}> = (props) => {
          const {id,itemId} = props ?? {};

          return  deleteMenuItem(id,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMenuItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMenuItem>>>

    export type DeleteMenuItemMutationError = ErrorType<unknown>

    /**
 * @summary Delete a menu item
 */
export const useDeleteMenuItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMenuItem>>, TError,{id: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMenuItem>>,
        TError,
        {id: number;itemId: number},
        TContext
      > => {
      return useMutation(getDeleteMenuItemMutationOptions(options));
    }

export const getCreateOrderPaymentIntentUrl = () => {




  return `/api/order/payment-intent`
}

/**
 * @summary Create a Stripe payment intent for an order
 */
export const createOrderPaymentIntent = async (createOrderPaymentIntentBody: CreateOrderPaymentIntentBody, options?: RequestInit): Promise<CreateOrderPaymentIntent200> => {

  return customFetch<CreateOrderPaymentIntent200>(getCreateOrderPaymentIntentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrderPaymentIntentBody)
  }
);}




export const getCreateOrderPaymentIntentMutationOptions = <TError = ErrorType<CreateOrderPaymentIntent409 | CheckoutPendingResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderPaymentIntent>>, TError,{data: BodyType<CreateOrderPaymentIntentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderPaymentIntent>>, TError,{data: BodyType<CreateOrderPaymentIntentBody>}, TContext> => {

const mutationKey = ['createOrderPaymentIntent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderPaymentIntent>>, {data: BodyType<CreateOrderPaymentIntentBody>}> = (props) => {
          const {data} = props ?? {};

          return  createOrderPaymentIntent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderPaymentIntentMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderPaymentIntent>>>
    export type CreateOrderPaymentIntentMutationBody = BodyType<CreateOrderPaymentIntentBody>
    export type CreateOrderPaymentIntentMutationError = ErrorType<CreateOrderPaymentIntent409 | CheckoutPendingResponse>

    /**
 * @summary Create a Stripe payment intent for an order
 */
export const useCreateOrderPaymentIntent = <TError = ErrorType<CreateOrderPaymentIntent409 | CheckoutPendingResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderPaymentIntent>>, TError,{data: BodyType<CreateOrderPaymentIntentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrderPaymentIntent>>,
        TError,
        {data: BodyType<CreateOrderPaymentIntentBody>},
        TContext
      > => {
      return useMutation(getCreateOrderPaymentIntentMutationOptions(options));
    }

export const getCreateOrderCheckoutSessionUrl = () => {




  return `/api/order/checkout-session`
}

/**
 * @summary Create a hosted order checkout from server-verified basket prices
 */
export const createOrderCheckoutSession = async (createOrderCheckoutSessionBody: CreateOrderCheckoutSessionBody, options?: RequestInit): Promise<CreateOrderCheckoutSession200> => {

  return customFetch<CreateOrderCheckoutSession200>(getCreateOrderCheckoutSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrderCheckoutSessionBody)
  }
);}




export const getCreateOrderCheckoutSessionMutationOptions = <TError = ErrorType<CreateOrderCheckoutSession409 | CheckoutPendingResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderCheckoutSession>>, TError,{data: BodyType<CreateOrderCheckoutSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderCheckoutSession>>, TError,{data: BodyType<CreateOrderCheckoutSessionBody>}, TContext> => {

const mutationKey = ['createOrderCheckoutSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderCheckoutSession>>, {data: BodyType<CreateOrderCheckoutSessionBody>}> = (props) => {
          const {data} = props ?? {};

          return  createOrderCheckoutSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderCheckoutSession>>>
    export type CreateOrderCheckoutSessionMutationBody = BodyType<CreateOrderCheckoutSessionBody>
    export type CreateOrderCheckoutSessionMutationError = ErrorType<CreateOrderCheckoutSession409 | CheckoutPendingResponse>

    /**
 * @summary Create a hosted order checkout from server-verified basket prices
 */
export const useCreateOrderCheckoutSession = <TError = ErrorType<CreateOrderCheckoutSession409 | CheckoutPendingResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderCheckoutSession>>, TError,{data: BodyType<CreateOrderCheckoutSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrderCheckoutSession>>,
        TError,
        {data: BodyType<CreateOrderCheckoutSessionBody>},
        TContext
      > => {
      return useMutation(getCreateOrderCheckoutSessionMutationOptions(options));
    }

export const getGetMyOrdersUrl = () => {




  return `/api/order/orders`
}

/**
 * @summary Get current user's orders
 */
export const getMyOrders = async ( options?: RequestInit): Promise<GetMyOrders200> => {

  return customFetch<GetMyOrders200>(getGetMyOrdersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyOrdersQueryKey = () => {
    return [
    `/api/order/orders`
    ] as const;
    }


export const getGetMyOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getMyOrders>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyOrdersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyOrders>>> = ({ signal }) => getMyOrders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getMyOrders>>>
export type GetMyOrdersQueryError = ErrorType<unknown>


/**
 * @summary Get current user's orders
 */

export function useGetMyOrders<TData = Awaited<ReturnType<typeof getMyOrders>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyOrdersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPlaceOrderUrl = () => {




  return `/api/order/orders`
}

/**
 * @summary Place a new order
 */
export const placeOrder = async (placeOrderInput: PlaceOrderInput, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getPlaceOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(placeOrderInput)
  }
);}




export const getPlaceOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof placeOrder>>, TError,{data: BodyType<PlaceOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof placeOrder>>, TError,{data: BodyType<PlaceOrderInput>}, TContext> => {

const mutationKey = ['placeOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof placeOrder>>, {data: BodyType<PlaceOrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  placeOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlaceOrderMutationResult = NonNullable<Awaited<ReturnType<typeof placeOrder>>>
    export type PlaceOrderMutationBody = BodyType<PlaceOrderInput>
    export type PlaceOrderMutationError = ErrorType<unknown>

    /**
 * @summary Place a new order
 */
export const usePlaceOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof placeOrder>>, TError,{data: BodyType<PlaceOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof placeOrder>>,
        TError,
        {data: BodyType<PlaceOrderInput>},
        TContext
      > => {
      return useMutation(getPlaceOrderMutationOptions(options));
    }

export const getGetOrderUrl = (id: number,) => {




  return `/api/order/orders/${id}`
}

/**
 * @summary Get a single order by ID (must be the order owner)
 */
export const getOrder = async (id: number, options?: RequestInit): Promise<OrderWithItems> => {

  return customFetch<OrderWithItems>(getGetOrderUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderQueryKey = (id: number,) => {
    return [
    `/api/order/orders/${id}`
    ] as const;
    }


export const getGetOrderQueryOptions = <TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({ signal }) => getOrder(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getOrder>>>
export type GetOrderQueryError = ErrorType<void>


/**
 * @summary Get a single order by ID (must be the order owner)
 */

export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStoreOrdersUrl = (id: number,) => {




  return `/api/order/stores/${id}/orders`
}

/**
 * @summary Get orders for a store (store owner/admin)
 */
export const getStoreOrders = async (id: number, options?: RequestInit): Promise<GetStoreOrders200> => {

  return customFetch<GetStoreOrders200>(getGetStoreOrdersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreOrdersQueryKey = (id: number,) => {
    return [
    `/api/order/stores/${id}/orders`
    ] as const;
    }


export const getGetStoreOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getStoreOrders>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStoreOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreOrdersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreOrders>>> = ({ signal }) => getStoreOrders(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoreOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreOrders>>>
export type GetStoreOrdersQueryError = ErrorType<unknown>


/**
 * @summary Get orders for a store (store owner/admin)
 */

export function useGetStoreOrders<TData = Awaited<ReturnType<typeof getStoreOrders>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStoreOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoreOrdersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOrderStatusUrl = (id: number,) => {




  return `/api/order/orders/${id}/status`
}

/**
 * @summary Update order status
 */
export const updateOrderStatus = async (id: number,
    updateOrderStatusBody: UpdateOrderStatusBody, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getUpdateOrderStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOrderStatusBody)
  }
);}




export const getUpdateOrderStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderStatus>>, TError,{id: number;data: BodyType<UpdateOrderStatusBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrderStatus>>, TError,{id: number;data: BodyType<UpdateOrderStatusBody>}, TContext> => {

const mutationKey = ['updateOrderStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrderStatus>>, {id: number;data: BodyType<UpdateOrderStatusBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrderStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrderStatus>>>
    export type UpdateOrderStatusMutationBody = BodyType<UpdateOrderStatusBody>
    export type UpdateOrderStatusMutationError = ErrorType<unknown>

    /**
 * @summary Update order status
 */
export const useUpdateOrderStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderStatus>>, TError,{id: number;data: BodyType<UpdateOrderStatusBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrderStatus>>,
        TError,
        {id: number;data: BodyType<UpdateOrderStatusBody>},
        TContext
      > => {
      return useMutation(getUpdateOrderStatusMutationOptions(options));
    }

export const getAdminGetOrderCategoriesUrl = () => {




  return `/api/admin/order-categories`
}

/**
 * @summary Admin list all order categories
 */
export const adminGetOrderCategories = async ( options?: RequestInit): Promise<AdminGetOrderCategories200> => {

  return customFetch<AdminGetOrderCategories200>(getAdminGetOrderCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetOrderCategoriesQueryKey = () => {
    return [
    `/api/admin/order-categories`
    ] as const;
    }


export const getAdminGetOrderCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof adminGetOrderCategories>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrderCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetOrderCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetOrderCategories>>> = ({ signal }) => adminGetOrderCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetOrderCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetOrderCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetOrderCategories>>>
export type AdminGetOrderCategoriesQueryError = ErrorType<unknown>


/**
 * @summary Admin list all order categories
 */

export function useAdminGetOrderCategories<TData = Awaited<ReturnType<typeof adminGetOrderCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrderCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetOrderCategoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminCreateOrderCategoryUrl = () => {




  return `/api/admin/order-categories`
}

/**
 * @summary Admin create an order category
 */
export const adminCreateOrderCategory = async (adminCreateOrderCategoryBody: AdminCreateOrderCategoryBody, options?: RequestInit): Promise<OrderCategory> => {

  return customFetch<OrderCategory>(getAdminCreateOrderCategoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminCreateOrderCategoryBody)
  }
);}




export const getAdminCreateOrderCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateOrderCategory>>, TError,{data: BodyType<AdminCreateOrderCategoryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateOrderCategory>>, TError,{data: BodyType<AdminCreateOrderCategoryBody>}, TContext> => {

const mutationKey = ['adminCreateOrderCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateOrderCategory>>, {data: BodyType<AdminCreateOrderCategoryBody>}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateOrderCategory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateOrderCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateOrderCategory>>>
    export type AdminCreateOrderCategoryMutationBody = BodyType<AdminCreateOrderCategoryBody>
    export type AdminCreateOrderCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Admin create an order category
 */
export const useAdminCreateOrderCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateOrderCategory>>, TError,{data: BodyType<AdminCreateOrderCategoryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminCreateOrderCategory>>,
        TError,
        {data: BodyType<AdminCreateOrderCategoryBody>},
        TContext
      > => {
      return useMutation(getAdminCreateOrderCategoryMutationOptions(options));
    }

export const getAdminUpdateOrderCategoryUrl = (id: number,) => {




  return `/api/admin/order-categories/${id}`
}

/**
 * @summary Admin update an order category
 */
export const adminUpdateOrderCategory = async (id: number,
    adminUpdateOrderCategoryBody: AdminUpdateOrderCategoryBody, options?: RequestInit): Promise<OrderCategory> => {

  return customFetch<OrderCategory>(getAdminUpdateOrderCategoryUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminUpdateOrderCategoryBody)
  }
);}




export const getAdminUpdateOrderCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateOrderCategory>>, TError,{id: number;data: BodyType<AdminUpdateOrderCategoryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateOrderCategory>>, TError,{id: number;data: BodyType<AdminUpdateOrderCategoryBody>}, TContext> => {

const mutationKey = ['adminUpdateOrderCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateOrderCategory>>, {id: number;data: BodyType<AdminUpdateOrderCategoryBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateOrderCategory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateOrderCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateOrderCategory>>>
    export type AdminUpdateOrderCategoryMutationBody = BodyType<AdminUpdateOrderCategoryBody>
    export type AdminUpdateOrderCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Admin update an order category
 */
export const useAdminUpdateOrderCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateOrderCategory>>, TError,{id: number;data: BodyType<AdminUpdateOrderCategoryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdateOrderCategory>>,
        TError,
        {id: number;data: BodyType<AdminUpdateOrderCategoryBody>},
        TContext
      > => {
      return useMutation(getAdminUpdateOrderCategoryMutationOptions(options));
    }

export const getAdminDeleteOrderCategoryUrl = (id: number,) => {




  return `/api/admin/order-categories/${id}`
}

/**
 * @summary Admin delete an order category
 */
export const adminDeleteOrderCategory = async (id: number, options?: RequestInit): Promise<AdminDeleteOrderCategory200> => {

  return customFetch<AdminDeleteOrderCategory200>(getAdminDeleteOrderCategoryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAdminDeleteOrderCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteOrderCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteOrderCategory>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminDeleteOrderCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteOrderCategory>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteOrderCategory(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteOrderCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteOrderCategory>>>

    export type AdminDeleteOrderCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Admin delete an order category
 */
export const useAdminDeleteOrderCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteOrderCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminDeleteOrderCategory>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminDeleteOrderCategoryMutationOptions(options));
    }

export const getAdminGetOrderStoresUrl = () => {




  return `/api/admin/order-stores`
}

/**
 * @summary Admin list all order stores
 */
export const adminGetOrderStores = async ( options?: RequestInit): Promise<AdminGetOrderStores200> => {

  return customFetch<AdminGetOrderStores200>(getAdminGetOrderStoresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetOrderStoresQueryKey = () => {
    return [
    `/api/admin/order-stores`
    ] as const;
    }


export const getAdminGetOrderStoresQueryOptions = <TData = Awaited<ReturnType<typeof adminGetOrderStores>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrderStores>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetOrderStoresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetOrderStores>>> = ({ signal }) => adminGetOrderStores({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetOrderStores>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetOrderStoresQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetOrderStores>>>
export type AdminGetOrderStoresQueryError = ErrorType<unknown>


/**
 * @summary Admin list all order stores
 */

export function useAdminGetOrderStores<TData = Awaited<ReturnType<typeof adminGetOrderStores>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrderStores>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetOrderStoresQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminUpdateOrderStoreUrl = (id: number,) => {




  return `/api/admin/order-stores/${id}`
}

/**
 * @summary Admin approve/activate a store
 */
export const adminUpdateOrderStore = async (id: number,
    adminUpdateOrderStoreBody: AdminUpdateOrderStoreBody, options?: RequestInit): Promise<OrderStore> => {

  return customFetch<OrderStore>(getAdminUpdateOrderStoreUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminUpdateOrderStoreBody)
  }
);}




export const getAdminUpdateOrderStoreMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateOrderStore>>, TError,{id: number;data: BodyType<AdminUpdateOrderStoreBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateOrderStore>>, TError,{id: number;data: BodyType<AdminUpdateOrderStoreBody>}, TContext> => {

const mutationKey = ['adminUpdateOrderStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateOrderStore>>, {id: number;data: BodyType<AdminUpdateOrderStoreBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateOrderStore(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateOrderStoreMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateOrderStore>>>
    export type AdminUpdateOrderStoreMutationBody = BodyType<AdminUpdateOrderStoreBody>
    export type AdminUpdateOrderStoreMutationError = ErrorType<unknown>

    /**
 * @summary Admin approve/activate a store
 */
export const useAdminUpdateOrderStore = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateOrderStore>>, TError,{id: number;data: BodyType<AdminUpdateOrderStoreBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdateOrderStore>>,
        TError,
        {id: number;data: BodyType<AdminUpdateOrderStoreBody>},
        TContext
      > => {
      return useMutation(getAdminUpdateOrderStoreMutationOptions(options));
    }

export const getApplyToBeDriverUrl = () => {




  return `/api/drivers/apply`
}

/**
 * @summary Apply to become a hub driver
 */
export const applyToBeDriver = async (applyToBeDriverBody: ApplyToBeDriverBody, options?: RequestInit): Promise<DriverProfile> => {

  return customFetch<DriverProfile>(getApplyToBeDriverUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(applyToBeDriverBody)
  }
);}




export const getApplyToBeDriverMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyToBeDriver>>, TError,{data: BodyType<ApplyToBeDriverBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyToBeDriver>>, TError,{data: BodyType<ApplyToBeDriverBody>}, TContext> => {

const mutationKey = ['applyToBeDriver'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyToBeDriver>>, {data: BodyType<ApplyToBeDriverBody>}> = (props) => {
          const {data} = props ?? {};

          return  applyToBeDriver(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyToBeDriverMutationResult = NonNullable<Awaited<ReturnType<typeof applyToBeDriver>>>
    export type ApplyToBeDriverMutationBody = BodyType<ApplyToBeDriverBody>
    export type ApplyToBeDriverMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Apply to become a hub driver
 */
export const useApplyToBeDriver = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyToBeDriver>>, TError,{data: BodyType<ApplyToBeDriverBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyToBeDriver>>,
        TError,
        {data: BodyType<ApplyToBeDriverBody>},
        TContext
      > => {
      return useMutation(getApplyToBeDriverMutationOptions(options));
    }

export const getGetDriverSearchRadiusUrl = () => {




  return `/api/drivers/search-radius`
}

/**
 * @summary Get approved driver's saved pickup radius (default 5 miles)
 */
export const getDriverSearchRadius = async ( options?: RequestInit): Promise<GetDriverSearchRadius200> => {

  return customFetch<GetDriverSearchRadius200>(getGetDriverSearchRadiusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDriverSearchRadiusQueryKey = () => {
    return [
    `/api/drivers/search-radius`
    ] as const;
    }


export const getGetDriverSearchRadiusQueryOptions = <TData = Awaited<ReturnType<typeof getDriverSearchRadius>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDriverSearchRadius>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriverSearchRadiusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverSearchRadius>>> = ({ signal }) => getDriverSearchRadius({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDriverSearchRadius>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDriverSearchRadiusQueryResult = NonNullable<Awaited<ReturnType<typeof getDriverSearchRadius>>>
export type GetDriverSearchRadiusQueryError = ErrorType<void>


/**
 * @summary Get approved driver's saved pickup radius (default 5 miles)
 */

export function useGetDriverSearchRadius<TData = Awaited<ReturnType<typeof getDriverSearchRadius>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDriverSearchRadius>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDriverSearchRadiusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDriverSearchRadiusUrl = () => {




  return `/api/drivers/search-radius`
}

/**
 * @summary Save own pickup radius without changing accepted jobs or issued offers
 */
export const updateDriverSearchRadius = async (updateDriverSearchRadiusBody: UpdateDriverSearchRadiusBody, options?: RequestInit): Promise<UpdateDriverSearchRadius200> => {

  return customFetch<UpdateDriverSearchRadius200>(getUpdateDriverSearchRadiusUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDriverSearchRadiusBody)
  }
);}




export const getUpdateDriverSearchRadiusMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDriverSearchRadius>>, TError,{data: BodyType<UpdateDriverSearchRadiusBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDriverSearchRadius>>, TError,{data: BodyType<UpdateDriverSearchRadiusBody>}, TContext> => {

const mutationKey = ['updateDriverSearchRadius'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDriverSearchRadius>>, {data: BodyType<UpdateDriverSearchRadiusBody>}> = (props) => {
          const {data} = props ?? {};

          return  updateDriverSearchRadius(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDriverSearchRadiusMutationResult = NonNullable<Awaited<ReturnType<typeof updateDriverSearchRadius>>>
    export type UpdateDriverSearchRadiusMutationBody = BodyType<UpdateDriverSearchRadiusBody>
    export type UpdateDriverSearchRadiusMutationError = ErrorType<void>

    /**
 * @summary Save own pickup radius without changing accepted jobs or issued offers
 */
export const useUpdateDriverSearchRadius = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDriverSearchRadius>>, TError,{data: BodyType<UpdateDriverSearchRadiusBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDriverSearchRadius>>,
        TError,
        {data: BodyType<UpdateDriverSearchRadiusBody>},
        TContext
      > => {
      return useMutation(getUpdateDriverSearchRadiusMutationOptions(options));
    }

export const getGetDriverProfileUrl = () => {




  return `/api/drivers/profile`
}

/**
 * @summary Get current user's driver profile
 */
export const getDriverProfile = async ( options?: RequestInit): Promise<DriverProfile> => {

  return customFetch<DriverProfile>(getGetDriverProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDriverProfileQueryKey = () => {
    return [
    `/api/drivers/profile`
    ] as const;
    }


export const getGetDriverProfileQueryOptions = <TData = Awaited<ReturnType<typeof getDriverProfile>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDriverProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriverProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverProfile>>> = ({ signal }) => getDriverProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDriverProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDriverProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getDriverProfile>>>
export type GetDriverProfileQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get current user's driver profile
 */

export function useGetDriverProfile<TData = Awaited<ReturnType<typeof getDriverProfile>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDriverProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDriverProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDriverProfileUrl = () => {




  return `/api/drivers/profile`
}

/**
 * @summary Update driver profile (availability, bio, vehicle)
 */
export const updateDriverProfile = async (updateDriverProfileBody: UpdateDriverProfileBody, options?: RequestInit): Promise<DriverProfile> => {

  return customFetch<DriverProfile>(getUpdateDriverProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDriverProfileBody)
  }
);}




export const getUpdateDriverProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDriverProfile>>, TError,{data: BodyType<UpdateDriverProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDriverProfile>>, TError,{data: BodyType<UpdateDriverProfileBody>}, TContext> => {

const mutationKey = ['updateDriverProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDriverProfile>>, {data: BodyType<UpdateDriverProfileBody>}> = (props) => {
          const {data} = props ?? {};

          return  updateDriverProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDriverProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateDriverProfile>>>
    export type UpdateDriverProfileMutationBody = BodyType<UpdateDriverProfileBody>
    export type UpdateDriverProfileMutationError = ErrorType<unknown>

    /**
 * @summary Update driver profile (availability, bio, vehicle)
 */
export const useUpdateDriverProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDriverProfile>>, TError,{data: BodyType<UpdateDriverProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDriverProfile>>,
        TError,
        {data: BodyType<UpdateDriverProfileBody>},
        TContext
      > => {
      return useMutation(getUpdateDriverProfileMutationOptions(options));
    }

export const getGetDriverEarningsUrl = () => {




  return `/api/drivers/earnings`
}

/**
 * @summary Get driver earnings grouped by week
 */
export const getDriverEarnings = async ( options?: RequestInit): Promise<GetDriverEarnings200> => {

  return customFetch<GetDriverEarnings200>(getGetDriverEarningsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDriverEarningsQueryKey = () => {
    return [
    `/api/drivers/earnings`
    ] as const;
    }


export const getGetDriverEarningsQueryOptions = <TData = Awaited<ReturnType<typeof getDriverEarnings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDriverEarnings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriverEarningsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverEarnings>>> = ({ signal }) => getDriverEarnings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDriverEarnings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDriverEarningsQueryResult = NonNullable<Awaited<ReturnType<typeof getDriverEarnings>>>
export type GetDriverEarningsQueryError = ErrorType<unknown>


/**
 * @summary Get driver earnings grouped by week
 */

export function useGetDriverEarnings<TData = Awaited<ReturnType<typeof getDriverEarnings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDriverEarnings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDriverEarningsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStoreDebtPaymentBalanceUrl = (storeId: number,) => {




  return `/api/order/stores/${storeId}/debt-payment`
}

/**
 * @summary Owner-only outstanding balance and amount available to pay by card
 */
export const getStoreDebtPaymentBalance = async (storeId: number, options?: RequestInit): Promise<GetStoreDebtPaymentBalance200> => {

  return customFetch<GetStoreDebtPaymentBalance200>(getGetStoreDebtPaymentBalanceUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreDebtPaymentBalanceQueryKey = (storeId: number,) => {
    return [
    `/api/order/stores/${storeId}/debt-payment`
    ] as const;
    }


export const getGetStoreDebtPaymentBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getStoreDebtPaymentBalance>>, TError = ErrorType<void>>(storeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStoreDebtPaymentBalance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreDebtPaymentBalanceQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreDebtPaymentBalance>>> = ({ signal }) => getStoreDebtPaymentBalance(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreDebtPaymentBalance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoreDebtPaymentBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreDebtPaymentBalance>>>
export type GetStoreDebtPaymentBalanceQueryError = ErrorType<void>


/**
 * @summary Owner-only outstanding balance and amount available to pay by card
 */

export function useGetStoreDebtPaymentBalance<TData = Awaited<ReturnType<typeof getStoreDebtPaymentBalance>>, TError = ErrorType<void>>(
 storeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStoreDebtPaymentBalance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoreDebtPaymentBalanceQueryOptions(storeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateStoreDebtCardPaymentUrl = (storeId: number,) => {




  return `/api/order/stores/${storeId}/debt-payment`
}

/**
 * Server calculates the payable balance under the order collector's store lock. Pending payments do not reduce confirmed debt. No order or additional sale is created.
 * @summary Create or resume one durable platform card checkout for existing shop charges
 */
export const createStoreDebtCardPayment = async (storeId: number, options?: RequestInit): Promise<CreateStoreDebtCardPayment200> => {

  return customFetch<CreateStoreDebtCardPayment200>(getCreateStoreDebtCardPaymentUrl(storeId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateStoreDebtCardPaymentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStoreDebtCardPayment>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStoreDebtCardPayment>>, TError,{storeId: number}, TContext> => {

const mutationKey = ['createStoreDebtCardPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStoreDebtCardPayment>>, {storeId: number}> = (props) => {
          const {storeId} = props ?? {};

          return  createStoreDebtCardPayment(storeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStoreDebtCardPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof createStoreDebtCardPayment>>>

    export type CreateStoreDebtCardPaymentMutationError = ErrorType<void>

    /**
 * @summary Create or resume one durable platform card checkout for existing shop charges
 */
export const useCreateStoreDebtCardPayment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStoreDebtCardPayment>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStoreDebtCardPayment>>,
        TError,
        {storeId: number},
        TContext
      > => {
      return useMutation(getCreateStoreDebtCardPaymentMutationOptions(options));
    }

export const getVerifyStoreDebtCardPaymentUrl = (storeId: number,
    paymentId: string,) => {




  return `/api/order/stores/${storeId}/debt-payment/${paymentId}/verify`
}

/**
 * @summary Reconcile an owner's original card settlement using current Stripe receipts
 */
export const verifyStoreDebtCardPayment = async (storeId: number,
    paymentId: string, options?: RequestInit): Promise<VerifyStoreDebtCardPayment200> => {

  return customFetch<VerifyStoreDebtCardPayment200>(getVerifyStoreDebtCardPaymentUrl(storeId,paymentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getVerifyStoreDebtCardPaymentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyStoreDebtCardPayment>>, TError,{storeId: number;paymentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyStoreDebtCardPayment>>, TError,{storeId: number;paymentId: string}, TContext> => {

const mutationKey = ['verifyStoreDebtCardPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyStoreDebtCardPayment>>, {storeId: number;paymentId: string}> = (props) => {
          const {storeId,paymentId} = props ?? {};

          return  verifyStoreDebtCardPayment(storeId,paymentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyStoreDebtCardPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof verifyStoreDebtCardPayment>>>

    export type VerifyStoreDebtCardPaymentMutationError = ErrorType<void>

    /**
 * @summary Reconcile an owner's original card settlement using current Stripe receipts
 */
export const useVerifyStoreDebtCardPayment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyStoreDebtCardPayment>>, TError,{storeId: number;paymentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyStoreDebtCardPayment>>,
        TError,
        {storeId: number;paymentId: string},
        TContext
      > => {
      return useMutation(getVerifyStoreDebtCardPaymentMutationOptions(options));
    }

export const getGetStoreFinanceReportUrl = (storeId: number,
    params?: GetStoreFinanceReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/order/stores/${storeId}/finance?${stringifiedParams}` : `/api/order/stores/${storeId}/finance`
}

/**
 * Stripe activity follows provider dates and includes cross-period refunds and processing. Order estimates are not adjusted net earnings or proof of bank receipt.
 * @summary Read shop order estimates and separate actual Stripe account activity
 */
export const getStoreFinanceReport = async (storeId: number,
    params?: GetStoreFinanceReportParams, options?: RequestInit): Promise<GetStoreFinanceReport200> => {

  return customFetch<GetStoreFinanceReport200>(getGetStoreFinanceReportUrl(storeId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreFinanceReportQueryKey = (storeId: number,
    params?: GetStoreFinanceReportParams,) => {
    return [
    `/api/order/stores/${storeId}/finance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStoreFinanceReportQueryOptions = <TData = Awaited<ReturnType<typeof getStoreFinanceReport>>, TError = ErrorType<void>>(storeId: number,
    params?: GetStoreFinanceReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStoreFinanceReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreFinanceReportQueryKey(storeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreFinanceReport>>> = ({ signal }) => getStoreFinanceReport(storeId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreFinanceReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoreFinanceReportQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreFinanceReport>>>
export type GetStoreFinanceReportQueryError = ErrorType<void>


/**
 * @summary Read shop order estimates and separate actual Stripe account activity
 */

export function useGetStoreFinanceReport<TData = Awaited<ReturnType<typeof getStoreFinanceReport>>, TError = ErrorType<void>>(
 storeId: number,
    params?: GetStoreFinanceReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStoreFinanceReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoreFinanceReportQueryOptions(storeId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminBankStatementsUrl = (params?: GetAdminBankStatementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/bank-statements?${stringifiedParams}` : `/api/admin/bank-statements`
}

/**
 * @summary List active statements, optionally including archived evidence
 */
export const getAdminBankStatements = async (params?: GetAdminBankStatementsParams, options?: RequestInit): Promise<GetAdminBankStatements200> => {

  return customFetch<GetAdminBankStatements200>(getGetAdminBankStatementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminBankStatementsQueryKey = (params?: GetAdminBankStatementsParams,) => {
    return [
    `/api/admin/bank-statements`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminBankStatementsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminBankStatements>>, TError = ErrorType<unknown>>(params?: GetAdminBankStatementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBankStatements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminBankStatementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminBankStatements>>> = ({ signal }) => getAdminBankStatements(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminBankStatements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminBankStatementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminBankStatements>>>
export type GetAdminBankStatementsQueryError = ErrorType<unknown>


/**
 * @summary List active statements, optionally including archived evidence
 */

export function useGetAdminBankStatements<TData = Awaited<ReturnType<typeof getAdminBankStatements>>, TError = ErrorType<unknown>>(
 params?: GetAdminBankStatementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBankStatements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminBankStatementsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportAdminBankStatementUrl = () => {




  return `/api/admin/bank-statements/commit`
}

/**
 * @summary Atomically import one RBS GBP statement, reusing the original on identical replay
 */
export const importAdminBankStatement = async (importAdminBankStatementBody: ImportAdminBankStatementBody, options?: RequestInit): Promise<ImportAdminBankStatement200> => {

  return customFetch<ImportAdminBankStatement200>(getImportAdminBankStatementUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importAdminBankStatementBody)
  }
);}




export const getImportAdminBankStatementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAdminBankStatement>>, TError,{data: BodyType<ImportAdminBankStatementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importAdminBankStatement>>, TError,{data: BodyType<ImportAdminBankStatementBody>}, TContext> => {

const mutationKey = ['importAdminBankStatement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importAdminBankStatement>>, {data: BodyType<ImportAdminBankStatementBody>}> = (props) => {
          const {data} = props ?? {};

          return  importAdminBankStatement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportAdminBankStatementMutationResult = NonNullable<Awaited<ReturnType<typeof importAdminBankStatement>>>
    export type ImportAdminBankStatementMutationBody = BodyType<ImportAdminBankStatementBody>
    export type ImportAdminBankStatementMutationError = ErrorType<void>

    /**
 * @summary Atomically import one RBS GBP statement, reusing the original on identical replay
 */
export const useImportAdminBankStatement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAdminBankStatement>>, TError,{data: BodyType<ImportAdminBankStatementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importAdminBankStatement>>,
        TError,
        {data: BodyType<ImportAdminBankStatementBody>},
        TContext
      > => {
      return useMutation(getImportAdminBankStatementMutationOptions(options));
    }

export const getArchiveAdminBankStatementUrl = (id: number,) => {




  return `/api/admin/bank-statements/${id}`
}

/**
 * @summary Archive a statement without deleting its original financial evidence
 */
export const archiveAdminBankStatement = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getArchiveAdminBankStatementUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getArchiveAdminBankStatementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAdminBankStatement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveAdminBankStatement>>, TError,{id: number}, TContext> => {

const mutationKey = ['archiveAdminBankStatement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAdminBankStatement>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  archiveAdminBankStatement(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAdminBankStatementMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAdminBankStatement>>>

    export type ArchiveAdminBankStatementMutationError = ErrorType<void>

    /**
 * @summary Archive a statement without deleting its original financial evidence
 */
export const useArchiveAdminBankStatement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAdminBankStatement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveAdminBankStatement>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getArchiveAdminBankStatementMutationOptions(options));
    }

export const getRestoreAdminBankStatementUrl = (id: number,) => {




  return `/api/admin/bank-statements/${id}/restore`
}

/**
 * @summary Explicitly restore the original archived evidence; no duplicate entries are created
 */
export const restoreAdminBankStatement = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRestoreAdminBankStatementUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRestoreAdminBankStatementMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreAdminBankStatement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreAdminBankStatement>>, TError,{id: number}, TContext> => {

const mutationKey = ['restoreAdminBankStatement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreAdminBankStatement>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  restoreAdminBankStatement(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreAdminBankStatementMutationResult = NonNullable<Awaited<ReturnType<typeof restoreAdminBankStatement>>>

    export type RestoreAdminBankStatementMutationError = ErrorType<void>

    /**
 * @summary Explicitly restore the original archived evidence; no duplicate entries are created
 */
export const useRestoreAdminBankStatement = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreAdminBankStatement>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restoreAdminBankStatement>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRestoreAdminBankStatementMutationOptions(options));
    }

export const getGetAdminBankStatementComparisonUrl = (id: number,) => {




  return `/api/admin/bank-statements/${id}/reconcile`
}

/**
 * Differences do not establish recipient identity or bank arrival. A zero difference remains Review.
 * @summary Compare statement totals with recorded projections
 */
export const getAdminBankStatementComparison = async (id: number, options?: RequestInit): Promise<GetAdminBankStatementComparison200> => {

  return customFetch<GetAdminBankStatementComparison200>(getGetAdminBankStatementComparisonUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminBankStatementComparisonQueryKey = (id: number,) => {
    return [
    `/api/admin/bank-statements/${id}/reconcile`
    ] as const;
    }


export const getGetAdminBankStatementComparisonQueryOptions = <TData = Awaited<ReturnType<typeof getAdminBankStatementComparison>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBankStatementComparison>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminBankStatementComparisonQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminBankStatementComparison>>> = ({ signal }) => getAdminBankStatementComparison(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminBankStatementComparison>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminBankStatementComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminBankStatementComparison>>>
export type GetAdminBankStatementComparisonQueryError = ErrorType<void>


/**
 * @summary Compare statement totals with recorded projections
 */

export function useGetAdminBankStatementComparison<TData = Awaited<ReturnType<typeof getAdminBankStatementComparison>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBankStatementComparison>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminBankStatementComparisonQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminStoreStripeReportingUrl = (id: number,
    params: GetAdminStoreStripeReportingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/stores/${id}/stripe/reporting?${stringifiedParams}` : `/api/admin/stores/${id}/stripe/reporting`
}

/**
 * @summary Read provider payout members and exact unmatched differences
 */
export const getAdminStoreStripeReporting = async (id: number,
    params: GetAdminStoreStripeReportingParams, options?: RequestInit): Promise<GetAdminStoreStripeReporting200> => {

  return customFetch<GetAdminStoreStripeReporting200>(getGetAdminStoreStripeReportingUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStoreStripeReportingQueryKey = (id: number,
    params?: GetAdminStoreStripeReportingParams,) => {
    return [
    `/api/admin/stores/${id}/stripe/reporting`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminStoreStripeReportingQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStoreStripeReporting>>, TError = ErrorType<void>>(id: number,
    params: GetAdminStoreStripeReportingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStoreStripeReporting>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStoreStripeReportingQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStoreStripeReporting>>> = ({ signal }) => getAdminStoreStripeReporting(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStoreStripeReporting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminStoreStripeReportingQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStoreStripeReporting>>>
export type GetAdminStoreStripeReportingQueryError = ErrorType<void>


/**
 * @summary Read provider payout members and exact unmatched differences
 */

export function useGetAdminStoreStripeReporting<TData = Awaited<ReturnType<typeof getAdminStoreStripeReporting>>, TError = ErrorType<void>>(
 id: number,
    params: GetAdminStoreStripeReportingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStoreStripeReporting>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminStoreStripeReportingQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminKindnessOverviewUrl = () => {




  return `/api/admin/kindness/overview`
}

/**
 * The Hub advances operating cash against authenticated paid donations while Stripe settles them. Available requires original payment evidence and current Hub liquidity. Donations and reservations are not Hub profit or a bank receipt.
 * @summary Read kindness balances and Hub-funded advances
 */
export const getAdminKindnessOverview = async ( options?: RequestInit): Promise<GetAdminKindnessOverview200> => {

  return customFetch<GetAdminKindnessOverview200>(getGetAdminKindnessOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminKindnessOverviewQueryKey = () => {
    return [
    `/api/admin/kindness/overview`
    ] as const;
    }


export const getGetAdminKindnessOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAdminKindnessOverview>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminKindnessOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminKindnessOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminKindnessOverview>>> = ({ signal }) => getAdminKindnessOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminKindnessOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminKindnessOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminKindnessOverview>>>
export type GetAdminKindnessOverviewQueryError = ErrorType<void>


/**
 * @summary Read kindness balances and Hub-funded advances
 */

export function useGetAdminKindnessOverview<TData = Awaited<ReturnType<typeof getAdminKindnessOverview>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminKindnessOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminKindnessOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminFinanceRecoveryUrl = () => {




  return `/api/admin/finance-recovery`
}

/**
 * Includes unpaid checkouts. Queue state is not proof of collected or refunded money. No provider payloads or correction actions are returned.
 * @summary Read pending and review-only payment recovery references
 */
export const getAdminFinanceRecovery = async ( options?: RequestInit): Promise<GetAdminFinanceRecovery200> => {

  return customFetch<GetAdminFinanceRecovery200>(getGetAdminFinanceRecoveryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminFinanceRecoveryQueryKey = () => {
    return [
    `/api/admin/finance-recovery`
    ] as const;
    }


export const getGetAdminFinanceRecoveryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinanceRecovery>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFinanceRecovery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinanceRecoveryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinanceRecovery>>> = ({ signal }) => getAdminFinanceRecovery({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinanceRecovery>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminFinanceRecoveryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinanceRecovery>>>
export type GetAdminFinanceRecoveryQueryError = ErrorType<void>


/**
 * @summary Read pending and review-only payment recovery references
 */

export function useGetAdminFinanceRecovery<TData = Awaited<ReturnType<typeof getAdminFinanceRecovery>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFinanceRecovery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminFinanceRecoveryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDecideAdminDriverWithdrawalUrl = (id: number,) => {




  return `/api/admin/drivers/withdrawal-requests/${id}`
}

/**
 * Pending requests can be approved or rejected. Approved requests can be rejected or recorded as sent with a payment reference. Terminal decisions are immutable. Recording a sent transfer does not verify bank arrival or send money.
 * @summary Record an audited driver withdrawal decision
 */
export const decideAdminDriverWithdrawal = async (id: number,
    decideAdminDriverWithdrawalBody: DecideAdminDriverWithdrawalBody, options?: RequestInit): Promise<DecideAdminDriverWithdrawal200> => {

  return customFetch<DecideAdminDriverWithdrawal200>(getDecideAdminDriverWithdrawalUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(decideAdminDriverWithdrawalBody)
  }
);}




export const getDecideAdminDriverWithdrawalMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideAdminDriverWithdrawal>>, TError,{id: number;data: BodyType<DecideAdminDriverWithdrawalBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof decideAdminDriverWithdrawal>>, TError,{id: number;data: BodyType<DecideAdminDriverWithdrawalBody>}, TContext> => {

const mutationKey = ['decideAdminDriverWithdrawal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof decideAdminDriverWithdrawal>>, {id: number;data: BodyType<DecideAdminDriverWithdrawalBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  decideAdminDriverWithdrawal(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DecideAdminDriverWithdrawalMutationResult = NonNullable<Awaited<ReturnType<typeof decideAdminDriverWithdrawal>>>
    export type DecideAdminDriverWithdrawalMutationBody = BodyType<DecideAdminDriverWithdrawalBody>
    export type DecideAdminDriverWithdrawalMutationError = ErrorType<void>

    /**
 * @summary Record an audited driver withdrawal decision
 */
export const useDecideAdminDriverWithdrawal = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideAdminDriverWithdrawal>>, TError,{id: number;data: BodyType<DecideAdminDriverWithdrawalBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof decideAdminDriverWithdrawal>>,
        TError,
        {id: number;data: BodyType<DecideAdminDriverWithdrawalBody>},
        TContext
      > => {
      return useMutation(getDecideAdminDriverWithdrawalMutationOptions(options));
    }

export const getGetDriverRatingsUrl = () => {




  return `/api/drivers/ratings`
}

/**
 * @summary Get the driver's own rating history (star score + comment + date)
 */
export const getDriverRatings = async ( options?: RequestInit): Promise<GetDriverRatings200> => {

  return customFetch<GetDriverRatings200>(getGetDriverRatingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDriverRatingsQueryKey = () => {
    return [
    `/api/drivers/ratings`
    ] as const;
    }


export const getGetDriverRatingsQueryOptions = <TData = Awaited<ReturnType<typeof getDriverRatings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDriverRatings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriverRatingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverRatings>>> = ({ signal }) => getDriverRatings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDriverRatings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDriverRatingsQueryResult = NonNullable<Awaited<ReturnType<typeof getDriverRatings>>>
export type GetDriverRatingsQueryError = ErrorType<unknown>


/**
 * @summary Get the driver's own rating history (star score + comment + date)
 */

export function useGetDriverRatings<TData = Awaited<ReturnType<typeof getDriverRatings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDriverRatings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDriverRatingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDriverJobsUrl = (params?: ListDriverJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/drivers/jobs?${stringifiedParams}` : `/api/drivers/jobs`
}

/**
 * @summary List available delivery jobs for hub drivers
 */
export const listDriverJobs = async (params?: ListDriverJobsParams, options?: RequestInit): Promise<ListDriverJobs200> => {

  return customFetch<ListDriverJobs200>(getListDriverJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDriverJobsQueryKey = (params?: ListDriverJobsParams,) => {
    return [
    `/api/drivers/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDriverJobsQueryOptions = <TData = Awaited<ReturnType<typeof listDriverJobs>>, TError = ErrorType<unknown>>(params?: ListDriverJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDriverJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDriverJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDriverJobs>>> = ({ signal }) => listDriverJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDriverJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDriverJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listDriverJobs>>>
export type ListDriverJobsQueryError = ErrorType<unknown>


/**
 * @summary List available delivery jobs for hub drivers
 */

export function useListDriverJobs<TData = Awaited<ReturnType<typeof listDriverJobs>>, TError = ErrorType<unknown>>(
 params?: ListDriverJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDriverJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDriverJobsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getClaimDriverJobUrl = (orderId: number,) => {




  return `/api/drivers/jobs/${orderId}/claim`
}

/**
 * @summary Claim a delivery job
 */
export const claimDriverJob = async (orderId: number, options?: RequestInit): Promise<DriverAssignment> => {

  return customFetch<DriverAssignment>(getClaimDriverJobUrl(orderId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getClaimDriverJobMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimDriverJob>>, TError,{orderId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof claimDriverJob>>, TError,{orderId: number}, TContext> => {

const mutationKey = ['claimDriverJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimDriverJob>>, {orderId: number}> = (props) => {
          const {orderId} = props ?? {};

          return  claimDriverJob(orderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimDriverJobMutationResult = NonNullable<Awaited<ReturnType<typeof claimDriverJob>>>

    export type ClaimDriverJobMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Claim a delivery job
 */
export const useClaimDriverJob = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimDriverJob>>, TError,{orderId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof claimDriverJob>>,
        TError,
        {orderId: number},
        TContext
      > => {
      return useMutation(getClaimDriverJobMutationOptions(options));
    }

export const getReleaseDriverJobUrl = (orderId: number,) => {




  return `/api/drivers/jobs/${orderId}/claim`
}

/**
 * @summary Release (unclaim) a delivery job
 */
export const releaseDriverJob = async (orderId: number,
    releaseDriverJobBody?: ReleaseDriverJobBody, options?: RequestInit): Promise<DriverAssignment> => {

  return customFetch<DriverAssignment>(getReleaseDriverJobUrl(orderId),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(releaseDriverJobBody)
  }
);}




export const getReleaseDriverJobMutationOptions = <TError = ErrorType<ReleaseDriverJob409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releaseDriverJob>>, TError,{orderId: number;data?: BodyType<ReleaseDriverJobBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof releaseDriverJob>>, TError,{orderId: number;data?: BodyType<ReleaseDriverJobBody>}, TContext> => {

const mutationKey = ['releaseDriverJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof releaseDriverJob>>, {orderId: number;data?: BodyType<ReleaseDriverJobBody>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  releaseDriverJob(orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReleaseDriverJobMutationResult = NonNullable<Awaited<ReturnType<typeof releaseDriverJob>>>
    export type ReleaseDriverJobMutationBody = BodyType<ReleaseDriverJobBody> | undefined
    export type ReleaseDriverJobMutationError = ErrorType<ReleaseDriverJob409>

    /**
 * @summary Release (unclaim) a delivery job
 */
export const useReleaseDriverJob = <TError = ErrorType<ReleaseDriverJob409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releaseDriverJob>>, TError,{orderId: number;data?: BodyType<ReleaseDriverJobBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof releaseDriverJob>>,
        TError,
        {orderId: number;data?: BodyType<ReleaseDriverJobBody>},
        TContext
      > => {
      return useMutation(getReleaseDriverJobMutationOptions(options));
    }

export const getUpdateDriverLocationUrl = (orderId: number,) => {




  return `/api/drivers/jobs/${orderId}/location`
}

/**
 * @summary Update driver GPS coordinates for an active assignment
 */
export const updateDriverLocation = async (orderId: number,
    updateDriverLocationBody: UpdateDriverLocationBody, options?: RequestInit): Promise<UpdateDriverLocation200> => {

  return customFetch<UpdateDriverLocation200>(getUpdateDriverLocationUrl(orderId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDriverLocationBody)
  }
);}




export const getUpdateDriverLocationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDriverLocation>>, TError,{orderId: number;data: BodyType<UpdateDriverLocationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDriverLocation>>, TError,{orderId: number;data: BodyType<UpdateDriverLocationBody>}, TContext> => {

const mutationKey = ['updateDriverLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDriverLocation>>, {orderId: number;data: BodyType<UpdateDriverLocationBody>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  updateDriverLocation(orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDriverLocationMutationResult = NonNullable<Awaited<ReturnType<typeof updateDriverLocation>>>
    export type UpdateDriverLocationMutationBody = BodyType<UpdateDriverLocationBody>
    export type UpdateDriverLocationMutationError = ErrorType<unknown>

    /**
 * @summary Update driver GPS coordinates for an active assignment
 */
export const useUpdateDriverLocation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDriverLocation>>, TError,{orderId: number;data: BodyType<UpdateDriverLocationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDriverLocation>>,
        TError,
        {orderId: number;data: BodyType<UpdateDriverLocationBody>},
        TContext
      > => {
      return useMutation(getUpdateDriverLocationMutationOptions(options));
    }

export const getGetOrderDriverUrl = (orderId: number,) => {




  return `/api/orders/${orderId}/driver`
}

/**
 * @summary Get driver assignment details for an order
 */
export const getOrderDriver = async (orderId: number, options?: RequestInit): Promise<GetOrderDriver200> => {

  return customFetch<GetOrderDriver200>(getGetOrderDriverUrl(orderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderDriverQueryKey = (orderId: number,) => {
    return [
    `/api/orders/${orderId}/driver`
    ] as const;
    }


export const getGetOrderDriverQueryOptions = <TData = Awaited<ReturnType<typeof getOrderDriver>>, TError = ErrorType<unknown>>(orderId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderDriver>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderDriverQueryKey(orderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderDriver>>> = ({ signal }) => getOrderDriver(orderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderDriver>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderDriverQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderDriver>>>
export type GetOrderDriverQueryError = ErrorType<unknown>


/**
 * @summary Get driver assignment details for an order
 */

export function useGetOrderDriver<TData = Awaited<ReturnType<typeof getOrderDriver>>, TError = ErrorType<unknown>>(
 orderId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderDriver>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderDriverQueryOptions(orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDriverJobStatusUrl = (orderId: number,) => {




  return `/api/drivers/jobs/${orderId}/status`
}

/**
 * @summary Advance delivery status (picked_up or delivered)
 */
export const updateDriverJobStatus = async (orderId: number,
    updateDriverJobStatusBody: UpdateDriverJobStatusBody, options?: RequestInit): Promise<DriverAssignment> => {

  return customFetch<DriverAssignment>(getUpdateDriverJobStatusUrl(orderId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDriverJobStatusBody)
  }
);}




export const getUpdateDriverJobStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDriverJobStatus>>, TError,{orderId: number;data: BodyType<UpdateDriverJobStatusBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDriverJobStatus>>, TError,{orderId: number;data: BodyType<UpdateDriverJobStatusBody>}, TContext> => {

const mutationKey = ['updateDriverJobStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDriverJobStatus>>, {orderId: number;data: BodyType<UpdateDriverJobStatusBody>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  updateDriverJobStatus(orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDriverJobStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateDriverJobStatus>>>
    export type UpdateDriverJobStatusMutationBody = BodyType<UpdateDriverJobStatusBody>
    export type UpdateDriverJobStatusMutationError = ErrorType<unknown>

    /**
 * @summary Advance delivery status (picked_up or delivered)
 */
export const useUpdateDriverJobStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDriverJobStatus>>, TError,{orderId: number;data: BodyType<UpdateDriverJobStatusBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDriverJobStatus>>,
        TError,
        {orderId: number;data: BodyType<UpdateDriverJobStatusBody>},
        TContext
      > => {
      return useMutation(getUpdateDriverJobStatusMutationOptions(options));
    }

export const getListDriverMessagesUrl = (orderId: number,) => {




  return `/api/orders/${orderId}/driver-messages`
}

/**
 * @summary List driver messages for an order
 */
export const listDriverMessages = async (orderId: number, options?: RequestInit): Promise<ListDriverMessages200> => {

  return customFetch<ListDriverMessages200>(getListDriverMessagesUrl(orderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDriverMessagesQueryKey = (orderId: number,) => {
    return [
    `/api/orders/${orderId}/driver-messages`
    ] as const;
    }


export const getListDriverMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listDriverMessages>>, TError = ErrorType<unknown>>(orderId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDriverMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDriverMessagesQueryKey(orderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDriverMessages>>> = ({ signal }) => listDriverMessages(orderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDriverMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDriverMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listDriverMessages>>>
export type ListDriverMessagesQueryError = ErrorType<unknown>


/**
 * @summary List driver messages for an order
 */

export function useListDriverMessages<TData = Awaited<ReturnType<typeof listDriverMessages>>, TError = ErrorType<unknown>>(
 orderId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDriverMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDriverMessagesQueryOptions(orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendDriverMessageUrl = (orderId: number,) => {




  return `/api/orders/${orderId}/driver-messages`
}

/**
 * @summary Send a driver message for an order
 */
export const sendDriverMessage = async (orderId: number,
    sendDriverMessageBody: SendDriverMessageBody, options?: RequestInit): Promise<DriverMessage> => {

  return customFetch<DriverMessage>(getSendDriverMessageUrl(orderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendDriverMessageBody)
  }
);}




export const getSendDriverMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendDriverMessage>>, TError,{orderId: number;data: BodyType<SendDriverMessageBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendDriverMessage>>, TError,{orderId: number;data: BodyType<SendDriverMessageBody>}, TContext> => {

const mutationKey = ['sendDriverMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendDriverMessage>>, {orderId: number;data: BodyType<SendDriverMessageBody>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  sendDriverMessage(orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendDriverMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendDriverMessage>>>
    export type SendDriverMessageMutationBody = BodyType<SendDriverMessageBody>
    export type SendDriverMessageMutationError = ErrorType<unknown>

    /**
 * @summary Send a driver message for an order
 */
export const useSendDriverMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendDriverMessage>>, TError,{orderId: number;data: BodyType<SendDriverMessageBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendDriverMessage>>,
        TError,
        {orderId: number;data: BodyType<SendDriverMessageBody>},
        TContext
      > => {
      return useMutation(getSendDriverMessageMutationOptions(options));
    }

export const getListDriverApplicationsUrl = (params?: ListDriverApplicationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/driver-applications?${stringifiedParams}` : `/api/admin/driver-applications`
}

/**
 * @summary List driver applications (admin)
 */
export const listDriverApplications = async (params?: ListDriverApplicationsParams, options?: RequestInit): Promise<ListDriverApplications200> => {

  return customFetch<ListDriverApplications200>(getListDriverApplicationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDriverApplicationsQueryKey = (params?: ListDriverApplicationsParams,) => {
    return [
    `/api/admin/driver-applications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDriverApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof listDriverApplications>>, TError = ErrorType<unknown>>(params?: ListDriverApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDriverApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDriverApplicationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDriverApplications>>> = ({ signal }) => listDriverApplications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDriverApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDriverApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listDriverApplications>>>
export type ListDriverApplicationsQueryError = ErrorType<unknown>


/**
 * @summary List driver applications (admin)
 */

export function useListDriverApplications<TData = Awaited<ReturnType<typeof listDriverApplications>>, TError = ErrorType<unknown>>(
 params?: ListDriverApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDriverApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDriverApplicationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApproveDriverUrl = (userId: number,) => {




  return `/api/admin/drivers/${userId}/approve`
}

/**
 * @summary Approve a driver application (admin)
 */
export const approveDriver = async (userId: number, options?: RequestInit): Promise<DriverProfile> => {

  return customFetch<DriverProfile>(getApproveDriverUrl(userId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getApproveDriverMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDriver>>, TError,{userId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveDriver>>, TError,{userId: number}, TContext> => {

const mutationKey = ['approveDriver'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveDriver>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  approveDriver(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveDriverMutationResult = NonNullable<Awaited<ReturnType<typeof approveDriver>>>

    export type ApproveDriverMutationError = ErrorType<unknown>

    /**
 * @summary Approve a driver application (admin)
 */
export const useApproveDriver = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDriver>>, TError,{userId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveDriver>>,
        TError,
        {userId: number},
        TContext
      > => {
      return useMutation(getApproveDriverMutationOptions(options));
    }

export const getRejectDriverUrl = (userId: number,) => {




  return `/api/admin/drivers/${userId}/reject`
}

/**
 * @summary Reject a driver application (admin)
 */
export const rejectDriver = async (userId: number,
    rejectDriverBody?: RejectDriverBody, options?: RequestInit): Promise<DriverProfile> => {

  return customFetch<DriverProfile>(getRejectDriverUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rejectDriverBody)
  }
);}




export const getRejectDriverMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectDriver>>, TError,{userId: number;data?: BodyType<RejectDriverBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectDriver>>, TError,{userId: number;data?: BodyType<RejectDriverBody>}, TContext> => {

const mutationKey = ['rejectDriver'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectDriver>>, {userId: number;data?: BodyType<RejectDriverBody>}> = (props) => {
          const {userId,data} = props ?? {};

          return  rejectDriver(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectDriverMutationResult = NonNullable<Awaited<ReturnType<typeof rejectDriver>>>
    export type RejectDriverMutationBody = BodyType<RejectDriverBody> | undefined
    export type RejectDriverMutationError = ErrorType<unknown>

    /**
 * @summary Reject a driver application (admin)
 */
export const useRejectDriver = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectDriver>>, TError,{userId: number;data?: BodyType<RejectDriverBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectDriver>>,
        TError,
        {userId: number;data?: BodyType<RejectDriverBody>},
        TContext
      > => {
      return useMutation(getRejectDriverMutationOptions(options));
    }

export const getUpdateStoreDriverModeUrl = (id: number,) => {




  return `/api/order/stores/${id}/driver-mode`
}

/**
 * @summary Toggle hub driver mode for a store
 */
export const updateStoreDriverMode = async (id: number,
    updateStoreDriverModeBody: UpdateStoreDriverModeBody, options?: RequestInit): Promise<OrderStore> => {

  return customFetch<OrderStore>(getUpdateStoreDriverModeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateStoreDriverModeBody)
  }
);}




export const getUpdateStoreDriverModeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoreDriverMode>>, TError,{id: number;data: BodyType<UpdateStoreDriverModeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStoreDriverMode>>, TError,{id: number;data: BodyType<UpdateStoreDriverModeBody>}, TContext> => {

const mutationKey = ['updateStoreDriverMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStoreDriverMode>>, {id: number;data: BodyType<UpdateStoreDriverModeBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateStoreDriverMode(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoreDriverModeMutationResult = NonNullable<Awaited<ReturnType<typeof updateStoreDriverMode>>>
    export type UpdateStoreDriverModeMutationBody = BodyType<UpdateStoreDriverModeBody>
    export type UpdateStoreDriverModeMutationError = ErrorType<unknown>

    /**
 * @summary Toggle hub driver mode for a store
 */
export const useUpdateStoreDriverMode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoreDriverMode>>, TError,{id: number;data: BodyType<UpdateStoreDriverModeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateStoreDriverMode>>,
        TError,
        {id: number;data: BodyType<UpdateStoreDriverModeBody>},
        TContext
      > => {
      return useMutation(getUpdateStoreDriverModeMutationOptions(options));
    }

export const getAdminRefundOrderUrl = (orderId: number,) => {




  return `/api/admin/orders/${orderId}/refund`
}

/**
 * @summary Refund a card order with a stable request reference
 */
export const adminRefundOrder = async (orderId: number,
    adminRefundOrderBody: AdminRefundOrderBody, options?: RequestInit): Promise<AdminRefundOrder200 | AdminRefundOrder202> => {

  return customFetch<AdminRefundOrder200 | AdminRefundOrder202>(getAdminRefundOrderUrl(orderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminRefundOrderBody)
  }
);}




export const getAdminRefundOrderMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRefundOrder>>, TError,{orderId: number;data: BodyType<AdminRefundOrderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRefundOrder>>, TError,{orderId: number;data: BodyType<AdminRefundOrderBody>}, TContext> => {

const mutationKey = ['adminRefundOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRefundOrder>>, {orderId: number;data: BodyType<AdminRefundOrderBody>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  adminRefundOrder(orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRefundOrderMutationResult = NonNullable<Awaited<ReturnType<typeof adminRefundOrder>>>
    export type AdminRefundOrderMutationBody = BodyType<AdminRefundOrderBody>
    export type AdminRefundOrderMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Refund a card order with a stable request reference
 */
export const useAdminRefundOrder = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRefundOrder>>, TError,{orderId: number;data: BodyType<AdminRefundOrderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminRefundOrder>>,
        TError,
        {orderId: number;data: BodyType<AdminRefundOrderBody>},
        TContext
      > => {
      return useMutation(getAdminRefundOrderMutationOptions(options));
    }

